import React, { useState, useEffect } from "react"; // Added useEffect import
import {
    Box,
    Button,
    Container,
    Grid,
    // TextField, // Not used
    Typography,
    // MenuItem, // Not used
    IconButton,
    Breadcrumbs,
    Link,
    Divider,
    // Autocomplete, // Not used
    Avatar,
    Tooltip,
    Chip,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    // --- Added for Security Feature ---
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
    useTheme,
	 Stack// Added for the message in the modal
    // --- End Added ---
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// --- Added for Security Feature ---
import SecurityIcon from '@mui/icons-material/Security';
import PolicyIcon from '@mui/icons-material/Policy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// --- End Added ---
import { useNavigate, useParams } from "react-router-dom";
import queryGraphql from "../../helpers/ApiInterface";
import { useAuth } from "../../helpers/AuthProvider";
import moment from "moment";
import { ExpandMore } from "@mui/icons-material";
import { RiRestartLine } from "react-icons/ri";
import { RiCheckLine } from "react-icons/ri";
import { RiCloseLine } from "react-icons/ri";
import { RiHourglass2Line } from "react-icons/ri";
import MiniBot from "../MiniBot";
import MainDrawer, { openDrawerWidth, collapsedDrawerWidth } from "../MainDrawer"; // Adjust path if needed
const statusStyles = {
    Loading: {
        backgroundImage: 'linear-gradient(to left, rgba(24, 24, 24, 0), rgba(24, 24, 24, 0.1))',
        icon:<RiRestartLine/>,
        // Note: 'active' was included here. If 'active' clusters map to a specific 'Success' status from backend, it might be redundant here.
        // Keeping as per original code provided. Review if necessary.
        status: ['active', 'pending','rejected']
    },
    Success: {
        backgroundImage: 'linear-gradient(to left, rgba(18, 183, 106, 0), rgba(18, 183, 106, 0.1))',
        icon:<RiCheckLine/>,
        status: ['Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Cluster Created','Infra Audit Successful']
    },
    Error: {
        backgroundImage: 'linear-gradient(to left, rgba(240, 68, 56, 0), rgba(240, 68, 56, 0.1))',
        icon:<RiCloseLine/>,
        status: ['Plan Failed','Cluster Creation Failed','Infra Audit Failed'],
    },
    Pending: {
        backgroundImage: 'linear-gradient(to left, rgba(253, 176, 34, 0), rgba(253, 176, 34, 0.1))',
        icon:<RiHourglass2Line/>,
        status: ['MR Approval Pending'],
    },
};

// --- Added Interface for Checkov Summary ---
interface CheckovSummary {
    passed: number;
    failed: number;
}
// --- End Added ---

const ClusterDetailsPageContent: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    // Ensure id is treated as string | undefined initially
    const { id } = useParams<{ id: string }>();
    const [resourceStatus, setResourceStatus] = useState<any>({});
    const [cluster, setCluster] = useState<any>({});

    // --- State Added for Security Checks ---
    const [checkovSummary, setCheckovSummary] = useState<CheckovSummary | null>(null);
    const [kyvernoPolicyCount, setKyvernoPolicyCount] = useState<number | null>(null);
    const [isLoadingSecurityData, setIsLoadingSecurityData] = useState<boolean>(false);
    const [isSecurityModalOpen, setIsSecurityModalOpen] = useState<boolean>(false);
    // --- End Added ---

    // --- GraphQL Queries Added for Security Checks (Fetching ALL results) ---
    // WARNING: Fetching all results is inefficient. Modify backend for filtering if possible.
    const GET_CHECKOV_RESULTS_QUERY = `
        query GetCheckovResults {
            getCheckovResults {
                id
                resourceType # Needed for potential filtering
                resourceId   # IMPORTANT: Assume this holds the cluster ID for cluster-related checks
                summary {
                    passed
                    failed
                }
                # cluster { id clusterName } # Include if needed for filtering instead of resourceId
            }
        }
    `;

    const GET_KYVERNO_RESULTS_QUERY = `
        query GetKyvernoResults {
            getKyvernoResults {
                id
                resourceId   # IMPORTANT: Assume this holds the cluster ID for cluster-related policies
                resourceType # Needed for potential filtering
                policies {
                    name # Need at least one field to count
                }
                # cluster { id clusterName } # Include if needed for filtering instead of resourceId
            }
        }
    `;
    // --- End Added ---


    // --- Original useEffect for Cluster Data ---
    // Note: Dependency array is [], meaning it only runs once on mount.
    // If 'id' can change without remounting, this might fetch stale data. Consider adding '[id]' dependency.
    React.useEffect(() => {
        const fetchData = async () => {
            if (!id) return; // Add check for id validity
            try {
                const data = await queryGraphql(
                    `
                        query($clusterId: String!){
                        cluster(id:$clusterId) {
                        id,
                        clusterName,
                        clusterOwner{
                        id,
                        name,
                        googleProfilePicture
                        },
                        gcpProjectId,
                        environment,
                        region,
                        clusterSize,
                        clusterType,
                        gcpClusterViewers,
                        applicationRequesters,
                        costLabelPairs{
                        cost,
                        label
                        },
                        status,
                        createdAt,
                        actionedAt,
                        clusterNamePrefix,
                        vpcProjectId,
                        network,
                        nodeSubnet,
                        nodeSubnetRange,
                        secondaryPodRange,
                        secondaryServiceRange,
                        releaseChannel,
                        kubernetesVersion,
                        reasonForRejection,
                        applications{
                        id,
                        applicationName,
                        environment,
                        costLabelPairs{
                        cost,
                        label
                        },
                        status,
                        createdAt,
                        gcpApplicationViewers,
                        serviceRequesters,
                        applicationOwner{
                        id,
                        name,
                        email,
                        googleProfilePicture
                        }
                        services {
                            id,
                            serviceName
                        }

                        }
                        }
                        }
                    `,
                    { clusterId: id }
                );
                if (data.cluster) {
                    console.dir(data.cluster);
                    setCluster(data.cluster);
                }
            } catch (error) {
                console.error("Error fetching cluster data:", error); // Log specific error
            }
        };

        fetchData();
    }, []); // Original dependency array kept as requested
    // --- End Original useEffect ---


    // --- Original useEffect for Resource Status ---
    React.useEffect(()=>{
        const fetchData = async () =>{
            if (!id) return; // Add check for id validity
            try{
                const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
                    resourceStatus(id: $resourceStatusId) {
                        id
                        resourceId
                        resourceName
                        currentStatus
                        resourceType
                        resourceEnvironment
                        resourceOwner {
                        id
                        name
                        }
                        projectUrl
                        gcpClusterUrl
                        argoCdStaticUrl
                        subGroupProjectAppUrl
                        subGroupProjectInfraUrl
                        createdAt
                        updatedAt
                    }
                }`, {resourceStatusId: id});
                if(data.resourceStatus){
                    setResourceStatus(data.resourceStatus);
                }
            }
            catch(error){
                console.error("Error fetching resource status:", error); // Log specific error
            }
        };
        fetchData();
    },[id]); // Original dependency array kept as requested
    // --- End Original useEffect ---


    // --- Added useEffect to Fetch and Filter Security Data ---
    useEffect(() => {
        const fetchAndFilterSecurityData = async () => {
            // Ensure cluster ID is available and cluster is active before fetching
            if (!id || !cluster.id || cluster.status !== 'active') {
                setCheckovSummary(null);
                setKyvernoPolicyCount(null);
                setIsLoadingSecurityData(false); // Ensure loading is set to false if we don't fetch
                return;
            }

            setIsLoadingSecurityData(true);
            setCheckovSummary(null); // Reset before fetching/filtering
            setKyvernoPolicyCount(null); // Reset before fetching/filtering

            // console.log(`Workspaceing security data for cluster ID: ${id}`); // Debug log

            try {
                // Fetch ALL Checkov & Kyverno Results Concurrently
                // console.log("Fetching all Checkov and Kyverno results...");
                const [checkovData, kyvernoData] = await Promise.all([
                     queryGraphql(GET_CHECKOV_RESULTS_QUERY),
                     queryGraphql(GET_KYVERNO_RESULTS_QUERY)
                 ]);

                // Filter Checkov Results
                 if (checkovData?.getCheckovResults && Array.isArray(checkovData.getCheckovResults)) {
                    //  console.log(`Received ${checkovData.getCheckovResults.length} Checkov results. Filtering...`);
                    // IMPORTANT: Verify 'resourceId' is the correct field linking to the cluster 'id'
                    const clusterCheckovResult = checkovData.getCheckovResults.find(
                        (result: any) => result.resourceId === id // Adjust filter key if needed (e.g., result.cluster?.id)
                    );

                    if (clusterCheckovResult && clusterCheckovResult.summary) {
                        //  console.log("Found matching Checkov result:", clusterCheckovResult.summary);
                        setCheckovSummary(clusterCheckovResult.summary);
                    } else {
                        // console.log("No matching Checkov result found for this cluster.");
                        setCheckovSummary(null);
                    }
                } else {
                    //  console.log("No Checkov results received or data is not an array.");
                     setCheckovSummary(null);
                }

                // Filter Kyverno Results
                 if (kyvernoData?.getKyvernoResults && Array.isArray(kyvernoData.getKyvernoResults)) {
                    // console.log(`Received ${kyvernoData.getKyvernoResults.length} Kyverno results. Filtering...`);
                    // IMPORTANT: Verify 'resourceId' is the correct field linking to the cluster 'id'
                     const clusterKyvernoResult = kyvernoData.getKyvernoResults.find(
                         (result: any) => result.resourceId === id // Adjust filter key if needed (e.g., result.cluster?.id)
                     );

                    if (clusterKyvernoResult && clusterKyvernoResult.policies) {
                        // console.log(`Found matching Kyverno result with ${clusterKyvernoResult.policies.length} policies.`);
                        setKyvernoPolicyCount(clusterKyvernoResult.policies.length);
                    } else {
                        //  console.log("No matching Kyverno result found for this cluster.");
                         setKyvernoPolicyCount(null);
                    }
                } else {
                    console.log("No Kyverno results received or data is not an array.");
                    setKyvernoPolicyCount(null);
                }

            } catch (error) {
                console.error("Error fetching/filtering security data:", error);
                setCheckovSummary(null); // Ensure state is null on error
                setKyvernoPolicyCount(null);
            } finally {
                setIsLoadingSecurityData(false);
                 console.log("Finished fetching/filtering security data.");
            }
        };

        // Fetch only when cluster data is loaded and status is active
        fetchAndFilterSecurityData();

    }, [id, cluster.id, cluster.status]); // Depend on cluster data being loaded and id
    // --- End Added ---

    // --- Modal Handlers Added ---
    const handleOpenSecurityModal = () => setIsSecurityModalOpen(true);
    const handleCloseSecurityModal = () => setIsSecurityModalOpen(false);

    const handleNavigateToCheckov = () => {
        if (!id) return; // Should not happen if button is visible, but good practice
        // Pass clusterId to the Checkov page, potentially in state or params
        navigate(`/integrations/checkov-details`);
        handleCloseSecurityModal();
    };

    const handleNavigateToKyverno = () => {
        if (!id) return; // Should not happen if button is visible, but good practice
         // Pass clusterId to the Kyverno page
        navigate(`/integrations/kyverno-details`);
        handleCloseSecurityModal();
    };
    // --- End Added ---

    // --- Conditional Variables Added ---
    // Determine if the section should be shown (cluster active AND (checkov OR kyverno data exists for *this* cluster))
    const showSecuritySection = cluster?.status === 'active' && (checkovSummary !== null || kyvernoPolicyCount !== null);
    // Separate flag for the button, including loading state check
    const showSecurityButton = showSecuritySection && !isLoadingSecurityData;
    // --- End Added ---

     // --- Calculate Resource Status Background/Icon ---
     // (Moved from previous example, ensure it uses resourceStatus correctly)
    let currentResourceStyle = statusStyles.Loading; // Default or initial state
    if (resourceStatus.currentStatus) {
        if (statusStyles.Success.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Success;
        else if (statusStyles.Error.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Error;
        else if (statusStyles.Pending.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Pending;
        // Retain Loading style if no specific status matches or if cluster status itself implies loading
        else if (statusStyles.Loading.status.includes(cluster.status)) { // Check cluster status too if relevant
             currentResourceStyle = statusStyles.Loading;
        }
    } else if (statusStyles.Loading.status.includes(cluster.status)) {
        // Fallback to cluster status if resourceStatus is unavailable
         currentResourceStyle = statusStyles.Loading;
    }
    // ---

    return (
        <Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh",display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <MiniBot/>
            <Box sx={{ p: 2, bgcolor: "#fff",flexShrink: 0 }}>
                <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
                    <Link underline="hover" color="inherit" href="/clusters"> Clusters </Link>
                    <Typography color="text.primary">Cluster Details</Typography>
                </Breadcrumbs>
                <Box display="flex" alignItems="center" mt={1}>
                    <IconButton edge="start" aria-label="back" color="inherit" onClick={() => navigate("/clusters")}>
                        <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>
                    <Typography fontFamily="Gilroy-Bold" fontSize="18px"> Cluster Details </Typography>
                </Box>
            </Box>

             {/* Main Grid */}
            {cluster.id && (
                <Grid container sx={{ flexGrow: 1, overflow: 'hidden' }}>
                     {/* Left Panel (Cluster Details) */}
                    <Grid item xs={12} md={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}> {/* Adjusted grid size */}
                        <Box m={2} bgcolor="white" borderRadius="4px" sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
                            {/* Top Status Section */}
                             <Box
                                bgcolor={
                                    cluster.status === "active" ? "#12B76A10" :
                                    cluster.status === "rejected" ? "#F0443810" :
                                    "#FDB02210" // Default pending
                                }
                                p={3}
								sx={{ flexShrink: 0 }}
                            >
                                 {/* Name and Edit */}
                                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                    <Typography fontFamily="Gilroy-Bold" fontSize="20px" mr={1} sx={{ wordBreak: 'break-word' }}>
                                        {cluster.clusterName}
                                    </Typography>
                                    {cluster.status === "pending" && user.roles?.some((e: string) => ["cluster_owner"].includes(e)) && (
                                        <IconButton sx={{ p: 0.5 }} edge="end" aria-label="edit" color="inherit" onClick={() => navigate(`/clusters/edit/${cluster.id}`)}>
                                            <img width="20px" height="20px" src="/assets/edit-icon.svg" alt="Edit"/>
                                        </IconButton>
                                    )}
                                </Box>
                                 {/* Date and Status Indicator */}
                                <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                                    <Typography fontFamily="Gilroy-Regular" fontSize="12px">
                                        {cluster.createdAt ? moment(new Date(Number(cluster.createdAt))).format("DD/MM/YYYY | hh:mm A") : 'N/A'}
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <img
                                            src={ cluster.status === "active" ? "/assets/tickcircle.svg" : cluster.status === "rejected" ? "/assets/reject.svg" : "/assets/clock.svg" }
                                            alt="Status Icon" style={{ width: "14px", height: "14px", marginRight: "4px" }}
                                        />
                                        <Typography
                                            fontSize="12px" fontFamily="Gilroy-Regular"
                                            color={ cluster.status === "active" ? "#12B76A" : cluster.status === "rejected" ? "#F04438" : "#FDB022" }
                                            sx={{ textTransform: 'capitalize' }}
                                        >
                                            {cluster.status === "pending" ? "Pending Approval" : cluster.status}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            {/* Scrollable Details Area */}
                             <Box sx={{ flexGrow: 1, overflowY: "auto", p: 3 }}>

                                <Grid container spacing={2} > {/* Use spacing, adjust original gap={1} */}
                                    {/* --- Keep original details grid items --- */}
                                    <Grid item xs={6} > {/* Adjusted from 5.75 */}
                                        <Typography fontFamily="Gilroy-Regular" fontSize="12px"> Cloud Identifier </Typography>
                                        <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}> {cluster.gcpProjectId || 'N/A'} </Typography>
                                    </Grid>
                                    <Grid item xs={6} > {/* Adjusted from 5.75 */}
                                        <Typography fontFamily="Gilroy-Regular" fontSize="12px"> Cluster Owner </Typography>
                                        <Box display="flex" alignItems="center">
                                            <Avatar sx={{ height: "20px", width: "20px", mr: 0.5 }} src={cluster.clusterOwner?.googleProfilePicture} alt={cluster.clusterOwner?.name?.charAt(0)}/>
                                            <Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap> {cluster.clusterOwner?.name || 'N/A'} </Typography>
                                        </Box>
                                    </Grid>
                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Environment</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.environment || 'N/A'}</Typography></Grid>
                                    <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Region</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.region || 'N/A'}</Typography></Grid>
                                    <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Size</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterSize || 'N/A'}</Typography></Grid>
                                    <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Type</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterType || 'N/A'}</Typography></Grid>
                                    {/* Cluster Viewers */}
                                    <Grid item xs={12}>
                                        <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}> Cluster Viewers </Typography>
                                        <Box display="flex" flexWrap="wrap" gap={0.5}>
                                            {cluster.gcpClusterViewers?.length > 0 ? cluster.gcpClusterViewers.map((e: string, index: number) => (
                                                <Tooltip title={e} key={`viewer-${index}`}> 
												<Avatar sx={{ height: "24px", width: "24px"}} src={e} alt={e} /> 
												</Tooltip>
                                            )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
                                        </Box>
                                    </Grid>
                                    {/* Application Owners */}
                                     <Grid item xs={12}>
                                        <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}> Application Owners </Typography>
                                        <Box display="flex" flexWrap="wrap" gap={0.5}>
                                            {cluster.applicationRequesters?.length > 0 ? cluster.applicationRequesters.map((e: string, index: number) => (
                                                <Tooltip title={e} key={`appowner-${index}`}>
													 <Avatar sx={{ height: "24px", width: "24px" }} src={e} alt={e} /> 
											    </Tooltip>
                                            )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
                                        </Box>
                                    </Grid>
                                    {/* Tags/Label */}
                                    <Grid item xs={12}>
                                        <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}> Tags/Label </Typography>
                                         <Box display="flex" flexWrap="wrap" gap={0.75}>
                                            {cluster.costLabelPairs?.length > 0 ? cluster.costLabelPairs.map((e: any, index: number) => (
                                                 <Chip key={`tag-${index}`} size="small" sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }} label={`${e.cost} • ${e.label}`} />
                                            )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
                                        </Box>
                                    </Grid>
                                    {/* --- End original details --- */}
                                </Grid>

                                {/* Cloud Infra Details (Only Active) */}
                                {cluster.status === "active" && ( // Use strict equality
                                    <>
                                        <Divider sx={{ my: 3 }} /> {/* Adjusted margin */}
                                        <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={2}> {/* Added margin */}
                                            Cloud Infra Details
                                        </Typography>
                                        <Grid container spacing={2}> {/* Use spacing */}
                                            {/* --- Original Infra Grid Items --- */}
                                            <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Name Prefix</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterNamePrefix || 'N/A'}</Typography></Grid>
                                            <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">VPC Project ID</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}>{cluster.vpcProjectId || 'N/A'}</Typography></Grid>
                                            <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Network</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.network || 'N/A'}</Typography></Grid>
                                            {cluster.nodeSubnet && (<Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Node Subnet</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.nodeSubnet || 'N/A'}</Typography></Grid>)}
                                            {cluster.nodeSubnetRange && (<Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Master CIDR Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.nodeSubnetRange || 'N/A'}</Typography></Grid>)}
                                            <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Release Channel</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.releaseChannel || 'N/A'}</Typography></Grid>
                                            {cluster.secondaryPodRange && (<Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Secondary Pod Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.secondaryPodRange || 'N/A'}</Typography></Grid>)}
                                            {cluster.secondaryServiceRange && (<Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Secondary Service Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.secondaryServiceRange || 'N/A'}</Typography></Grid>)}
                                            <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Kubernetes Version</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.kubernetesVersion || 'N/A'}</Typography></Grid>
                                            {/* Infra URLs Tooltip */}
                                            <Grid item xs={12} sm={6}>
											<Typography fontFamily="Gilroy-Regular" fontSize="12px" >
												Infra URLs
										</Typography>
											<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
 											5
 											<Tooltip 
												sx={{ whiteSpace: "pre-line" }}
												// title={cluster.applications?.map(
												// 	(e: any, index: number) => `${e.applicationName}`
												// )}
												title={
													<>
													<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>

														List of Infra URLs
													</Typography>
														<br />
														{resourceStatus.resourceId === id && resourceStatus.gcpClusterUrl ? (
    <Link
        href={resourceStatus.gcpClusterUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
            Cluster URL
        </Typography>
    </Link>
) : (
    // If no link available (loading state), display the label as plain text
    <Typography fontFamily="Gilroy-Regular" fontSize="12px">
                    Cluster URL

    </Typography>
)}

														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
												Cluster URL
											</Typography>
											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
  												{resourceStatus.resourceId === id ? (
    												<Link href={resourceStatus.gcpClusterUrl} 
													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
													{`${resourceStatus.gcpClusterUrl.substring(0,10)}...`} 
													</Link>
  															) : (
   														<>Loading...</>
  																)}
													</Typography> */}

														<br/>
														{resourceStatus.resourceId === id && resourceStatus.projectUrl ? (
    <Link
        href={resourceStatus.projectUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
            Project URL
        </Typography>
    </Link>
) : (
    // If no link available (loading state), display the label as plain text
    <Typography fontFamily="Gilroy-Regular" fontSize="12px">
                    Project URL

    </Typography>
)}

														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
												Project URL
											</Typography>

											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
  												{resourceStatus.resourceId === id ? (
    												<Link href={resourceStatus.projectUrl} 
													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
													{`${resourceStatus.projectUrl.substring(0,10)}...`}
													
													 </Link>
  															) : (
   														<>Loading...</>
  																)}
													</Typography> */}

													<br/>
													{resourceStatus.resourceId === id && resourceStatus.argoCdStaticUrl ? (
    <Link
        href={resourceStatus.argoCdStaticUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
            ArgoCD URL
        </Typography>
    </Link>
) : (
    // If no link available (loading state), display the label as plain text
    <Typography fontFamily="Gilroy-Regular" fontSize="12px">
        ArgoCD URL
    </Typography>
)}
													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
												ArgoCD URL
											</Typography>
											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
  												{resourceStatus.resourceId === id ? (
    												<Link href={resourceStatus.argoCdStaticUrl} 
													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
													{`${resourceStatus.argoCdStaticUrl.substring(0,10)}...`} 
													
													</Link>
  															) : (
   														<>Loading...</>
  																)}
													</Typography> */}

													<br/>
													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectAppUrl ? (
    <Link
        href={resourceStatus.subGroupProjectAppUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
            Sub Group Project App URL
        </Typography>
    </Link>
) : (
    // If no link available (loading state), display the label as plain text
    <Typography fontFamily="Gilroy-Regular" fontSize="12px">
        Sub Group Project App URL
    </Typography>
)}
													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
												Sub Group Project App URL
											</Typography>
											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
  												{resourceStatus.resourceId === id ? (
    												<Link href={resourceStatus.subGroupProjectAppUrl} 
													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
													{`${resourceStatus.subGroupProjectAppUrl.substring(0,10)}...`} 
													</Link>

  															) : (
   														<>Loading...</>
  																)}
													</Typography> */}

													<br/>
													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectInfraUrl ? (
    <Link
        href={resourceStatus.subGroupProjectInfraUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
            Sub Group Project Infra URL
        </Typography>
    </Link>
) : (
    // If no link available (loading state), display the label as plain text
    <Typography fontFamily="Gilroy-Regular" fontSize="12px">
                    Sub Group Project Infra URL

    </Typography>
)}

													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
												Sub Group Project Infra URL
											</Typography>
											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
  												{resourceStatus.resourceId === id ? (

										<Link href={resourceStatus.subGroupProjectInfraUrl} 
											target="_blank" rel="noopener noreferrer" sx={{textDecoration: 'underline', color: '#FFFFFF' }}> 
											{`${resourceStatus.subGroupProjectInfraUrl.substring(0,10)}...`} 
										
											</Link>

  															) : (
   														<>Loading...</>
  																)}
													</Typography> */}


													</>
												}
												slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
											>
												<Avatar
													src="/assets/info.svg"
													alt="info"
													sx={{ height: 16, width: 16, marginLeft: "4px" }}
												/>
												
											</Tooltip>
 													</Typography>
                                                {/* <Typography fontFamily="Gilroy-Regular" fontSize="12px" > Infra URLs </Typography>
                                                <Box display="flex" alignItems="center">
                                                    <Typography fontFamily="Gilroy-SemiBold" fontSize={14}>
                                                        { [ resourceStatus.gcpClusterUrl, resourceStatus.projectUrl, resourceStatus.argoCdStaticUrl, resourceStatus.subGroupProjectAppUrl, resourceStatus.subGroupProjectInfraUrl ].filter(Boolean).length} URLs
                                                    </Typography>
                                                    <Tooltip
                                                        arrow
                                                        title={  <Box sx={{ p: 1 }}><Typography fontFamily="Gilroy-Bold" fontSize="14px" mb={1}>Infra URLs</Typography>{[ { label: "Cluster URL", url: resourceStatus.gcpClusterUrl }, { label: "Project URL", url: resourceStatus.projectUrl }, { label: "ArgoCD URL", url: resourceStatus.argoCdStaticUrl }, { label: "Sub Group App URL", url: resourceStatus.subGroupProjectAppUrl }, { label: "Sub Group Infra URL", url: resourceStatus.subGroupProjectInfraUrl } ].map((item, index) => ( item.url ? ( <Box key={index} mb={0.5}><Link href={item.url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: '#ADD8E6', display: 'block', fontSize: '12px' }}>{item.label}</Link></Box> ) : ( <Typography key={index} fontFamily="Gilroy-Regular" fontSize="12px" color="text.secondary" mb={0.5}>{item.label} (Not Available)</Typography> ) ))}</Box> }
                                                        slotProps={{ tooltip: { sx: { bgcolor: '#333333', color: '#FFFFFF', maxWidth: 350 } } }}
                                                    >
                                                        <IconButton size="small" sx={{ ml: 0.5 }}><img src="/assets/info.svg" alt="info" style={{ height: 16, width: 16 }}/></IconButton>
                                                    </Tooltip>
                                                </Box> */}
                                            </Grid>
											<Grid item xs={12} sm={6}>
                                                <Typography fontFamily="Gilroy-Regular" fontSize="12px" > Installed Plugins </Typography>
                                                <Box display="flex" alignItems="center">
													<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
													{ [ checkovSummary, kyvernoPolicyCount ].filter(Boolean).length}
 											<Tooltip 
												sx={{ whiteSpace: "pre-line" }}
												// title={cluster.applications?.map(
												// 	(e: any, index: number) => `${e.applicationName}`
												// )}
												title={
													<>
													<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>

														Installed Plugins
													</Typography>
														<br />
														{checkovSummary && (
															<Typography
															fontFamily="Gilroy-Regular"
															fontSize="12px"
															// Apply link color here if 'inherit' doesn't work as expected,
															// or if you want a specific link color different from default Typography.
															// For example: color: '#ADD8E6' (light blue)
														>
															Checkov
														</Typography>
														)}
														{checkovSummary && (
															
    <Link
        href="/integrations/checkov-details"
        
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
            Passed Checks:{checkovSummary.passed} | Failed Checks:{checkovSummary.failed}
        </Typography>
    </Link>
)}


														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
												Cluster URL
											</Typography>
											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
  												{resourceStatus.resourceId === id ? (
    												<Link href={resourceStatus.gcpClusterUrl} 
													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
													{`${resourceStatus.gcpClusterUrl.substring(0,10)}...`} 
													</Link>
  															) : (
   														<>Loading...</>
  																)}
													</Typography> */}

														<br/>
														{kyvernoPolicyCount && (
															<Typography
															fontFamily="Gilroy-Regular"
															fontSize="12px"
															// Apply link color here if 'inherit' doesn't work as expected,
															// or if you want a specific link color different from default Typography.
															// For example: color: '#ADD8E6' (light blue)
														>
															Kyverno
														</Typography>
														)}
														{kyvernoPolicyCount && (
															
    <Link
        href="/integrations/kyverno-details"
        
        sx={{
            textDecoration: 'underline', // Ensure underline for link appearance
            color: 'inherit' // Inherit color from Typography, or set explicitly if needed
        }}
    >
        <Typography
            fontFamily="Gilroy-Bold"
            fontSize="12px"
            // Apply link color here if 'inherit' doesn't work as expected,
            // or if you want a specific link color different from default Typography.
            // For example: color: '#ADD8E6' (light blue)
        >
           {kyvernoPolicyCount} Policies Applied
        </Typography>
    </Link>
) }
<br />
														


													</>
												}
												slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
											>
												
												<Avatar
													src="/assets/info.svg"
													alt="info"
													sx={{ height: 16, width: 16, marginLeft: "4px" }}
												/>
												
											</Tooltip>
 													</Typography>
                                                    
                                                </Box>
                                            </Grid>
                                            {/* --- End Original Infra --- */}
                                        </Grid>
                                    </>
                                )}
                            </Box> {/* End Scrollable Details Area */}

                             {/* Bottom Status Bar */}
                             {resourceStatus.currentStatus && (
                                 <Box
                                     sx={{
                                         p: 1.5,
                                         display:"flex", alignItems:"center", justifyContent: "flex-start",
                                         backgroundImage: currentResourceStyle.backgroundImage,
                                         borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px',
										 flexShrink: 0
                                     }}
                                 >
                                     <Box sx={{ display: "flex", alignItems: "center", fontSize: '20px', mr: 1 }}>
                                         {currentResourceStyle.icon}
                                     </Box>
                                     {!statusStyles.Loading.status.includes(resourceStatus.currentStatus) && (
                                            <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">
                                                {resourceStatus.currentStatus}
                                            </Typography>
                                        )}
                                 </Box>
                              )}
                             {/* End Status Bar */}
                        </Box>
                    </Grid> {/* End Left Panel */}

                    {/* Right Panel (Applications) */}
                    <Grid item xs={12} md={9} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}> {/* Adjusted grid size */}
                        <Box bgcolor="white" display="flex" flexDirection="column" m={2} borderRadius="8px" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            {/* Applications Header & Add Button */}
                             <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={2} sx={{ flexShrink: 0 }}>
                                <Typography fontFamily="Gilroy-SemiBold" fontSize="16px"> {`APPLICATIONS (${cluster.applications?.length || 0})`} </Typography>
                                 {/* Original Add App button logic (show only if active and user has role) */}
                                {cluster.status === 'active' && ( // Check status before showing button at all
                                     <Button
                                        sx={{ backgroundColor: "black", color: "white", fontFamily: "Gilroy-SemiBold", "&:hover": { backgroundColor: "#333" }, textTransform: "none", px: 2, py: 0.5 }}
                                         // Also check role and if app requesters are defined
                                        disabled={!user.roles?.some((e: string) => ["application_owner"].includes(e)) || !cluster.applicationRequesters || cluster.applicationRequesters.length === 0}
                                        variant="contained" size="medium"
                                        onClick={() => navigate("/applications/add", { state: { clusterId: cluster.id, clusterName: cluster.clusterName } })} // Pass cluster info if needed
                                    > Add New Application </Button>
                                )}
                            </Box>
                            <Divider sx={{ flexShrink: 0 }}/>
                            {/* Applications Content Area */}
                            <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
                                {/* --- Original Applications rendering logic --- */}
                                {/* Empty state for active clusters */}
                                {cluster.status === "active" && (!cluster.applications || cluster.applications?.length === 0) ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', p:3 }}>
                                        <img src="/assets/inbox-icon.svg" alt="No Applications" style={{ marginBottom: '16px', width: '80px' }} />
                                        <Typography gutterBottom fontFamily="Gilroy-Bold" fontSize="16px" textAlign="center"> No applications added yet </Typography>
                                        <Typography fontFamily="Gilroy-Regular" fontSize="14px" textAlign="center" color="text.secondary" mb={2} maxWidth="450px">
                                             Click the button above to add a new application, or ask an assigned application owner to add one.
                                        </Typography>
                                        {/* Add button is already in the header */}
                                    </Box>
                                ) : /* List for active clusters with apps */ cluster.status === "active" && cluster.applications?.length > 0 ? (
                                    <Box>
                                        {cluster.applications.map((application: any, index: number) => (
                                             <Accordion key={application.id || index} elevation={0} sx={{ borderRadius: "8px", mb: 2, "&:before": { display: "none" }, bgcolor: "white", border: "1px solid #eee" }}>
                                                <AccordionSummary expandIcon={<ExpandMore />}>
                                                     <Box>
                                                         <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">{application.applicationName}</Typography>
                                                         <Typography fontSize="12px" fontFamily="Gilroy-Regular" color="text.secondary"> Created: {application.createdAt ? moment(new Date(Number(application.createdAt))).format("DD/MM/YYYY | hh:mm A") : 'N/A'} </Typography>
                                                     </Box>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ pt: 0 }}>
                                                     <Divider sx={{ mb: 2 }}/>
                                                      <Grid container spacing={2}>
                                                          {/* App Details Grid Items */}
                                                          <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Name</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" noWrap>{cluster.clusterName}</Typography></Grid>
                                                        <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Environment</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{application.environment}</Typography></Grid>
                                                        <Grid item xs={12} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">App Owner</Typography><Box display="flex" alignItems="center"><Avatar sx={{ height: "20px", width: "20px", mr: 0.5 }} src={application.applicationOwner?.googleProfilePicture} alt={application.applicationOwner?.name?.charAt(0)} /><Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap>{application.applicationOwner?.name || 'N/A'}</Typography></Box></Grid>
                                                        <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>App Viewers</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{application.gcpApplicationViewers?.length > 0 ? application.gcpApplicationViewers.map((e: string, i: number) => <Tooltip title={e} key={`appviewer-${i}`}><Avatar sx={{ height: "20px", width: "20px" }} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
                                                        <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Service Owners</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{application.serviceRequesters?.length > 0 ? application.serviceRequesters.map((e: string, i: number) => <Tooltip title={e} key={`svcowner-${i}`}><Avatar sx={{ height: "20px", width: "20px" }} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
                                                        <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Tags/Label</Typography><Box display="flex" flexWrap="wrap" gap={0.75}>{application.costLabelPairs?.length > 0 ? application.costLabelPairs.map((e: any, i: number) => <Chip key={`apptag-${i}`} size="small" sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }} label={`${e.cost} • ${e.label}`} />) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
                                                        <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Micro-Services</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{`${application?.services?.length || 0}`}</Typography></Grid>
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </Box>
                                ) : /* Info state for non-active clusters */ (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', p: 3 }}>
                                        <img src="/assets/inbox-reject-icon.svg" alt="Application addition not allowed" style={{ marginBottom: '16px', width: '80px' }}/>
                                        <Typography gutterBottom fontFamily="Gilroy-Bold" fontSize="16px" textAlign="center"> Application addition not allowed </Typography>
                                        <Paper elevation={0} sx={{ bgcolor: cluster.status === "rejected" ? "#FEECEB" : "#FEFBE8", border: `1px solid ${cluster.status === "rejected" ? "#F04438" : "#FDB022"}`, display: "flex", alignItems: "center", p: 1.5, maxWidth: '500px' }}>
                                            <img src="/assets/info-circle.svg" alt="info" style={{ marginRight: '8px', width: '20px' }}/>
                                            <Typography fontFamily="Gilroy-Regular" fontSize="14px">
                                                {cluster.status === "rejected" ? "This cluster request was rejected..." : "This cluster is pending approval..."}
                                                {cluster.reasonForRejection && cluster.status === "rejected" && ( <Typography component="span" display="block" mt={1} fontSize="12px"> Reason: {cluster.reasonForRejection} </Typography> )}
                                           </Typography>
                                        </Paper>
                                    </Box>
                                )}
                                {/* --- End original rendering --- */}
                            </Box> {/* End Applications Content Area */}
                        </Box>
                    </Grid> {/* End Right Panel */}
                </Grid>
            )}
        </Container>
    );
};

//export default ClusterDetailsPage;


const ClusterDetailsPage: React.FC = () => {
    const theme = useTheme();

    const getInitialDrawerState = () => {
        if (typeof window !== 'undefined') {
            const storedState = localStorage.getItem('isFaradayDrawerOpen');
            return storedState !== null ? JSON.parse(storedState) : true;
        }
        return true;
    };
    const [isDrawerActuallyOpen, setIsDrawerActuallyOpen] = useState<boolean>(getInitialDrawerState);

    const handleDrawerStateChange = (isOpenFromDrawer: boolean) => {
        setIsDrawerActuallyOpen(isOpenFromDrawer);
    };

    // Using your remembered calculation for marginLeft
    const currentMarginLeft = isDrawerActuallyOpen ? openDrawerWidth - 248 : collapsedDrawerWidth - 70;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <MainDrawer
                // Assuming "integrations" is the correct index for Kyverno page
                // If Kyverno has its own top-level menu item, update this index.
                index={"clusters"} // Or a more specific index like "integrations-kyverno" if applicable
                onStateChange={handleDrawerStateChange}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    // bgcolor: '#fafafa', // bgcolor commented out as per your previous change
                    p: 0,
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    // Using your remembered unit and calculation for marginLeft
                    marginLeft: `${currentMarginLeft}vh`,
                }}
            >
                <ClusterDetailsPageContent />
            </Box>
        </Box>
    );
};

export default ClusterDetailsPage;
// import React, { useState, useEffect } from "react"; // Added useEffect import
// import {
//     Box,
//     Button,
//     Container,
//     Grid,
//     // TextField, // Not used
//     Typography,
//     // MenuItem, // Not used
//     IconButton,
//     Breadcrumbs,
//     Link,
//     Divider,
//     // Autocomplete, // Not used
//     Avatar,
//     Tooltip,
//     Chip,
//     Paper,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     // --- Added for Security Feature ---
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     CircularProgress,
//     List,
//     ListItemButton,
//     ListItemText,
//     ListItemIcon,
//     ListItem,
// 	 Stack// Added for the message in the modal
//     // --- End Added ---
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// // --- Added for Security Feature ---
// import SecurityIcon from '@mui/icons-material/Security';
// import PolicyIcon from '@mui/icons-material/Policy';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// // --- End Added ---
// import { useNavigate, useParams } from "react-router-dom";
// import queryGraphql from "../../helpers/ApiInterface";
// import { useAuth } from "../../helpers/AuthProvider";
// import moment from "moment";
// import { ExpandMore } from "@mui/icons-material";
// import { RiRestartLine } from "react-icons/ri";
// import { RiCheckLine } from "react-icons/ri";
// import { RiCloseLine } from "react-icons/ri";
// import { RiHourglass2Line } from "react-icons/ri";

// const statusStyles = {
//     Loading: {
//         backgroundImage: 'linear-gradient(to left, rgba(24, 24, 24, 0), rgba(24, 24, 24, 0.1))',
//         icon:<RiRestartLine/>,
//         // Note: 'active' was included here. If 'active' clusters map to a specific 'Success' status from backend, it might be redundant here.
//         // Keeping as per original code provided. Review if necessary.
//         status: ['active', 'pending','rejected']
//     },
//     Success: {
//         backgroundImage: 'linear-gradient(to left, rgba(18, 183, 106, 0), rgba(18, 183, 106, 0.1))',
//         icon:<RiCheckLine/>,
//         status: ['Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Cluster Created','Infra Audit Successful']
//     },
//     Error: {
//         backgroundImage: 'linear-gradient(to left, rgba(240, 68, 56, 0), rgba(240, 68, 56, 0.1))',
//         icon:<RiCloseLine/>,
//         status: ['Plan Failed','Cluster Creation Failed','Infra Audit Failed'],
//     },
//     Pending: {
//         backgroundImage: 'linear-gradient(to left, rgba(253, 176, 34, 0), rgba(253, 176, 34, 0.1))',
//         icon:<RiHourglass2Line/>,
//         status: ['MR Approval Pending'],
//     },
// };

// // --- Added Interface for Checkov Summary ---
// interface CheckovSummary {
//     passed: number;
//     failed: number;
// }
// // --- End Added ---

// const ClusterDetailsPage: React.FC = () => {
//     const navigate = useNavigate();
//     const { user } = useAuth();
//     // Ensure id is treated as string | undefined initially
//     const { id } = useParams<{ id: string }>();
//     const [resourceStatus, setResourceStatus] = useState<any>({});
//     const [cluster, setCluster] = useState<any>({});

//     // --- State Added for Security Checks ---
//     const [checkovSummary, setCheckovSummary] = useState<CheckovSummary | null>(null);
//     const [kyvernoPolicyCount, setKyvernoPolicyCount] = useState<number | null>(null);
//     const [isLoadingSecurityData, setIsLoadingSecurityData] = useState<boolean>(false);
//     const [isSecurityModalOpen, setIsSecurityModalOpen] = useState<boolean>(false);
//     // --- End Added ---

//     // --- GraphQL Queries Added for Security Checks (Fetching ALL results) ---
//     // WARNING: Fetching all results is inefficient. Modify backend for filtering if possible.
//     const GET_CHECKOV_RESULTS_QUERY = `
//         query GetCheckovResults {
//             getCheckovResults {
//                 id
//                 resourceType # Needed for potential filtering
//                 resourceId   # IMPORTANT: Assume this holds the cluster ID for cluster-related checks
//                 summary {
//                     passed
//                     failed
//                 }
//                 # cluster { id clusterName } # Include if needed for filtering instead of resourceId
//             }
//         }
//     `;

//     const GET_KYVERNO_RESULTS_QUERY = `
//         query GetKyvernoResults {
//             getKyvernoResults {
//                 id
//                 resourceId   # IMPORTANT: Assume this holds the cluster ID for cluster-related policies
//                 resourceType # Needed for potential filtering
//                 policies {
//                     name # Need at least one field to count
//                 }
//                 # cluster { id clusterName } # Include if needed for filtering instead of resourceId
//             }
//         }
//     `;
//     // --- End Added ---


//     // --- Original useEffect for Cluster Data ---
//     // Note: Dependency array is [], meaning it only runs once on mount.
//     // If 'id' can change without remounting, this might fetch stale data. Consider adding '[id]' dependency.
//     React.useEffect(() => {
//         const fetchData = async () => {
//             if (!id) return; // Add check for id validity
//             try {
//                 const data = await queryGraphql(
//                     `
//                         query($clusterId: String!){
//                         cluster(id:$clusterId) {
//                         id,
//                         clusterName,
//                         clusterOwner{
//                         id,
//                         name,
//                         googleProfilePicture
//                         },
//                         gcpProjectId,
//                         environment,
//                         region,
//                         clusterSize,
//                         clusterType,
//                         gcpClusterViewers,
//                         applicationRequesters,
//                         costLabelPairs{
//                         cost,
//                         label
//                         },
//                         status,
//                         createdAt,
//                         actionedAt,
//                         clusterNamePrefix,
//                         vpcProjectId,
//                         network,
//                         nodeSubnet,
//                         nodeSubnetRange,
//                         secondaryPodRange,
//                         secondaryServiceRange,
//                         releaseChannel,
//                         kubernetesVersion,
//                         reasonForRejection,
//                         applications{
//                         id,
//                         applicationName,
//                         environment,
//                         costLabelPairs{
//                         cost,
//                         label
//                         },
//                         status,
//                         createdAt,
//                         gcpApplicationViewers,
//                         serviceRequesters,
//                         applicationOwner{
//                         id,
//                         name,
//                         email,
//                         googleProfilePicture
//                         }
//                         services {
//                             id,
//                             serviceName
//                         }

//                         }
//                         }
//                         }
//                     `,
//                     { clusterId: id }
//                 );
//                 if (data.cluster) {
//                     console.dir(data.cluster);
//                     setCluster(data.cluster);
//                 }
//             } catch (error) {
//                 console.error("Error fetching cluster data:", error); // Log specific error
//             }
//         };

//         fetchData();
//     }, []); // Original dependency array kept as requested
//     // --- End Original useEffect ---


//     // --- Original useEffect for Resource Status ---
//     React.useEffect(()=>{
//         const fetchData = async () =>{
//             if (!id) return; // Add check for id validity
//             try{
//                 const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
//                     resourceStatus(id: $resourceStatusId) {
//                         id
//                         resourceId
//                         resourceName
//                         currentStatus
//                         resourceType
//                         resourceEnvironment
//                         resourceOwner {
//                         id
//                         name
//                         }
//                         projectUrl
//                         gcpClusterUrl
//                         argoCdStaticUrl
//                         subGroupProjectAppUrl
//                         subGroupProjectInfraUrl
//                         createdAt
//                         updatedAt
//                     }
//                 }`, {resourceStatusId: id});
//                 if(data.resourceStatus){
//                     setResourceStatus(data.resourceStatus);
//                 }
//             }
//             catch(error){
//                 console.error("Error fetching resource status:", error); // Log specific error
//             }
//         };
//         fetchData();
//     },[id]); // Original dependency array kept as requested
//     // --- End Original useEffect ---


//     // --- Added useEffect to Fetch and Filter Security Data ---
//     useEffect(() => {
//         const fetchAndFilterSecurityData = async () => {
//             // Ensure cluster ID is available and cluster is active before fetching
//             if (!id || !cluster.id || cluster.status !== 'active') {
//                 setCheckovSummary(null);
//                 setKyvernoPolicyCount(null);
//                 setIsLoadingSecurityData(false); // Ensure loading is set to false if we don't fetch
//                 return;
//             }

//             setIsLoadingSecurityData(true);
//             setCheckovSummary(null); // Reset before fetching/filtering
//             setKyvernoPolicyCount(null); // Reset before fetching/filtering

//             console.log(`Workspaceing security data for cluster ID: ${id}`); // Debug log

//             try {
//                 // Fetch ALL Checkov & Kyverno Results Concurrently
//                 console.log("Fetching all Checkov and Kyverno results...");
//                 const [checkovData, kyvernoData] = await Promise.all([
//                      queryGraphql(GET_CHECKOV_RESULTS_QUERY),
//                      queryGraphql(GET_KYVERNO_RESULTS_QUERY)
//                  ]);

//                 // Filter Checkov Results
//                  if (checkovData?.getCheckovResults && Array.isArray(checkovData.getCheckovResults)) {
//                      console.log(`Received ${checkovData.getCheckovResults.length} Checkov results. Filtering...`);
//                     // IMPORTANT: Verify 'resourceId' is the correct field linking to the cluster 'id'
//                     const clusterCheckovResult = checkovData.getCheckovResults.find(
//                         (result: any) => result.resourceId === id // Adjust filter key if needed (e.g., result.cluster?.id)
//                     );

//                     if (clusterCheckovResult && clusterCheckovResult.summary) {
//                          console.log("Found matching Checkov result:", clusterCheckovResult.summary);
//                         setCheckovSummary(clusterCheckovResult.summary);
//                     } else {
//                         console.log("No matching Checkov result found for this cluster.");
//                         setCheckovSummary(null);
//                     }
//                 } else {
//                      console.log("No Checkov results received or data is not an array.");
//                      setCheckovSummary(null);
//                 }

//                 // Filter Kyverno Results
//                  if (kyvernoData?.getKyvernoResults && Array.isArray(kyvernoData.getKyvernoResults)) {
//                     console.log(`Received ${kyvernoData.getKyvernoResults.length} Kyverno results. Filtering...`);
//                     // IMPORTANT: Verify 'resourceId' is the correct field linking to the cluster 'id'
//                      const clusterKyvernoResult = kyvernoData.getKyvernoResults.find(
//                          (result: any) => result.resourceId === id // Adjust filter key if needed (e.g., result.cluster?.id)
//                      );

//                     if (clusterKyvernoResult && clusterKyvernoResult.policies) {
//                         console.log(`Found matching Kyverno result with ${clusterKyvernoResult.policies.length} policies.`);
//                         setKyvernoPolicyCount(clusterKyvernoResult.policies.length);
//                     } else {
//                          console.log("No matching Kyverno result found for this cluster.");
//                          setKyvernoPolicyCount(null);
//                     }
//                 } else {
//                     console.log("No Kyverno results received or data is not an array.");
//                     setKyvernoPolicyCount(null);
//                 }

//             } catch (error) {
//                 console.error("Error fetching/filtering security data:", error);
//                 setCheckovSummary(null); // Ensure state is null on error
//                 setKyvernoPolicyCount(null);
//             } finally {
//                 setIsLoadingSecurityData(false);
//                  console.log("Finished fetching/filtering security data.");
//             }
//         };

//         // Fetch only when cluster data is loaded and status is active
//         fetchAndFilterSecurityData();

//     }, [id, cluster.id, cluster.status]); // Depend on cluster data being loaded and id
//     // --- End Added ---

//     // --- Modal Handlers Added ---
//     const handleOpenSecurityModal = () => setIsSecurityModalOpen(true);
//     const handleCloseSecurityModal = () => setIsSecurityModalOpen(false);

//     const handleNavigateToCheckov = () => {
//         if (!id) return; // Should not happen if button is visible, but good practice
//         // Pass clusterId to the Checkov page, potentially in state or params
//         navigate(`/integrations/checkov-details`);
//         handleCloseSecurityModal();
//     };

//     const handleNavigateToKyverno = () => {
//         if (!id) return; // Should not happen if button is visible, but good practice
//          // Pass clusterId to the Kyverno page
//         navigate(`/integrations/kyverno-details`);
//         handleCloseSecurityModal();
//     };
//     // --- End Added ---

//     // --- Conditional Variables Added ---
//     // Determine if the section should be shown (cluster active AND (checkov OR kyverno data exists for *this* cluster))
//     const showSecuritySection = cluster?.status === 'active' && (checkovSummary !== null || kyvernoPolicyCount !== null);
//     // Separate flag for the button, including loading state check
//     const showSecurityButton = showSecuritySection && !isLoadingSecurityData;
//     // --- End Added ---

//      // --- Calculate Resource Status Background/Icon ---
//      // (Moved from previous example, ensure it uses resourceStatus correctly)
//     let currentResourceStyle = statusStyles.Loading; // Default or initial state
//     if (resourceStatus.currentStatus) {
//         if (statusStyles.Success.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Success;
//         else if (statusStyles.Error.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Error;
//         else if (statusStyles.Pending.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Pending;
//         // Retain Loading style if no specific status matches or if cluster status itself implies loading
//         else if (statusStyles.Loading.status.includes(cluster.status)) { // Check cluster status too if relevant
//              currentResourceStyle = statusStyles.Loading;
//         }
//     } else if (statusStyles.Loading.status.includes(cluster.status)) {
//         // Fallback to cluster status if resourceStatus is unavailable
//          currentResourceStyle = statusStyles.Loading;
//     }
//     // ---

//     return (
//         <Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh",display: 'flex', flexDirection: 'column' }}>
//             {/* Header */}
//             <Box sx={{ p: 2, bgcolor: "#fff",flexShrink: 0 }}>
//                 <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
//                     <Link underline="hover" color="inherit" href="/clusters"> Clusters </Link>
//                     <Typography color="text.primary">Cluster Details</Typography>
//                 </Breadcrumbs>
//                 <Box display="flex" alignItems="center" mt={1}>
//                     <IconButton edge="start" aria-label="back" color="inherit" onClick={() => navigate("/clusters")}>
//                         <ArrowBackIosNewIcon fontSize="small" />
//                     </IconButton>
//                     <Typography fontFamily="Gilroy-Bold" fontSize="18px"> Cluster Details </Typography>
//                 </Box>
//             </Box>

//              {/* Main Grid */}
//             {cluster.id && (
//                 <Grid container sx={{ flexGrow: 1, overflow: 'hidden' }}>
//                      {/* Left Panel (Cluster Details) */}
//                     <Grid item xs={12} md={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}> {/* Adjusted grid size */}
//                         <Box m={2} bgcolor="white" borderRadius="4px" sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
//                             {/* Top Status Section */}
//                              <Box
//                                 bgcolor={
//                                     cluster.status === "active" ? "#12B76A10" :
//                                     cluster.status === "rejected" ? "#F0443810" :
//                                     "#FDB02210" // Default pending
//                                 }
//                                 p={3}
// 								sx={{ flexShrink: 0 }}
//                             >
//                                  {/* Name and Edit */}
//                                 <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                                     <Typography fontFamily="Gilroy-Bold" fontSize="20px" mr={1} sx={{ wordBreak: 'break-word' }}>
//                                         {cluster.clusterName}
//                                     </Typography>
//                                     {cluster.status === "pending" && user.roles?.some((e: string) => ["cluster_owner"].includes(e)) && (
//                                         <IconButton sx={{ p: 0.5 }} edge="end" aria-label="edit" color="inherit" onClick={() => navigate(`/clusters/edit/${cluster.id}`)}>
//                                             <img width="20px" height="20px" src="/assets/edit-icon.svg" alt="Edit"/>
//                                         </IconButton>
//                                     )}
//                                 </Box>
//                                  {/* Date and Status Indicator */}
//                                 <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
//                                     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                         {cluster.createdAt ? moment(new Date(Number(cluster.createdAt))).format("DD/MM/YYYY | hh:mm A") : 'N/A'}
//                                     </Typography>
//                                     <Box sx={{ display: "flex", alignItems: "center" }}>
//                                         <img
//                                             src={ cluster.status === "active" ? "/assets/tickcircle.svg" : cluster.status === "rejected" ? "/assets/reject.svg" : "/assets/clock.svg" }
//                                             alt="Status Icon" style={{ width: "14px", height: "14px", marginRight: "4px" }}
//                                         />
//                                         <Typography
//                                             fontSize="12px" fontFamily="Gilroy-Regular"
//                                             color={ cluster.status === "active" ? "#12B76A" : cluster.status === "rejected" ? "#F04438" : "#FDB022" }
//                                             sx={{ textTransform: 'capitalize' }}
//                                         >
//                                             {cluster.status === "pending" ? "Pending Approval" : cluster.status}
//                                         </Typography>
//                                     </Box>
//                                 </Box>
//                             </Box>

//                             {/* Scrollable Details Area */}
//                              <Box sx={{ flexGrow: 1, overflowY: "auto", p: 3 }}>

//                                 <Grid container spacing={2} > {/* Use spacing, adjust original gap={1} */}
//                                     {/* --- Keep original details grid items --- */}
//                                     <Grid item xs={6} > {/* Adjusted from 5.75 */}
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px"> GCP Project ID </Typography>
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}> {cluster.gcpProjectId || 'N/A'} </Typography>
//                                     </Grid>
//                                     <Grid item xs={6} > {/* Adjusted from 5.75 */}
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px"> Cluster Owner </Typography>
//                                         <Box display="flex" alignItems="center">
//                                             <Avatar sx={{ height: "20px", width: "20px", mr: 0.5 }} src={cluster.clusterOwner?.googleProfilePicture} alt={cluster.clusterOwner?.name?.charAt(0)}/>
//                                             <Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap> {cluster.clusterOwner?.name || 'N/A'} </Typography>
//                                         </Box>
//                                     </Grid>
//                                      <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Environment</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.environment || 'N/A'}</Typography></Grid>
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Region</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.region || 'N/A'}</Typography></Grid>
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Size</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterSize || 'N/A'}</Typography></Grid>
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Type</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterType || 'N/A'}</Typography></Grid>
//                                     {/* Cluster Viewers */}
//                                     <Grid item xs={12}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}> Cluster Viewers </Typography>
//                                         <Box display="flex" flexWrap="wrap" gap={0.5}>
//                                             {cluster.gcpClusterViewers?.length > 0 ? cluster.gcpClusterViewers.map((e: string, index: number) => (
//                                                 <Tooltip title={e} key={`viewer-${index}`}> 
// 												<Avatar sx={{ height: "24px", width: "24px"}} src={e} alt={e} /> 
// 												</Tooltip>
//                                             )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                         </Box>
//                                     </Grid>
//                                     {/* Application Owners */}
//                                      <Grid item xs={12}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}> Application Owners </Typography>
//                                         <Box display="flex" flexWrap="wrap" gap={0.5}>
//                                             {cluster.applicationRequesters?.length > 0 ? cluster.applicationRequesters.map((e: string, index: number) => (
//                                                 <Tooltip title={e} key={`appowner-${index}`}>
// 													 <Avatar sx={{ height: "24px", width: "24px" }} src={e} alt={e} /> 
// 											    </Tooltip>
//                                             )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                         </Box>
//                                     </Grid>
//                                     {/* Tags/Label */}
//                                     <Grid item xs={12}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}> Tags/Label </Typography>
//                                          <Box display="flex" flexWrap="wrap" gap={0.75}>
//                                             {cluster.costLabelPairs?.length > 0 ? cluster.costLabelPairs.map((e: any, index: number) => (
//                                                  <Chip key={`tag-${index}`} size="small" sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }} label={`${e.cost} • ${e.label}`} />
//                                             )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                         </Box>
//                                     </Grid>
//                                     {/* --- End original details --- */}
//                                 </Grid>

//                                 {/* Cloud Infra Details (Only Active) */}
//                                 {cluster.status === "active" && ( // Use strict equality
//                                     <>
//                                         <Divider sx={{ my: 3 }} /> {/* Adjusted margin */}
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={2}> {/* Added margin */}
//                                             Cloud Infra Details
//                                         </Typography>
//                                         <Grid container spacing={2}> {/* Use spacing */}
//                                             {/* --- Original Infra Grid Items --- */}
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Name Prefix</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterNamePrefix || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">VPC Project ID</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}>{cluster.vpcProjectId || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Network</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.network || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Node Subnet</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.nodeSubnet || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Master CIDR Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.nodeSubnetRange || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Release Channel</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.releaseChannel || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Secondary Pod Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.secondaryPodRange || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Secondary Service Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.secondaryServiceRange || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Kubernetes Version</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.kubernetesVersion || 'N/A'}</Typography></Grid>
//                                             {/* Infra URLs Tooltip */}
//                                             <Grid item xs={12} sm={6}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px" >
// 												Infra URLs
// 										</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
//  											5
//  											<Tooltip 
// 												sx={{ whiteSpace: "pre-line" }}
// 												// title={cluster.applications?.map(
// 												// 	(e: any, index: number) => `${e.applicationName}`
// 												// )}
// 												title={
// 													<>
// 													<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>

// 														List of Infra URLs
// 													</Typography>
// 														<br />
// 														{resourceStatus.resourceId === id && resourceStatus.gcpClusterUrl ? (
//     <Link
//         href={resourceStatus.gcpClusterUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Cluster URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Cluster URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.gcpClusterUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.gcpClusterUrl.substring(0,10)}...`} 
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 														<br/>
// 														{resourceStatus.resourceId === id && resourceStatus.projectUrl ? (
//     <Link
//         href={resourceStatus.projectUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Project URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Project URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Project URL
// 											</Typography>

// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.projectUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.projectUrl.substring(0,10)}...`}
													
// 													 </Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.argoCdStaticUrl ? (
//     <Link
//         href={resourceStatus.argoCdStaticUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             ArgoCD URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         ArgoCD URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												ArgoCD URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.argoCdStaticUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.argoCdStaticUrl.substring(0,10)}...`} 
													
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectAppUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectAppUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project App URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         Sub Group Project App URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project App URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.subGroupProjectAppUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.subGroupProjectAppUrl.substring(0,10)}...`} 
// 													</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectInfraUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectInfraUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project Infra URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Sub Group Project Infra URL

//     </Typography>
// )}

// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project Infra URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (

// 										<Link href={resourceStatus.subGroupProjectInfraUrl} 
// 											target="_blank" rel="noopener noreferrer" sx={{textDecoration: 'underline', color: '#FFFFFF' }}> 
// 											{`${resourceStatus.subGroupProjectInfraUrl.substring(0,10)}...`} 
										
// 											</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}


// 													</>
// 												}
// 												slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
// 											>
// 												<Avatar
// 													src="/assets/info.svg"
// 													alt="info"
// 													sx={{ height: 16, width: 16, marginLeft: "4px" }}
// 												/>
												
// 											</Tooltip>
//  													</Typography>
//                                                 {/* <Typography fontFamily="Gilroy-Regular" fontSize="12px" > Infra URLs </Typography>
//                                                 <Box display="flex" alignItems="center">
//                                                     <Typography fontFamily="Gilroy-SemiBold" fontSize={14}>
//                                                         { [ resourceStatus.gcpClusterUrl, resourceStatus.projectUrl, resourceStatus.argoCdStaticUrl, resourceStatus.subGroupProjectAppUrl, resourceStatus.subGroupProjectInfraUrl ].filter(Boolean).length} URLs
//                                                     </Typography>
//                                                     <Tooltip
//                                                         arrow
//                                                         title={  <Box sx={{ p: 1 }}><Typography fontFamily="Gilroy-Bold" fontSize="14px" mb={1}>Infra URLs</Typography>{[ { label: "Cluster URL", url: resourceStatus.gcpClusterUrl }, { label: "Project URL", url: resourceStatus.projectUrl }, { label: "ArgoCD URL", url: resourceStatus.argoCdStaticUrl }, { label: "Sub Group App URL", url: resourceStatus.subGroupProjectAppUrl }, { label: "Sub Group Infra URL", url: resourceStatus.subGroupProjectInfraUrl } ].map((item, index) => ( item.url ? ( <Box key={index} mb={0.5}><Link href={item.url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: '#ADD8E6', display: 'block', fontSize: '12px' }}>{item.label}</Link></Box> ) : ( <Typography key={index} fontFamily="Gilroy-Regular" fontSize="12px" color="text.secondary" mb={0.5}>{item.label} (Not Available)</Typography> ) ))}</Box> }
//                                                         slotProps={{ tooltip: { sx: { bgcolor: '#333333', color: '#FFFFFF', maxWidth: 350 } } }}
//                                                     >
//                                                         <IconButton size="small" sx={{ ml: 0.5 }}><img src="/assets/info.svg" alt="info" style={{ height: 16, width: 16 }}/></IconButton>
//                                                     </Tooltip>
//                                                 </Box> */}
//                                             </Grid>
// 											<Grid item xs={12} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px" > Installed Plugins </Typography>
//                                                 <Box display="flex" alignItems="center">
// 													<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
// 													{ [ checkovSummary, kyvernoPolicyCount ].filter(Boolean).length}
//  											<Tooltip 
// 												sx={{ whiteSpace: "pre-line" }}
// 												// title={cluster.applications?.map(
// 												// 	(e: any, index: number) => `${e.applicationName}`
// 												// )}
// 												title={
// 													<>
// 													<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>

// 														Installed Plugins
// 													</Typography>
// 														<br />
// 														{checkovSummary && (
// 															<Typography
// 															fontFamily="Gilroy-Regular"
// 															fontSize="12px"
// 															// Apply link color here if 'inherit' doesn't work as expected,
// 															// or if you want a specific link color different from default Typography.
// 															// For example: color: '#ADD8E6' (light blue)
// 														>
// 															Checkov
// 														</Typography>
// 														)}
// 														{checkovSummary && (
															
//     <Link
//         href="/integrations/checkov-details"
        
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Passed Checks:{checkovSummary.passed} | Failed Checks:{checkovSummary.failed}
//         </Typography>
//     </Link>
// )}


// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.gcpClusterUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.gcpClusterUrl.substring(0,10)}...`} 
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 														<br/>
// 														{kyvernoPolicyCount && (
// 															<Typography
// 															fontFamily="Gilroy-Regular"
// 															fontSize="12px"
// 															// Apply link color here if 'inherit' doesn't work as expected,
// 															// or if you want a specific link color different from default Typography.
// 															// For example: color: '#ADD8E6' (light blue)
// 														>
// 															Kyverno
// 														</Typography>
// 														)}
// 														{kyvernoPolicyCount && (
															
//     <Link
//         href="/integrations/kyverno-details"
        
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//            {kyvernoPolicyCount} Policies Applied
//         </Typography>
//     </Link>
// ) }
// <br />
// 														{resourceStatus.resourceId === id && resourceStatus.projectUrl ? (
//     <Link
//         href={resourceStatus.projectUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Project URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Project URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Project URL
// 											</Typography>

// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.projectUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.projectUrl.substring(0,10)}...`}
													
// 													 </Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.argoCdStaticUrl ? (
//     <Link
//         href={resourceStatus.argoCdStaticUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             ArgoCD URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         ArgoCD URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												ArgoCD URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.argoCdStaticUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.argoCdStaticUrl.substring(0,10)}...`} 
													
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectAppUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectAppUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project App URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         Sub Group Project App URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project App URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.subGroupProjectAppUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.subGroupProjectAppUrl.substring(0,10)}...`} 
// 													</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectInfraUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectInfraUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project Infra URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Sub Group Project Infra URL

//     </Typography>
// )}

// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project Infra URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (

// 										<Link href={resourceStatus.subGroupProjectInfraUrl} 
// 											target="_blank" rel="noopener noreferrer" sx={{textDecoration: 'underline', color: '#FFFFFF' }}> 
// 											{`${resourceStatus.subGroupProjectInfraUrl.substring(0,10)}...`} 
										
// 											</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}


// 													</>
// 												}
// 												slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
// 											>
// 												<Avatar
// 													src="/assets/info.svg"
// 													alt="info"
// 													sx={{ height: 16, width: 16, marginLeft: "4px" }}
// 												/>
												
// 											</Tooltip>
//  													</Typography>
                                                    
//                                                 </Box>
//                                             </Grid>
//                                             {/* --- End Original Infra --- */}
//                                         </Grid>

//                                         {/* --- Security & Compliance Section Added Here ---
//                                          {/* Show section title only if loading or if data exists */}
                                         
//                                             <>
//                                                 <Divider sx={{ my: 3 }} />
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={1}>
//                                                     Security & Compliance
//                                                 </Typography>
//                                             </>
                                        
//                                         {/* Loading Indicator */}
//                                         {isLoadingSecurityData && cluster.status === 'active' && (
//                                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
//                                                 <CircularProgress size={20} />
//                                                 <Typography fontSize="12px" color="text.secondary">Loading security status...</Typography>
//                                             </Box>
//                                         )}
//                                         {/* Security Button */}
//                                         {showSecurityButton && ( // Button shown only when loading is false AND data exists
//                                             <Box sx={{  textAlign: "left" }}>
// 																			<Button
// 																				type="submit"
// 																				sx={{ /* Your Button Styles */ backgroundColor: "black", color: "white", fontFamily: "Gilroy-SemiBold", fontSize: "14px", borderRadius: "8px", textTransform: "none", px: 2, transition: 'background-color 0.3s ease', '&:hover': { backgroundColor: "dimgray" }, '&:disabled': { backgroundColor: 'rgba(0, 0, 0, 0.12)', color: 'rgba(0, 0, 0, 0.26)', cursor: 'not-allowed' }, }}
// 																				variant="contained" size="small"
// 																				onClick={handleOpenSecurityModal}
// 																			>  Explore Security Checks</Button>
// 																		</Box>
// 											// <Button
//                                             //     variant="outlined"
//                                             //     size="small"
//                                             //     startIcon={<SecurityIcon />}
//                                             //     onClick={handleOpenSecurityModal}
//                                             //     sx={{ textTransform: 'none', mb: 2 }}
//                                             // >
//                                             //     View Security Checks
//                                             // </Button>
//                                         )}
//                                          {/* No Data Message */}
//                                         {!isLoadingSecurityData && cluster.status === 'active' && !showSecuritySection && ( // Show message only if not loading, cluster active, and no data found
//                                              <Typography fontSize="12px" color="text.secondary" sx={{ mb: 2 }}>
//                                                 No security scan results found for this cluster.
//                                              </Typography>
//                                         )} 
//                                          {/* --- End Security Section Add --- */}
//                                     </>
//                                 )}
//                             </Box> {/* End Scrollable Details Area */}

//                              {/* Bottom Status Bar */}
//                              {resourceStatus.currentStatus && (
//                                  <Box
//                                      sx={{
//                                          p: 1.5,
//                                          display:"flex", alignItems:"center", justifyContent: "flex-start",
//                                          backgroundImage: currentResourceStyle.backgroundImage,
//                                          borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px',
// 										 flexShrink: 0
//                                      }}
//                                  >
//                                      <Box sx={{ display: "flex", alignItems: "center", fontSize: '20px', mr: 1 }}>
//                                          {currentResourceStyle.icon}
//                                      </Box>
//                                      {/* <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">
//                                          {statusStyles.Loading.status.includes(resourceStatus.currentStatus) ? "Processing..." : resourceStatus.currentStatus}
//                                      </Typography> */}
//                                  </Box>
//                               )}
//                              {/* End Status Bar */}
//                         </Box>
//                     </Grid> {/* End Left Panel */}

//                     {/* Right Panel (Applications) */}
//                     <Grid item xs={12} md={9} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}> {/* Adjusted grid size */}
//                         <Box bgcolor="white" display="flex" flexDirection="column" m={2} borderRadius="8px" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//                             {/* Applications Header & Add Button */}
//                              <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={2} sx={{ flexShrink: 0 }}>
//                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="16px"> {`APPLICATIONS (${cluster.applications?.length || 0})`} </Typography>
//                                  {/* Original Add App button logic (show only if active and user has role) */}
//                                 {cluster.status === 'active' && ( // Check status before showing button at all
//                                      <Button
//                                         sx={{ backgroundColor: "black", color: "white", fontFamily: "Gilroy-SemiBold", "&:hover": { backgroundColor: "#333" }, textTransform: "none", px: 2, py: 0.5 }}
//                                          // Also check role and if app requesters are defined
//                                         disabled={!user.roles?.some((e: string) => ["application_owner"].includes(e)) || !cluster.applicationRequesters || cluster.applicationRequesters.length === 0}
//                                         variant="contained" size="medium"
//                                         onClick={() => navigate("/applications/add", { state: { clusterId: cluster.id, clusterName: cluster.clusterName } })} // Pass cluster info if needed
//                                     > Add New Application </Button>
//                                 )}
//                             </Box>
//                             <Divider sx={{ flexShrink: 0 }}/>
//                             {/* Applications Content Area */}
//                             <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
//                                 {/* --- Original Applications rendering logic --- */}
//                                 {/* Empty state for active clusters */}
//                                 {cluster.status === "active" && (!cluster.applications || cluster.applications?.length === 0) ? (
//                                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', p:3 }}>
//                                         <img src="/assets/inbox-icon.svg" alt="No Applications" style={{ marginBottom: '16px', width: '80px' }} />
//                                         <Typography gutterBottom fontFamily="Gilroy-Bold" fontSize="16px" textAlign="center"> No applications added yet </Typography>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="14px" textAlign="center" color="text.secondary" mb={2} maxWidth="450px">
//                                              Click the button above to add a new application, or ask an assigned application owner to add one.
//                                         </Typography>
//                                         {/* Add button is already in the header */}
//                                     </Box>
//                                 ) : /* List for active clusters with apps */ cluster.status === "active" && cluster.applications?.length > 0 ? (
//                                     <Box>
//                                         {cluster.applications.map((application: any, index: number) => (
//                                              <Accordion key={application.id || index} elevation={0} sx={{ borderRadius: "8px", mb: 2, "&:before": { display: "none" }, bgcolor: "white", border: "1px solid #eee" }}>
//                                                 <AccordionSummary expandIcon={<ExpandMore />}>
//                                                      <Box>
//                                                          <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">{application.applicationName}</Typography>
//                                                          <Typography fontSize="12px" fontFamily="Gilroy-Regular" color="text.secondary"> Created: {application.createdAt ? moment(new Date(Number(application.createdAt))).format("DD/MM/YYYY | hh:mm A") : 'N/A'} </Typography>
//                                                      </Box>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails sx={{ pt: 0 }}>
//                                                      <Divider sx={{ mb: 2 }}/>
//                                                       <Grid container spacing={2}>
//                                                           {/* App Details Grid Items */}
//                                                           <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Name</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" noWrap>{cluster.clusterName}</Typography></Grid>
//                                                         <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Environment</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{application.environment}</Typography></Grid>
//                                                         <Grid item xs={12} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">App Owner</Typography><Box display="flex" alignItems="center"><Avatar sx={{ height: "20px", width: "20px", mr: 0.5 }} src={application.applicationOwner?.googleProfilePicture} alt={application.applicationOwner?.name?.charAt(0)} /><Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap>{application.applicationOwner?.name || 'N/A'}</Typography></Box></Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>App Viewers</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{application.gcpApplicationViewers?.length > 0 ? application.gcpApplicationViewers.map((e: string, i: number) => <Tooltip title={e} key={`appviewer-${i}`}><Avatar sx={{ height: "20px", width: "20px" }} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Service Owners</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{application.serviceRequesters?.length > 0 ? application.serviceRequesters.map((e: string, i: number) => <Tooltip title={e} key={`svcowner-${i}`}><Avatar sx={{ height: "20px", width: "20px" }} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Tags/Label</Typography><Box display="flex" flexWrap="wrap" gap={0.75}>{application.costLabelPairs?.length > 0 ? application.costLabelPairs.map((e: any, i: number) => <Chip key={`apptag-${i}`} size="small" sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }} label={`${e.cost} • ${e.label}`} />) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                                         <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Micro-Services</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{`${application?.services?.length || 0}`}</Typography></Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         ))}
//                                     </Box>
//                                 ) : /* Info state for non-active clusters */ (
//                                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', p: 3 }}>
//                                         <img src="/assets/inbox-reject-icon.svg" alt="Application addition not allowed" style={{ marginBottom: '16px', width: '80px' }}/>
//                                         <Typography gutterBottom fontFamily="Gilroy-Bold" fontSize="16px" textAlign="center"> Application addition not allowed </Typography>
//                                         <Paper elevation={0} sx={{ bgcolor: cluster.status === "rejected" ? "#FEECEB" : "#FEFBE8", border: `1px solid ${cluster.status === "rejected" ? "#F04438" : "#FDB022"}`, display: "flex", alignItems: "center", p: 1.5, maxWidth: '500px' }}>
//                                             <img src="/assets/info-circle.svg" alt="info" style={{ marginRight: '8px', width: '20px' }}/>
//                                             <Typography fontFamily="Gilroy-Regular" fontSize="14px">
//                                                 {cluster.status === "rejected" ? "This cluster request was rejected..." : "This cluster is pending approval..."}
//                                                 {cluster.reasonForRejection && cluster.status === "rejected" && ( <Typography component="span" display="block" mt={1} fontSize="12px"> Reason: {cluster.reasonForRejection} </Typography> )}
//                                            </Typography>
//                                         </Paper>
//                                     </Box>
//                                 )}
//                                 {/* --- End original rendering --- */}
//                             </Box> {/* End Applications Content Area */}
//                         </Box>
//                     </Grid> {/* End Right Panel */}
//                 </Grid>
//             )}
			
//             {/* --- Security Checks Modal Added Here --- */}
//             <Dialog open={isSecurityModalOpen} onClose={handleCloseSecurityModal} maxWidth="xs" fullWidth>
//                 <DialogTitle sx={{ fontFamily: "Gilroy-Bold" }}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                         <SecurityIcon /> Security Check Results
//                     </Box>
//                 </DialogTitle>
//                 <DialogContent dividers sx={{ p: 0 }}> {/* Remove padding for List */}
//                     <List disablePadding>
//                         {/* Checkov Item */}
//                         {checkovSummary && (
//                             <ListItemButton
//                                 onClick={handleNavigateToCheckov}
//                                 sx={{
//                                     '&:hover': { bgcolor: 'action.hover' },
//                                     p: 2 // Add padding here instead of DialogContent
//                                 }}
//                             >
//                                 <Box display="flex" alignItems="center" width="100%" gap={2}>
//                                     {/* Custom Checkov Logo */}
//                                     <Box sx={{ flexShrink: 0, width: 24, height: 24, display: 'flex', alignItems: 'center' }}>
//                                         {/* TODO: Replace with actual path */}
//                                         <img src="/assets/checkov-dashboard.svg" alt="Checkov" width="24" height="24" />
//                                     </Box>

//                                     {/* Primary Text */}
//                                     <Typography sx={{ fontFamily: "Gilroy-SemiBold", flexGrow: 1 }}>
//                                         View Checkov Results
//                                     </Typography>

//                                     {/* Passed/Failed Chips Stack */}
//                                      <Stack
//                                          direction="row"
//                                          spacing={1}
//                                          alignItems="center"
//                                          sx={{ flexShrink: 0, fontFamily:'Gilroy-SemiBold' }}
//                                      >
//                                         <Tooltip title={`Passed checks: ${checkovSummary.passed}`} placement="top">
//                                             <Chip
//                                                 label={`Passed: ${checkovSummary.passed}`}
//                                                 icon={
//                                                     <Avatar sx={{ width: 18, height: 18, bgcolor: 'transparent' }}>
//                                                         {/* TODO: Replace with actual path */}
//                                                         <img src="/assets/checkbox-circle-fill.svg" alt="Passed" width="18" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
//                                                     </Avatar>
//                                                 }
//                                                 size="small"
//                                                 sx={{
//                                                     // TODO: Replace with actual color value (e.g., '#12B76A')
//                                                     bgcolor: '#5CB85C',
//                                                     color: '#fff', height: '28px', borderRadius: '16px', fontSize: '0.75rem',
//                                                     '& .MuiChip-icon': { color: '#fff', ml: '6px', mr: '-4px', width: 18, height: 18 },
//                                                     '& .MuiChip-label': { pl: '8px', pr: '10px' }
//                                                 }}
//                                             />
//                                         </Tooltip>
//                                         <Tooltip title={`Failed checks: ${checkovSummary.failed}`} placement="top">
//                                             <Chip
//                                                 label={`Failed: ${checkovSummary.failed}`}
//                                                 icon={
//                                                     <Avatar sx={{ width: 18, height: 18, bgcolor: 'transparent' }}>
//                                                         {/* TODO: Replace with actual path */}
//                                                         <img src="/assets/close-circle-fill.svg" alt="Failed" width="18" height="18" style={{ filter: 'brightness(0) invert(1)' }}/>
//                                                     </Avatar>
//                                                 }
//                                                 size="small"
//                                                 sx={{
//                                                     // TODO: Replace with actual color value (e.g., '#F04438')
//                                                     bgcolor: '#D9534F',
//                                                     color: '#fff', height: '28px', borderRadius: '16px', fontSize: '0.75rem',
//                                                     '& .MuiChip-icon': { color: '#fff', ml: '6px', mr: '-4px', width: 18, height: 18 },
//                                                     '& .MuiChip-label': { pl: '8px', pr: '10px' }
//                                                 }}
//                                             />
//                                         </Tooltip>
//                                     </Stack>
//                                 </Box>
//                             </ListItemButton>
//                         )}

//                         {/* Divider if both are present */}
//                         {checkovSummary && kyvernoPolicyCount !== null && <Divider component="li" />}

//                         {/* Kyverno Item */}
//                         {kyvernoPolicyCount !== null && (
//                             <ListItemButton
//                                 onClick={handleNavigateToKyverno}
//                                 sx={{
//                                     '&:hover': { bgcolor: 'action.hover' },
//                                     p: 2 // Add padding here
//                                 }}
//                             >
//                                 {/* Custom Kyverno Logo */}
//                                 <ListItemIcon sx={{ minWidth: 'auto', mr: 2 /* Add margin */ }}>
//                                      {/* TODO: Replace with actual path */}
//                                      <img src="/assets/kyverno.svg" alt="Kyverno" width="24" height="24" />
//                                 </ListItemIcon>

//                                 {/* Primary Text */}
//                                 <ListItemText
//                                     primary="View Kyverno Policies"
//                                     primaryTypographyProps={{ fontFamily: "Gilroy-SemiBold" }}
//                                 />

//                                 {/* Policy Count */}
//                                 <Typography sx={{ fontFamily: "Gilroy-Regular", color: 'text.secondary', ml: 2 /* Add margin */ }}>
//                                     {`${kyvernoPolicyCount} Policies Applied`}
//                                 </Typography>

//                             </ListItemButton>
//                         )}

//                         {/* Message if neither Checkov nor Kyverno data is loaded/found */}
//                         {!isLoadingSecurityData && !checkovSummary && kyvernoPolicyCount === null && (
//                              <ListItem sx={{ p: 2 /* Add padding */ }}>
//                                 <ListItemText
//                                     primary="No specific security results available for this cluster."
//                                     primaryTypographyProps={{ fontFamily: "Gilroy-Regular", textAlign:"center", color: "text.secondary" }}
//                                 />
//                              </ListItem>
//                         )}
//                          {/* Optional: Show loading indicator inside dialog content */}
//                          {isLoadingSecurityData && (
//                             <ListItem sx={{ justifyContent: 'center', p: 2 }}>
//                                 <CircularProgress size={24} />
//                             </ListItem>
//                          )}
//                     </List>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleCloseSecurityModal} sx={{ fontFamily: "Gilroy-SemiBold", textTransform: 'none' }}> Close </Button>
//                 </DialogActions>
//             </Dialog>
//              {/* --- End Modal Add --- */}

//         </Container>
//     );
// };

// export default ClusterDetailsPage;

// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     Button,
//     Container,
//     Grid,
//     // TextField, // Not used in the provided snippet
//     Typography,
//     // MenuItem, // Not used in the provided snippet
//     IconButton,
//     Breadcrumbs,
//     Link,
//     Divider,
//     // Autocomplete, // Not used in the provided snippet
//     Avatar,
//     Tooltip,
//     Chip,
//     Paper,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     CircularProgress,
//     List,
//     ListItemButton,
//     ListItemText,
//     ListItemIcon,
//     // Add ListItem if needed for the 'No specific results loaded' case
//     ListItem
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SecurityIcon from '@mui/icons-material/Security';
// import PolicyIcon from '@mui/icons-material/Policy';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import { useNavigate, useParams } from "react-router-dom";
// import queryGraphql from "../../helpers/ApiInterface";
// import { useAuth } from "../../helpers/AuthProvider";
// import moment from "moment";
// import { ExpandMore } from "@mui/icons-material";
// import { RiRestartLine } from "react-icons/ri";
// import { RiCheckLine } from "react-icons/ri";
// import { RiCloseLine } from "react-icons/ri";
// import { RiHourglass2Line } from "react-icons/ri";

// // --- (Keep statusStyles, CheckovSummary, KyvernoResult interfaces as before) ---
// const statusStyles = {
//     Loading: {
//         backgroundImage: 'linear-gradient(to left, rgba(24, 24, 24, 0), rgba(24, 24, 24, 0.1))',
//         icon:<RiRestartLine/>,
//         // NOTE: 'active' was in Loading and also used for display logic. Ensure this is intended.
//         // If active clusters can be 'Loading', status might need refinement.
//         // Removing 'active' from Loading for clarity based on context.
//         status: ['pending','rejected'] // Assuming Loading applies before Success/Error/Pending states
//     },
//     Success: {
//         backgroundImage: 'linear-gradient(to left, rgba(18, 183, 106, 0), rgba(18, 183, 106, 0.1))',
//         icon:<RiCheckLine/>,
//         // 'active' status might map to one of these backend statuses like 'Cluster Created' or 'Infra Audit Successful'
//         status: ['Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Cluster Created','Infra Audit Successful']
//     },
//     Error: {
//         backgroundImage: 'linear-gradient(to left, rgba(240, 68, 56, 0), rgba(240, 68, 56, 0.1))',
//         icon:<RiCloseLine/>,
//         status: ['Plan Failed','Cluster Creation Failed','Infra Audit Failed'],
//     },
//     Pending: {
//         backgroundImage: 'linear-gradient(to left, rgba(253, 176, 34, 0), rgba(253, 176, 34, 0.1))',
//         icon:<RiHourglass2Line/>,
//         status: ['MR Approval Pending'],
//     },
// }

// interface CheckovSummary {
//     passed: number;
//     failed: number;
// }

// interface KyvernoResult {
//     id: string;
//     policies: any[];
// }
// // ---

// const ClusterDetailsPage: React.FC = () => {
//     const navigate = useNavigate();
//     const { user } = useAuth();
//     const { id } = useParams<{ id: string }>();
//     const [resourceStatus, setResourceStatus] = useState<any>({});
//     const [cluster, setCluster] = useState<any>({});

//     const [checkovSummary, setCheckovSummary] = useState<CheckovSummary | null>(null);
//     const [kyvernoPolicyCount, setKyvernoPolicyCount] = useState<number | null>(null);
//     const [isLoadingSecurityData, setIsLoadingSecurityData] = useState<boolean>(false);
//     const [isSecurityModalOpen, setIsSecurityModalOpen] = useState<boolean>(false);

//     // --- GraphQL Queries (Fetching ALL results) ---
//     // WARNING: Fetching all results is inefficient. Modify backend for filtering if possible.
//     const GET_CHECKOV_RESULTS_QUERY = `
//         query GetCheckovResults {
//             getCheckovResults {
//                 id
//                 resourceType # Needed for potential filtering
//                 resourceId   # IMPORTANT: Assume this holds the cluster ID for cluster-related checks
//                 summary {
//                     passed
//                     failed
//                 }
//                 # cluster { clusterName } # Include if needed for filtering instead of resourceId
//             }
//         }
//     `;

//     const GET_KYVERNO_RESULTS_QUERY = `
//         query GetKyvernoResults {
//             getKyvernoResults {
//                 id
//                 resourceId   # IMPORTANT: Assume this holds the cluster ID for cluster-related policies
//                 resourceType # Needed for potential filtering
//                 policies {
//                     name # Need at least one field to count
//                 }
//                 # cluster { clusterName } # Include if needed for filtering instead of resourceId
//             }
//         }
//     `;
//     // ---

//     // --- Effect for Cluster and Resource Status (No change needed here) ---
//     useEffect(() => {
//         const fetchClusterData = async () => {
//             if (!id) return;
//             try {
//                 const data = await queryGraphql( /* ... your cluster query ... */ `
//                    query($clusterId: String!){
//                         cluster(id:$clusterId) {
//                             id, clusterName, status, createdAt, # etc.
//                              clusterOwner{ id, name, googleProfilePicture }, gcpProjectId, environment, region, clusterSize, clusterType, gcpClusterViewers, applicationRequesters, costLabelPairs{ cost, label }, actionedAt, clusterNamePrefix, vpcProjectId, network, nodeSubnet, nodeSubnetRange, secondaryPodRange, secondaryServiceRange, releaseChannel, kubernetesVersion, reasonForRejection,
//                              applications{ id, applicationName, environment, costLabelPairs{ cost, label }, status, createdAt, gcpApplicationViewers, serviceRequesters, applicationOwner{ id, name, email, googleProfilePicture }, services { id, serviceName }}
//                         }
//                     }
//                 `, { clusterId: id });
//                 if (data.cluster) {
//                     // console.dir(data.cluster); // Keep for debugging if needed
//                     setCluster(data.cluster);
//                 }
//             } catch (error) {
//                 console.error("Error fetching cluster data:", error);
//             }
//         };

//         const fetchResourceStatusData = async () => {
//             if (!id) return;
//             try {
//                  const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
//                     resourceStatus(id: $resourceStatusId) {
//                         id, resourceId, resourceName, currentStatus, resourceType, resourceEnvironment, resourceOwner { id, name }, projectUrl, gcpClusterUrl, argoCdStaticUrl, subGroupProjectAppUrl, subGroupProjectInfraUrl, createdAt, updatedAt
//                     }
//                 }`, {resourceStatusId: id});
//                 if(data.resourceStatus){
//                     setResourceStatus(data.resourceStatus);
//                 }
//             } catch (error) {
//                 console.error("Error fetching resource status:", error);
//             }
//         }

//         fetchClusterData();
//         fetchResourceStatusData();
//     }, [id]);
//     // ---

//     // --- Fetch and Filter Security Data ---
//     useEffect(() => {
//         const fetchAndFilterSecurityData = async () => {
//             // Ensure cluster ID is available and cluster is active before fetching
//             if (!id || !cluster.id || cluster.status !== 'active') {
//                 setCheckovSummary(null);
//                 setKyvernoPolicyCount(null);
//                 setIsLoadingSecurityData(false); // Ensure loading is set to false if we don't fetch
//                 return;
//             }

//             setIsLoadingSecurityData(true);
//             setCheckovSummary(null); // Reset before fetching/filtering
//             setKyvernoPolicyCount(null); // Reset before fetching/filtering

//             console.log(`Workspaceing security data for cluster ID: ${id}`); // Debug log

//             try {
//                 // Fetch ALL Checkov Results
//                 console.log("Fetching all Checkov results...");
//                 const checkovData = await queryGraphql(GET_CHECKOV_RESULTS_QUERY);
//                 if (checkovData.getCheckovResults && Array.isArray(checkovData.getCheckovResults)) {
//                      console.log(`Received ${checkovData.getCheckovResults.length} Checkov results. Filtering...`);
//                     // Filter results client-side
//                     // IMPORTANT: Verify 'resourceId' is the correct field linking to the cluster 'id'
//                     const clusterCheckovResult = checkovData.getCheckovResults.find(
//                         (result: any) => result.resourceId === id // Or result.cluster.id === id / result.cluster.clusterName === cluster.clusterName
//                     );

//                     if (clusterCheckovResult && clusterCheckovResult.summary) {
//                          console.log("Found matching Checkov result:", clusterCheckovResult.summary);
//                         setCheckovSummary(clusterCheckovResult.summary);
//                     } else {
//                         console.log("No matching Checkov result found for this cluster.");
//                         setCheckovSummary(null); // Explicitly set to null if not found
//                     }
//                 } else {
//                      console.log("No Checkov results received or data is not an array.");
//                      setCheckovSummary(null);
//                 }

//                 // Fetch ALL Kyverno Results
//                 console.log("Fetching all Kyverno results...");
//                 const kyvernoData = await queryGraphql(GET_KYVERNO_RESULTS_QUERY);
//                  if (kyvernoData.getKyvernoResults && Array.isArray(kyvernoData.getKyvernoResults)) {
//                     console.log(`Received ${kyvernoData.getKyvernoResults.length} Kyverno results. Filtering...`);
//                     // Filter results client-side
//                     // IMPORTANT: Verify 'resourceId' is the correct field linking to the cluster 'id'
//                      const clusterKyvernoResult = kyvernoData.getKyvernoResults.find(
//                          (result: any) => result.resourceId === id // Or result.cluster.id === id / result.cluster.clusterName === cluster.clusterName
//                      );

//                     if (clusterKyvernoResult && clusterKyvernoResult.policies) {
//                         console.log(`Found matching Kyverno result with ${clusterKyvernoResult.policies.length} policies.`);
//                         setKyvernoPolicyCount(clusterKyvernoResult.policies.length);
//                     } else {
//                          console.log("No matching Kyverno result found for this cluster.");
//                          setKyvernoPolicyCount(null); // Explicitly set to null if not found
//                     }
//                 } else {
//                     console.log("No Kyverno results received or data is not an array.");
//                     setKyvernoPolicyCount(null);
//                 }

//             } catch (error) {
//                 console.error("Error fetching/filtering security data:", error);
//                 setCheckovSummary(null); // Ensure state is null on error
//                 setKyvernoPolicyCount(null);
//             } finally {
//                 setIsLoadingSecurityData(false);
//                  console.log("Finished fetching/filtering security data.");
//             }
//         };

//         // Fetch only when cluster data is loaded and status is active
//         fetchAndFilterSecurityData();

//     }, [id, cluster.id, cluster.status]); // Depend on cluster data being loaded
//     // NOTE: Removed query strings from dependencies as they are constant
//     // ---

//     const handleOpenSecurityModal = () => setIsSecurityModalOpen(true);
//     const handleCloseSecurityModal = () => setIsSecurityModalOpen(false);

//     const handleNavigateToCheckov = () => {
//         // Pass clusterId to the Checkov page, potentially in state or params
//         navigate(`/security/checkov/${id}`);
//         handleCloseSecurityModal();
//     };

//     const handleNavigateToKyverno = () => {
//          // Pass clusterId to the Kyverno page
//         navigate(`/security/kyverno/${id}`);
//         handleCloseSecurityModal();
//     };

//     // Determine if the section should be shown (cluster active AND (checkov OR kyverno data exists for *this* cluster))
//     const showSecuritySection = cluster.status === 'active' && (checkovSummary !== null || kyvernoPolicyCount !== null);
//     // Separate flag for the button, including loading state check
//     const showSecurityButton = showSecuritySection && !isLoadingSecurityData;

//     // --- Calculate Resource Status Background/Icon ---
//     let currentResourceStyle = statusStyles.Loading; // Default or initial state
//     if (resourceStatus.currentStatus) {
//         if (statusStyles.Success.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Success;
//         else if (statusStyles.Error.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Error;
//         else if (statusStyles.Pending.status.includes(resourceStatus.currentStatus)) currentResourceStyle = statusStyles.Pending;
//         // Keep Loading style if none of the specific statuses match (or based on your specific logic)
//     }
//     // ---

//     return (
//         <Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>
//             {/* ... Header/Breadcrumbs ... */}
//             <Box sx={{ p: 2, bgcolor: "#fff" }}>
//                  <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
//                     <Link underline="hover" color="inherit" href="/clusters">
//                         Clusters
//                     </Link>
//                     <Typography color="text.primary">Cluster Details</Typography>
//                 </Breadcrumbs>
//                 <Box display="flex" alignItems="center" mt={1}>
//                     <IconButton edge="start" aria-label="back" color="inherit" onClick={() => navigate("/clusters")}>
//                         <ArrowBackIosNewIcon fontSize="small" />
//                     </IconButton>
//                     <Typography fontFamily="Gilroy-Bold" fontSize="18px"> Cluster Details </Typography>
//                 </Box>
//             </Box>
//             {/* --- Main Content Grid --- */}
//             {cluster.id && (
//                 <Grid container>
//                     {/* --- Left Panel (Cluster Details) --- */}
//                     <Grid item xs={12} md={3}>
//                         <Box m={2} bgcolor="white" borderRadius="4px" sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 32px)' }}>
//                              {/* ... Top section with name, status, date ... */}
//                              <Box  p={3}>
//                                 <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                                     <Typography fontFamily="Gilroy-Bold" fontSize="20px" mr={1} sx={{ wordBreak: 'break-word' }}>
//                                         {cluster.clusterName}
//                                     </Typography>
//                                     {cluster.status === "pending" && user.roles?.some((e: string) => ["cluster_owner"].includes(e)) && (
//                                         <IconButton sx={{ p: 0.5 }} edge="end" aria-label="edit" color="inherit" onClick={() => navigate(`/clusters/edit/${cluster.id}`)}>
//                                             <img width="20px" height="20px" src="/assets/edit-icon.svg" alt="Edit"/>
//                                         </IconButton>
//                                     )}
//                                 </Box>
//                                 <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
//                                      <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                         {cluster.createdAt ? moment(new Date(Number(cluster.createdAt))).format("DD/MM/YYYY | hh:mm A") : 'N/A'}
//                                      </Typography>
//                                      <Box sx={{ display: "flex", alignItems: "center" }}>
//                                         <img /* ... status icon ... */
//                                             src={ cluster.status === "active" ? "/assets/tickcircle.svg" : cluster.status === "rejected" ? "/assets/reject.svg" : "/assets/clock.svg" }
//                                             alt="Status Icon" style={{ width: "14px", height: "14px", marginRight: "4px" }}
//                                         />
//                                         <Typography /* ... status text ... */
//                                             fontSize="12px" fontFamily="Gilroy-Regular"
//                                             color={ cluster.status === "active" ? "#12B76A" : cluster.status === "rejected" ? "#F04438" : "#FDB022" }
//                                             sx={{ textTransform: 'capitalize' }}
//                                         >
//                                              {cluster.status === "pending" ? "Pending Approval" : cluster.status}
//                                         </Typography>
//                                      </Box>
//                                 </Box>
//                             </Box>
//                             {/* --- Scrollable Details --- */}
//                             <Box sx={{ flexGrow: 1, overflowY: "auto", p: 3 }}>
//                                  <Grid container spacing={2}>
//                                       {/* ... Cluster Details Grid Items ... */}
//                                      {/* GCP Project ID */}
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">GCP Project ID</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}>{cluster.gcpProjectId || 'N/A'}</Typography></Grid>
//                                     {/* Cluster Owner */}
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Owner</Typography><Box display="flex" alignItems="center"><Avatar sx={{ height: "20px", width: "20px", mr: 0.5 }} src={cluster.clusterOwner?.googleProfilePicture} alt={cluster.clusterOwner?.name?.charAt(0)} /><Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap>{cluster.clusterOwner?.name || 'N/A'}</Typography></Box></Grid>
//                                     {/* Environment */}
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Environment</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.environment || 'N/A'}</Typography></Grid>
//                                     {/* Region */}
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Region</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.region || 'N/A'}</Typography></Grid>
//                                     {/* Cluster Size */}
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Size</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterSize || 'N/A'}</Typography></Grid>
//                                     {/* Cluster Type */}
//                                     <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Type</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterType || 'N/A'}</Typography></Grid>
//                                     {/* Cluster Viewers */}
//                                     <Grid item xs={12}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Cluster Viewers</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{cluster.gcpClusterViewers?.length > 0 ? cluster.gcpClusterViewers.map((e: string, i: number) => <Tooltip title={e} key={i}><Avatar sx={{ height: "24px", width: "24px"}} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                     {/* Application Owners */}
//                                     <Grid item xs={12}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Application Owners</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{cluster.applicationRequesters?.length > 0 ? cluster.applicationRequesters.map((e: string, i: number) => <Tooltip title={e} key={i}><Avatar sx={{ height: "24px", width: "24px"}} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                     {/* Tags/Label */}
//                                     <Grid item xs={12}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Tags/Label</Typography><Box display="flex" flexWrap="wrap" gap={0.75}>{cluster.costLabelPairs?.length > 0 ? cluster.costLabelPairs.map((e: any, i: number) => <Chip key={i} size="small" sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }} label={`${e.cost} • ${e.label}`} />) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                  </Grid>

//                                 {/* --- Cloud Infra Details (Only for Active) --- */}
//                                 {cluster.status === "active" && (
//                                     <>
//                                         <Divider sx={{ my: 3 }} />
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={2}> Cloud Infra Details </Typography>
//                                          <Grid container spacing={2}>
//                                             {/* ... Infra Details Grid Items ... */}
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Name Prefix</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.clusterNamePrefix || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">VPC Project ID</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}>{cluster.vpcProjectId || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Network</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.network || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Node Subnet</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.nodeSubnet || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Master CIDR Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.nodeSubnetRange || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Release Channel</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.releaseChannel || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Secondary Pod Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.secondaryPodRange || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Secondary Service Range</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.secondaryServiceRange || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Kubernetes Version</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{cluster.kubernetesVersion || 'N/A'}</Typography></Grid>
//                                             {/* Infra URLs Tooltip */}
//                                             <Grid item xs={12} sm={6}>
//                                                  <Typography fontFamily="Gilroy-Regular" fontSize="12px"> Infra URLs </Typography>
//                                                   <Box display="flex" alignItems="center">
//                                                       <Typography fontFamily="Gilroy-SemiBold" fontSize={14}>
//                                                          { [ resourceStatus.gcpClusterUrl, resourceStatus.projectUrl, resourceStatus.argoCdStaticUrl, resourceStatus.subGroupProjectAppUrl, resourceStatus.subGroupProjectInfraUrl ].filter(Boolean).length} URLs available
//                                                       </Typography>
//                                                       <Tooltip arrow title={ /* ... Tooltip content with links ... */ <Box sx={{ p: 1 }}><Typography fontFamily="Gilroy-Bold" fontSize="14px" mb={1}>Infrastructure URLs</Typography>{[ { label: "Cluster URL", url: resourceStatus.gcpClusterUrl }, { label: "Project URL", url: resourceStatus.projectUrl }, { label: "ArgoCD URL", url: resourceStatus.argoCdStaticUrl }, { label: "Sub Group App URL", url: resourceStatus.subGroupProjectAppUrl }, { label: "Sub Group Infra URL", url: resourceStatus.subGroupProjectInfraUrl } ].map((item, index) => ( item.url ? ( <Box key={index} mb={0.5}><Link href={item.url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: '#ADD8E6', display: 'block', fontSize: '12px' }}>{item.label}</Link></Box> ) : ( <Typography key={index} fontFamily="Gilroy-Regular" fontSize="12px" color="text.secondary" mb={0.5}>{item.label} (Not Available)</Typography> ) ))}</Box> } slotProps={{ tooltip: { sx: { bgcolor: '#333333', color: '#FFFFFF', maxWidth: 350, fontSize: '12px' } } }}>
//                                                          <IconButton size="small" sx={{ ml: 0.5 }}><img src="/assets/info.svg" alt="info" style={{ height: 16, width: 16 }}/></IconButton>
//                                                       </Tooltip>
//                                                   </Box>
//                                              </Grid>
//                                         </Grid>

//                                         {/* --- Security & Compliance Section (Conditionally Rendered) --- */}
//                                         {/* Show section title only if loading or if data exists */}
//                                         {(isLoadingSecurityData || showSecuritySection) && (
//                                             <>
//                                                 <Divider sx={{ my: 3 }} />
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={1}>
//                                                     Security & Compliance
//                                                 </Typography>
//                                             </>
//                                         )}
//                                         {/* Loading Indicator */}
//                                         {isLoadingSecurityData && cluster.status === 'active' && (
//                                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
//                                                 <CircularProgress size={20} />
//                                                 <Typography fontSize="12px" color="text.secondary">Loading security status...</Typography>
//                                             </Box>
//                                         )}
//                                         {/* Security Button */}
//                                         {showSecurityButton && ( // Button shown only when loading is false AND data exists
//                                             <Button
//                                                 variant="outlined"
//                                                 size="small"
//                                                 startIcon={<SecurityIcon />}
//                                                 onClick={handleOpenSecurityModal}
//                                                 sx={{ textTransform: 'none', mb: 2 }}
//                                             >
//                                                 View Security Checks
//                                             </Button>
//                                         )}
//                                          {/* No Data Message */}
//                                         {!isLoadingSecurityData && cluster.status === 'active' && !showSecuritySection && ( // Show message only if not loading, cluster active, and no data found
//                                              <Typography fontSize="12px" color="text.secondary" sx={{ mb: 2 }}>
//                                                 No security scan results found for this cluster.
//                                              </Typography>
//                                         )}
//                                         {/* --- End Security Check Button --- */}
//                                     </>
//                                 )}
//                             </Box> {/* End Scrollable Details */}

//                             {/* --- Status Bar --- */}
//                              {resourceStatus.currentStatus && (
//                                  <Box sx={{ p: 1.5, display:"flex", alignItems:"center", justifyContent: "flex-start", backgroundImage: currentResourceStyle.backgroundImage, borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px' }}>
//                                      <Box sx={{ display: "flex", alignItems: "center", fontSize: '20px', mr: 1 }}>
//                                          {currentResourceStyle.icon}
//                                      </Box>
//                                      <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">
//                                          {statusStyles.Loading.status.includes(resourceStatus.currentStatus) ? "Processing..." : resourceStatus.currentStatus}
//                                      </Typography>
//                                  </Box>
//                               )}
//                              {/* --- End Status Bar --- */}
//                         </Box>
//                     </Grid>

//                     {/* --- Right Panel (Applications) --- */}
//                     <Grid item xs={12} md={9}>
//                          <Box bgcolor="white" display="flex" flexDirection="column" m={2} borderRadius="8px" sx={{ height: 'calc(100% - 32px)' }}>
//                              {/* ... Applications Header + Add Button ... */}
//                               <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={2}>
//                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="16px"> {`APPLICATIONS (${cluster.applications?.length || 0})`} </Typography>
//                                 {cluster.status === 'active' && (
//                                     <Button /* ... Add App Button ... */
//                                         sx={{ backgroundColor: "black", color: "white", fontFamily: "Gilroy-SemiBold", "&:hover": { backgroundColor: "#333" }, textTransform: "none", px: 2, py: 0.5 }}
//                                         disabled={ !user.roles?.some((e: string) => ["application_owner"].includes(e)) || !cluster.applicationRequesters || cluster.applicationRequesters.length === 0 }
//                                         variant="contained" size="medium"
//                                         onClick={() => navigate("/applications/add", { state: { clusterId: cluster.id, clusterName: cluster.clusterName } })}
//                                     > Add New Application </Button>
//                                 )}
//                             </Box>
//                             <Divider />
//                              {/* ... Applications List / Empty States ... */}
//                              <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
//                                 {cluster.status === "active" && (!cluster.applications || cluster.applications?.length === 0) ? (
//                                      <Box /* ... Empty state for Active Cluster ... */ display="flex" flexDirection="column" flex={1} alignItems="center" justifyContent="center" sx={{ height: '100%', p: 3 }}>
//                                         <img src="/assets/inbox-icon.svg" alt="No Applications" style={{ marginBottom: '16px', width: '80px' }} />
//                                         <Typography gutterBottom fontFamily="Gilroy-Bold" fontSize="16px" textAlign="center"> No applications added yet </Typography>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="14px" textAlign="center" color="text.secondary" mb={2} maxWidth="450px"> Click the button above to add a new application, or ask an assigned application owner to add one. </Typography>
//                                     </Box>
//                                 ) : cluster.status === "active" && cluster.applications && cluster.applications?.length > 0 ? (
//                                      <Box /* ... List of Applications ... */ display="flex" flexDirection="column" flex={1}>
//                                          {cluster.applications.map((application: any, index: number) => (
//                                             <Accordion key={application.id || index} elevation={0} sx={{ borderRadius: "8px", mb: 2, "&:before": { display: "none" }, bgcolor: "white", border: "1px solid #eee" }}>
//                                                 <AccordionSummary expandIcon={<ExpandMore />}>
//                                                      <Box>
//                                                          <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">{application.applicationName}</Typography>
//                                                          <Typography fontSize="12px" fontFamily="Gilroy-Regular" color="text.secondary"> Created: {application.createdAt ? moment(new Date(Number(application.createdAt))).format("DD/MM/YYYY | hh:mm A") : 'N/A'} </Typography>
//                                                      </Box>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails sx={{ pt: 0 }}>
//                                                      <Divider sx={{ mb: 2 }}/>
//                                                       <Grid container spacing={2}>
//                                                          {/* ... Application Details Grid Items ... */}
//                                                           <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Cluster Name</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px" noWrap>{cluster.clusterName}</Typography></Grid>
//                                                         <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Environment</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{application.environment}</Typography></Grid>
//                                                         <Grid item xs={12} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">App Owner</Typography><Box display="flex" alignItems="center"><Avatar sx={{ height: "20px", width: "20px", mr: 0.5 }} src={application.applicationOwner?.googleProfilePicture} alt={application.applicationOwner?.name?.charAt(0)} /><Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap>{application.applicationOwner?.name || 'N/A'}</Typography></Box></Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>App Viewers</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{application.gcpApplicationViewers?.length > 0 ? application.gcpApplicationViewers.map((e: string, i: number) => <Tooltip title={e} key={i}><Avatar sx={{ height: "20px", width: "20px" }} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Service Owners</Typography><Box display="flex" flexWrap="wrap" gap={0.5}>{application.serviceRequesters?.length > 0 ? application.serviceRequesters.map((e: string, i: number) => <Tooltip title={e} key={i}><Avatar sx={{ height: "20px", width: "20px" }} src={e} alt={e} /></Tooltip>) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}><Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>Tags/Label</Typography><Box display="flex" flexWrap="wrap" gap={0.75}>{application.costLabelPairs?.length > 0 ? application.costLabelPairs.map((e: any, i: number) => <Chip key={i} size="small" sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }} label={`${e.cost} • ${e.label}`} />) : <Typography fontSize="12px" color="text.secondary">None</Typography>}</Box></Grid>
//                                                         <Grid item xs={6} sm={4} md={2.4}><Typography fontFamily="Gilroy-Regular" fontSize="12px">Micro-Services</Typography><Typography fontFamily="Gilroy-SemiBold" fontSize="14px">{`${application?.services?.length || 0}`}</Typography></Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         ))}
//                                     </Box>
//                                 ) : (
//                                      <Box /* ... Empty State for Non-Active Cluster ... */ display="flex" flexDirection="column" flex={1} alignItems="center" justifyContent="center" sx={{ height: '100%', p: 3 }}>
//                                         <img src="/assets/inbox-reject-icon.svg" alt="Application addition not allowed" style={{ marginBottom: '16px', width: '80px' }}/>
//                                         <Typography gutterBottom fontFamily="Gilroy-Bold" fontSize="16px" textAlign="center"> Application addition not allowed </Typography>
//                                          <Paper /* ... Warning Paper ... */ elevation={0} sx={{ bgcolor: cluster.status === "rejected" ? "#FEECEB" : "#FEFBE8", border: `1px solid ${cluster.status === "rejected" ? "#F04438" : "#FDB022"}`, display: "flex", alignItems: "center", p: 1.5, maxWidth: '500px' }}>
//                                              <img src="/assets/info-circle.svg" alt="info" style={{ marginRight: '8px', width: '20px' }}/>
//                                              <Typography fontFamily="Gilroy-Regular" fontSize="14px">
//                                                  {cluster.status === "rejected" ? "This cluster request was rejected..." : "This cluster is pending approval..."}
//                                                  {cluster.reasonForRejection && cluster.status === "rejected" && ( <Typography component="span" display="block" mt={1} fontSize="12px"> Reason: {cluster.reasonForRejection} </Typography> )}
//                                             </Typography>
//                                          </Paper>
//                                     </Box>
//                                 )}
//                             </Box>
//                         </Box>
//                     </Grid>
//                 </Grid>
//             )}

//             {/* --- Security Checks Modal --- */}
//             <Dialog open={isSecurityModalOpen} onClose={handleCloseSecurityModal} maxWidth="xs" fullWidth>
//                 <DialogTitle sx={{ fontFamily: "Gilroy-Bold" }}>
//                     <Box display="flex" alignItems="center" gap={1}> <SecurityIcon /> Security Check Options </Box>
//                 </DialogTitle>
//                 <DialogContent dividers>
//                     <List disablePadding>
//                         {/* Checkov Item - Rendered only if checkovSummary exists */}
//                         {checkovSummary && (
//                             <ListItemButton onClick={handleNavigateToCheckov} sx={{ borderRadius: '4px', mb: 1, '&:hover': { bgcolor: 'action.hover' } }}>
//                                 <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
//                                 <ListItemText
//                                     primary="View Checkov Results"
//                                     secondary={`Passed: ${checkovSummary.passed}, Failed: ${checkovSummary.failed}`}
//                                     primaryTypographyProps={{ fontFamily: "Gilroy-SemiBold" }}
//                                     secondaryTypographyProps={{ fontFamily: "Gilroy-Regular" }}
//                                 />
//                                 {checkovSummary.failed > 0 && ( <ListItemIcon sx={{ minWidth: 'auto', color: 'error.main', justifyContent: 'flex-end' }}> <ErrorOutlineIcon /> </ListItemIcon> )}
//                             </ListItemButton>
//                         )}
//                         {/* Kyverno Item - Rendered only if kyvernoPolicyCount is not null */}
//                         {kyvernoPolicyCount !== null && ( // Check for not null specifically
//                             <ListItemButton onClick={handleNavigateToKyverno} sx={{ borderRadius: '4px', '&:hover': { bgcolor: 'action.hover' } }}>
//                                 <ListItemIcon><PolicyIcon color="info"/></ListItemIcon>
//                                 <ListItemText
//                                     primary="View Kyverno Policies"
//                                     secondary={`Total Policies Applied: ${kyvernoPolicyCount}`}
//                                     primaryTypographyProps={{ fontFamily: "Gilroy-SemiBold" }}
//                                     secondaryTypographyProps={{ fontFamily: "Gilroy-Regular" }}
//                                 />
//                             </ListItemButton>
//                         )}
//                         {/* Message if neither Checkov nor Kyverno data is loaded/found for this cluster */}
//                         {!checkovSummary && kyvernoPolicyCount === null && (
//                              <ListItem>
//                                 <ListItemText primary="No specific security results available for this cluster." primaryTypographyProps={{ fontFamily: "Gilroy-Regular", textAlign:"center", color: "text.secondary" }}/>
//                              </ListItem>
//                             // <Typography color="text.secondary" textAlign="center" fontFamily="Gilroy-Regular" sx={{p: 2}}>
//                             //    No specific security results loaded.
//                             // </Typography>
//                         )}
//                     </List>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleCloseSecurityModal} sx={{ fontFamily: "Gilroy-SemiBold", textTransform: 'none' }}> Close </Button>
//                 </DialogActions>
//             </Dialog>
//             {/* --- End Security Checks Modal --- */}
//         </Container>
//     );
// };

// export default ClusterDetailsPage;
// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     Button,
//     Container,
//     Grid,
//     TextField,
//     Typography,
//     MenuItem,
//     IconButton,
//     Breadcrumbs,
//     Link,
//     Divider,
//     Autocomplete,
//     Avatar,
//     Tooltip,
//     Chip,
//     Paper,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     Dialog, // Added
//     DialogTitle, // Added
//     DialogContent, // Added
//     DialogActions, // Added
//     CircularProgress, // Added
//     List,         // Added for modal layout
//     ListItemButton,     // Added for modal layout
//     ListItemText, // Added for modal layout
//     ListItemIcon, // Added for modal layout
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SecurityIcon from '@mui/icons-material/Security'; // Added Example Icon
// import PolicyIcon from '@mui/icons-material/Policy'; // Added Example Icon
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'; // Added Example Icon
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'; // Added Example Icon
// import { useNavigate, useParams } from "react-router-dom";
// import queryGraphql from "../../helpers/ApiInterface";
// import { useAuth } from "../../helpers/AuthProvider";
// import moment from "moment";
// import { ExpandMore } from "@mui/icons-material";
// import { RiRestartLine } from "react-icons/ri";
// import { RiCheckLine } from "react-icons/ri";
// import { RiCloseLine } from "react-icons/ri";
// import { RiHourglass2Line } from "react-icons/ri";

// const statusStyles = {
//     Loading: {
//         backgroundImage: 'linear-gradient(to left, rgba(24, 24, 24, 0), rgba(24, 24, 24, 0.1))',
//         icon:<RiRestartLine/>,
//         status: ['active', 'pending','rejected'] // Note: 'active' was also here, might need review based on desired logic
//     },
//     Success: {
//         backgroundImage: 'linear-gradient(to left, rgba(18, 183, 106, 0), rgba(18, 183, 106, 0.1))',
//         icon:<RiCheckLine/>,
//         status: ['Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Cluster Created','Infra Audit Successful']
//     },
//     Error: {
//         backgroundImage: 'linear-gradient(to left, rgba(240, 68, 56, 0), rgba(240, 68, 56, 0.1))',
//         icon:<RiCloseLine/>,
//         status: ['Plan Failed','Cluster Creation Failed','Infra Audit Failed'],
//     },
//     Pending: {
//         backgroundImage: 'linear-gradient(to left, rgba(253, 176, 34, 0), rgba(253, 176, 34, 0.1))',
//         icon:<RiHourglass2Line/>,
//         status: ['MR Approval Pending'],
//     },
// }

// // --- Interface for Checkov Summary ---
// interface CheckovSummary {
//     passed: number;
//     failed: number;
// }

// // --- Interface for Kyverno Result (simplified for check) ---
// interface KyvernoResult {
//     id: string;
//     policies: any[]; // Keep structure for count
// }


// const ClusterDetailsPage: React.FC = () => {
//     const navigate = useNavigate();
//     const { user } = useAuth();
//     const { id } = useParams<{ id: string }>(); // Ensure id is treated as string
//     const [resourceStatus, setResourceStatus] = useState<any>({});
//     const [cluster, setCluster] = useState<any>({});

//     // --- State for Security Checks ---
//     const [checkovSummary, setCheckovSummary] = useState<CheckovSummary | null>(null);
//     const [kyvernoPolicyCount, setKyvernoPolicyCount] = useState<number | null>(null);
//     const [isLoadingSecurityData, setIsLoadingSecurityData] = useState<boolean>(false);
//     const [isSecurityModalOpen, setIsSecurityModalOpen] = useState<boolean>(false);
//     // ---

//     // --- Modified GraphQL Queries (Assuming filtering capability) ---
//     const GET_CHECKOV_RESULTS_QUERY = `
//        query GetCheckovResults {
//   getCheckovResults {
//     id
//     cluster {
//       clusterName
//     }
//     application {
//       applicationName
//     }
//     service {
//       serviceName
//     }
//     resourceType
//     resourceId
//     summary {
//       passed
//       failed
//     }
//   }
// }
//     `;

//     const GET_KYVERNO_RESULTS_QUERY = `
//         query GetKyvernoResults {
//   getKyvernoResults {
//     id
//     resourceId
//     resourceType
//     policies {
//       category
//       description
//       name
//       rules {
//         message
//         name
//       }
//       severity
//       title
//       validationFailureAction
//     }
//     cluster {
//       clusterName
//     }
//     createdAt
//     updatedAt
//   }
// }
//     `;
//     // ---

//     React.useEffect(() => {
//         const fetchData = async () => {
//             if (!id) return; // Don't fetch if id is not available
//             try {
//                 const data = await queryGraphql(
//                     `
//                         query($clusterId: String!){
//                            # ... (rest of your cluster query) ...
//                             cluster(id:$clusterId) {
//                                 id,
//                                 clusterName,
//                                 clusterOwner{
//                                 id,
//                                 name,
//                                 googleProfilePicture
//                                 },
//                                 gcpProjectId,
//                                 environment,
//                                 region,
//                                 clusterSize,
//                                 clusterType,
//                                 gcpClusterViewers,
//                                 applicationRequesters,
//                                 costLabelPairs{
//                                 cost,
//                                 label
//                                 },
//                                 status,
//                                 createdAt,
//                                 actionedAt,
//                                 clusterNamePrefix,
//                                 vpcProjectId,
//                                 network,
//                                 nodeSubnet,
//                                 nodeSubnetRange,
//                                 secondaryPodRange,
//                                 secondaryServiceRange,
//                                 releaseChannel,
//                                 kubernetesVersion,
//                                 reasonForRejection,
//                                 applications{
//                                 id,
//                                 applicationName,
//                                 environment,
//                                 costLabelPairs{
//                                 cost,
//                                 label
//                                 },
//                                 status,
//                                 createdAt,
//                                 gcpApplicationViewers,
//                                 serviceRequesters,
//                                 applicationOwner{
//                                 id,
//                                 name,
//                                 email,
//                                 googleProfilePicture
//                                 }
//                                 services {
//                                     id,
//                                     serviceName
//                                 }

//                                 }
//                             }
//                         }
//                     `,
//                     { clusterId: id }
//                 );
//                 if (data.cluster) {
//                     console.dir(data.cluster);
//                     setCluster(data.cluster);
//                 }
//             } catch (error) {
//                 console.error("Error fetching cluster data:", error); // Use console.error
//             }
//         };

//         fetchData();
//     }, [id]); // Depend on id

//     React.useEffect(()=>{
//         const fetchData = async () =>{
//              if (!id) return; // Don't fetch if id is not available
//             try{
//                 const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
//                     # ... (rest of your resource status query) ...
//                     resourceStatus(id: $resourceStatusId) {
//                         id
//                         resourceId
//                         resourceName
//                         currentStatus
//                         resourceType
//                         resourceEnvironment
//                         resourceOwner {
//                         id
//                         name
//                         }
//                         projectUrl
//                         gcpClusterUrl
//                         argoCdStaticUrl
//                         subGroupProjectAppUrl
//                         subGroupProjectInfraUrl
//                         createdAt
//                         updatedAt
//                     }
//                     }`, {resourceStatusId: id});
//                 if(data.resourceStatus){
//                     setResourceStatus(data.resourceStatus);
//                 }
//             }
//             catch(error){
//                 console.error("Error fetching resource status:", error); // Use console.error
//             }
//         }
//         fetchData();
//     },[id]); // Depend on id

//     // --- Fetch Security Data ---
//     useEffect(() => {
//         const fetchSecurityData = async () => {
//             if (!id || cluster.status !== 'active') { // Only fetch for active clusters with an ID
//                 setCheckovSummary(null);
//                 setKyvernoPolicyCount(null);
//                 return;
//             }

//             setIsLoadingSecurityData(true);
//             setCheckovSummary(null); // Reset before fetching
//             setKyvernoPolicyCount(null); // Reset before fetching

//             try {
//                 // Fetch Checkov Results
//                 const checkovData = await queryGraphql(GET_CHECKOV_RESULTS_QUERY, { clusterId: id });
//                 if (checkovData.getCheckovResults && checkovData.getCheckovResults.length > 0) {
//                     // Assuming the query returns an array, potentially with multiple resources.
//                     // Aggregate or decide how to handle multiple results if necessary.
//                     // Here, we just take the first one for simplicity, assuming one result per cluster/resource type focus.
//                     // You might need to adjust logic if one cluster has multiple checkov entries (e.g., per application/service).
//                     const result = checkovData.getCheckovResults[0];
//                      if (result.summary) {
//                         setCheckovSummary(result.summary);
//                     }
//                 }

//                 // Fetch Kyverno Results
//                 const kyvernoData = await queryGraphql(GET_KYVERNO_RESULTS_QUERY, { clusterId: id });
//                  if (kyvernoData.getKyvernoResults && kyvernoData.getKyvernoResults.length > 0) {
//                      // Similar assumption as Checkov: take the first result or aggregate if needed.
//                     const result = kyvernoData.getKyvernoResults[0];
//                     if (result.policies) {
//                         setKyvernoPolicyCount(result.policies.length);
//                     }
//                 }

//             } catch (error) {
//                 console.error("Error fetching security data:", error);
//                 // Keep summaries null on error
//                 setCheckovSummary(null);
//                 setKyvernoPolicyCount(null);
//             } finally {
//                 setIsLoadingSecurityData(false);
//             }
//         };

//         // Fetch only when cluster data is loaded and status is known
//         if (cluster.id && cluster.status) {
//              fetchSecurityData();
//         }

//     }, [id, cluster.id, cluster.status, GET_CHECKOV_RESULTS_QUERY, GET_KYVERNO_RESULTS_QUERY]); // Add cluster dependencies
//     // ---

//     // --- Modal Handlers ---
//     const handleOpenSecurityModal = () => {
//         setIsSecurityModalOpen(true);
//     };

//     const handleCloseSecurityModal = () => {
//         setIsSecurityModalOpen(false);
//     };

//     const handleNavigateToCheckov = () => {
//         navigate(`/security/checkov/${id}`); // Adjust route as needed
//         handleCloseSecurityModal();
//     };

//     const handleNavigateToKyverno = () => {
//         navigate(`/security/kyverno/${id}`); // Adjust route as needed
//         handleCloseSecurityModal();
//     };
//     // ---

//     // Determine if the security button should be shown
//     const showSecurityButton = cluster.status === 'active' && !isLoadingSecurityData && (checkovSummary !== null || kyvernoPolicyCount !== null);

//     return (
//         <Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>
//             <Box sx={{ p: 2, bgcolor: "#fff" }}>
//                 {/* ... Breadcrumbs and Header ... */}
//                  <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
//                     <Link underline="hover" color="inherit" href="/clusters">
//                         Clusters
//                     </Link>
//                     <Typography color="text.primary">Cluster Details</Typography>
//                 </Breadcrumbs>
//                 <Box display="flex" alignItems="center" mt={1}>
//                     <IconButton
//                         edge="start"
//                         aria-label="back"
//                         color="inherit"
//                         onClick={() => navigate("/clusters")}
//                     >
//                         <ArrowBackIosNewIcon fontSize="small" />
//                     </IconButton>
//                     <Typography fontFamily="Gilroy-Bold" fontSize="18px">
//                         Cluster Details
//                     </Typography>
//                 </Box>
//             </Box>
//             {cluster.id && (
//                 <Grid container>
//                     <Grid item xs={12} md={3}> {/* Adjusted grid size for responsiveness */}
//                         <Box m={2} bgcolor="white" borderRadius="4px" sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 32px)' }}> {/* Adjust height */}
//                             <Box
//                                 bgcolor={
//                                     cluster.status === "active" // Use === for comparison
//                                         ? "#12B76A10"
//                                         : cluster.status === "rejected"
//                                         ? "#F0443810"
//                                         : "#FDB02210"
//                                 }
//                                 p={3}
//                             >
//                                 {/* ... Cluster Name, Status, Edit Icon ... */}
//                                  <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                                     <Typography fontFamily="Gilroy-Bold" fontSize="20px" mr={1} sx={{ wordBreak: 'break-word' }}>
//                                         {cluster.clusterName}
//                                     </Typography>
//                                     {cluster.status === "pending" && // Use ===
//                                         user.roles?.some((e: string) => ["cluster_owner"].includes(e)) && (
//                                             <IconButton
//                                                 sx={{ p: 0.5 }} // Adjust padding
//                                                 edge="end" // Align to end
//                                                 aria-label="edit"
//                                                 color="inherit"
//                                                 onClick={() => navigate(`/clusters/edit/${cluster.id}`)}
//                                             >
//                                                 <img width="20px" height="20px" src="/assets/edit-icon.svg" alt="Edit"/>
//                                             </IconButton>
//                                         )}
//                                 </Box>
//                                 <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
//                                     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                         {cluster.createdAt ? moment(new Date(Number(cluster.createdAt)).toISOString()).format(
//                                             "DD/MM/YYYY | hh:mm A"
//                                         ) : 'N/A'}
//                                     </Typography>
//                                     <Box sx={{ display: "flex", alignItems: "center" }}>
//                                         <img
//                                             src={
//                                                 cluster.status === "active"
//                                                     ? "/assets/tickcircle.svg"
//                                                     : cluster.status === "rejected"
//                                                     ? "/assets/reject.svg"
//                                                     : "/assets/clock.svg"
//                                             }
//                                             alt="Status Icon"
//                                             style={{ width: "14px", height: "14px", marginRight: "4px" }} // Ensure height is set
//                                         />
//                                         <Typography
//                                             fontSize="12px"
//                                             fontFamily="Gilroy-Regular"
//                                             color={
//                                                 cluster.status === "active"
//                                                     ? "#12B76A"
//                                                     : cluster.status === "rejected"
//                                                     ? "#F04438"
//                                                     : "#FDB022"
//                                             }
//                                             sx={{ textTransform: 'capitalize' }} // Capitalize status
//                                         >
//                                             {cluster.status === "pending" ? "Pending Approval" : cluster.status}
//                                         </Typography>
//                                     </Box>
//                                 </Box>
//                             </Box>

//                              {/* --- Scrollable Details Area --- */}
//                             <Box sx={{ flexGrow: 1, overflowY: "auto", p: 3 }}>

//                                 {/* ... Basic Cluster Details (GCP Project ID, Owner, Env, etc.) ... */}
//                                 <Grid container spacing={2}> {/* Use spacing */}
//                                     <Grid item xs={6} sm={6}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                             GCP Project ID
//                                         </Typography>
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}>
//                                             {cluster.gcpProjectId || 'N/A'}
//                                         </Typography>
//                                     </Grid>
//                                      <Grid item xs={6} sm={6}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                             Cluster Owner
//                                         </Typography>
//                                         <Box display="flex" alignItems="center" justifyContent="flex-start">
//                                             <Avatar
//                                                 sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
//                                                 src={cluster.clusterOwner?.googleProfilePicture}
//                                                 alt={cluster.clusterOwner?.name?.charAt(0)} // Fallback initial
//                                             />
//                                             <Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap>
//                                                 {cluster.clusterOwner?.name || 'N/A'}
//                                             </Typography>
//                                         </Box>
//                                     </Grid>
//                                     {/* ... Add other fields similarly ... */}
//                                     <Grid item xs={6} sm={6}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                             Environment
//                                         </Typography>
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                             {cluster.environment || 'N/A'}
//                                         </Typography>
//                                     </Grid>
//                                     <Grid item xs={6} sm={6}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                             Region
//                                         </Typography>
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                             {cluster.region || 'N/A'}
//                                         </Typography>
//                                     </Grid>
//                                     <Grid item xs={6} sm={6}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                             Cluster Size
//                                         </Typography>
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                             {cluster.clusterSize || 'N/A'}
//                                         </Typography>
//                                     </Grid>
//                                     <Grid item xs={6} sm={6}>
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                             Cluster Type
//                                         </Typography>
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                             {cluster.clusterType || 'N/A'}
//                                         </Typography>
//                                     </Grid>
//                                       <Grid item xs={12}> {/* Full width for lists */}
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>
//                                             Cluster Viewers
//                                         </Typography>
//                                         <Box display="flex" flexWrap="wrap" gap={0.5}>
//                                             {cluster.gcpClusterViewers?.length > 0 ? cluster.gcpClusterViewers.map((e: string, index: number) => (
//                                                 <Tooltip title={e} key={index}>
//                                                     <Avatar
//                                                         sx={{ height: "24px", width: "24px"}} // Slightly larger
//                                                         src={e} // Assuming 'e' is a URL or identifier for Avatar
//                                                         alt={e} // Provide meaningful alt text if possible
//                                                     />
//                                                 </Tooltip>
//                                             )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                         </Box>
//                                     </Grid>
//                                     <Grid item xs={12}> {/* Full width for lists */}
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>
//                                             Application Owners
//                                         </Typography>
//                                          <Box display="flex" flexWrap="wrap" gap={0.5}>
//                                              {cluster.applicationRequesters?.length > 0 ? cluster.applicationRequesters.map((e: string, index: number) => (
//                                                 <Tooltip title={e} key={index}>
//                                                     <Avatar
//                                                         sx={{ height: "24px", width: "24px" }}
//                                                         src={e} // Assuming 'e' is a URL
//                                                         alt={e}
//                                                     />
//                                                 </Tooltip>
//                                             )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                         </Box>
//                                     </Grid>
//                                      <Grid item xs={12}> {/* Full width for tags */}
//                                         <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>
//                                             Tags/Label
//                                         </Typography>
//                                          <Box display="flex" flexWrap="wrap" gap={0.75}>
//                                             {cluster.costLabelPairs?.length > 0 ? cluster.costLabelPairs.map((e: any, index: number) => (
//                                                 <Chip
//                                                     key={index}
//                                                     size="small"
//                                                     sx={{
//                                                         bgcolor: "#F0F0F0", // Lighter background
//                                                         // border: "1px solid #ccc", // Optional border
//                                                         fontFamily: "Gilroy-Regular",
//                                                         fontSize: "12px",
//                                                     }}
//                                                     label={`${e.cost} • ${e.label}`}
//                                                 />
//                                             )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                         </Box>
//                                     </Grid>
//                                 </Grid>


//                                 {cluster.status === "active" && (
//                                     <>
//                                         <Divider sx={{ my: 3 }} />
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={2}>
//                                             Cloud Infra Details
//                                         </Typography>
//                                          <Grid container spacing={2}> {/* Use spacing */}
//                                             {/* ... Infra Details (Prefix, VPC, Network, etc.) ... */}
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Cluster Name Prefix
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.clusterNamePrefix || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                             <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     VPC Project ID
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordBreak: 'break-all' }}>
//                                                     {cluster.vpcProjectId || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Network
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.network || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Node Subnet
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.nodeSubnet || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                               <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Master CIDR Range
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.nodeSubnetRange || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Release Channel
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.releaseChannel || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Secondary Pod Range
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.secondaryPodRange || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Secondary Service Range
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.secondaryServiceRange || 'N/A'}
//                                                 </Typography>
//                                             </Grid>
//                                              <Grid item xs={6} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Kubernetes Version
//                                                 </Typography>
//                                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                     {cluster.kubernetesVersion || 'N/A'}
//                                                 </Typography>
//                                             </Grid>

//                                             {/* --- Infra URLs Tooltip --- */}
//                                              <Grid item xs={12} sm={6}>
//                                                 <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                     Infra URLs
//                                                 </Typography>
//                                                  <Box display="flex" alignItems="center">
//                                                     <Typography fontFamily="Gilroy-SemiBold" fontSize={14}>
//                                                         {/* Calculate count based on available URLs */}
//                                                         {[
//                                                             resourceStatus.gcpClusterUrl,
//                                                             resourceStatus.projectUrl,
//                                                             resourceStatus.argoCdStaticUrl,
//                                                             resourceStatus.subGroupProjectAppUrl,
//                                                             resourceStatus.subGroupProjectInfraUrl
//                                                         ].filter(Boolean).length} URLs available
//                                                     </Typography>
//                                                     <Tooltip
//                                                         arrow // Add arrow for better visibility
//                                                         title={
//                                                             <Box sx={{ p: 1 }}>
//                                                                 <Typography fontFamily="Gilroy-Bold" fontSize="14px" mb={1}>
//                                                                     Infrastructure URLs
//                                                                 </Typography>
//                                                                 {[
//                                                                     { label: "Cluster URL", url: resourceStatus.gcpClusterUrl },
//                                                                     { label: "Project URL", url: resourceStatus.projectUrl },
//                                                                     { label: "ArgoCD URL", url: resourceStatus.argoCdStaticUrl },
//                                                                     { label: "Sub Group App URL", url: resourceStatus.subGroupProjectAppUrl },
//                                                                     { label: "Sub Group Infra URL", url: resourceStatus.subGroupProjectInfraUrl },
//                                                                 ].map((item, index) => (
//                                                                     item.url ? (
//                                                                         <Box key={index} mb={0.5}>
//                                                                             <Link href={item.url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: '#ADD8E6', display: 'block', fontSize: '12px' }}>
//                                                                                 {item.label}
//                                                                             </Link>
//                                                                         </Box>
//                                                                     ) : (
//                                                                         <Typography key={index} fontFamily="Gilroy-Regular" fontSize="12px" color="text.secondary" mb={0.5}>
//                                                                             {item.label} (Not Available)
//                                                                         </Typography>
//                                                                     )
//                                                                 ))}
//                                                             </Box>
//                                                         }
//                                                         slotProps={{ tooltip: { sx: { bgcolor: '#333333', color: '#FFFFFF', maxWidth: 350, fontSize: '12px' } } }}
//                                                     >
//                                                         <IconButton size="small" sx={{ ml: 0.5 }}>
//                                                             <img
//                                                                 src="/assets/info.svg"
//                                                                 alt="info"
//                                                                 style={{ height: 16, width: 16 }}
//                                                             />
//                                                         </IconButton>
//                                                     </Tooltip>
//                                                  </Box>
//                                             </Grid>
//                                             {/* --- End Infra URLs --- */}
//                                         </Grid>

//                                         {/* --- Security Check Button --- */}
//                                         <Divider sx={{ my: 3 }} />
//                                         <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" mb={1}>
//                                             Security & Compliance
//                                         </Typography>
//                                         {isLoadingSecurityData && (
//                                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                                  <CircularProgress size={20} />
//                                                 <Typography fontSize="12px" color="text.secondary">Loading security status...</Typography>
//                                              </Box>
//                                         )}
//                                         {showSecurityButton && (
//                                             <Button
//                                                 variant="outlined"
//                                                 size="small"
//                                                 startIcon={<SecurityIcon />}
//                                                 onClick={handleOpenSecurityModal}
//                                                 sx={{ textTransform: 'none', mb: 2 }}
//                                             >
//                                                 View Security Checks
//                                             </Button>
//                                         )}
//                                          {!isLoadingSecurityData && !showSecurityButton && cluster.status === 'active' && (
//                                              <Typography fontSize="12px" color="text.secondary">
//                                                 No security scan results found for this cluster.
//                                              </Typography>
//                                         )}
//                                         {/* --- End Security Check Button --- */}
//                                     </>
//                                 )}

//                             </Box>
//                             {/* --- End Scrollable Details Area --- */}

//                             {/* --- Status Bar at the bottom --- */}
//                             {resourceStatus.currentStatus && ( // Only show if status is available
//                                 <Box
//                                     sx={{
//                                         p: 1.5, // Adjust padding
//                                         display:"flex",
//                                         alignItems:"center",
//                                         justifyContent: "flex-start", // Align items left
//                                         backgroundImage:
//                                             (statusStyles.Loading.status.includes(resourceStatus.currentStatus)) ? statusStyles.Loading.backgroundImage :
//                                             statusStyles.Success.status.includes(resourceStatus.currentStatus) ? statusStyles.Success.backgroundImage :
//                                             statusStyles.Error.status.includes(resourceStatus.currentStatus) ? statusStyles.Error.backgroundImage :
//                                             statusStyles.Pending.status.includes(resourceStatus.currentStatus) ? statusStyles.Pending.backgroundImage : 'none', // Fallback
//                                         borderBottomLeftRadius: '4px', // Match container radius
//                                         borderBottomRightRadius: '4px',
//                                     }}
//                                 >
//                                     <Box sx={{ display: "flex", alignItems: "center", fontSize: '20px', mr: 1 }}> {/* Icon size */}
//                                         {
//                                             (statusStyles.Loading.status.includes(resourceStatus.currentStatus)) ? statusStyles.Loading.icon :
//                                             statusStyles.Success.status.includes(resourceStatus.currentStatus) ? statusStyles.Success.icon :
//                                             statusStyles.Error.status.includes(resourceStatus.currentStatus) ? statusStyles.Error.icon :
//                                             statusStyles.Pending.status.includes(resourceStatus.currentStatus) ? statusStyles.Pending.icon : null
//                                         }
//                                     </Box>
//                                     <Typography fontSize="14px" fontFamily="Gilroy-SemiBold"> {/* Adjusted font */}
//                                         {/* Show specific status text or a generic loading message */}
//                                         {statusStyles.Loading.status.includes(resourceStatus.currentStatus) ? "Processing..." : resourceStatus.currentStatus}
//                                     </Typography>
//                                 </Box>
//                              )}
//                              {/* --- End Status Bar --- */}
//                         </Box>
//                     </Grid>

//                      {/* --- Applications Section --- */}
//                     <Grid item xs={12} md={9}> {/* Adjusted grid size */}
//                         <Box
//                             bgcolor="white"
//                             // minHeight="100%" // Remove minHeight if not needed, let content define height
//                             display="flex"
//                             flexDirection="column"
//                             m={2}
//                             borderRadius="8px"
//                             sx={{ height: 'calc(100% - 32px)' }} // Match height of the left panel if desired
//                         >
//                             <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={2}> {/* Adjust padding */}
//                                 <Typography fontFamily="Gilroy-SemiBold" fontSize="16px">
//                                     {`APPLICATIONS (${cluster.applications?.length || 0})`}
//                                 </Typography>
//                                 {cluster.status === 'active' && ( // Only show Add button for active clusters
//                                     <Button
//                                         sx={{
//                                             backgroundColor: "black",
//                                             color: "white",
//                                             // fontWeight: "bold", // Use default or Gilroy-SemiBold
//                                             fontFamily: "Gilroy-SemiBold",
//                                             "&:hover": {
//                                                 backgroundColor: "#333", // Darker hover
//                                                 // color: "black",
//                                                 // borderColor: "black",
//                                             },
//                                             textTransform: "none",
//                                             px: 2,
//                                             py: 0.5, // Adjust padding
//                                             // mr: 2,
//                                         }}
//                                         // Disable based on role AND if there are no application owners defined
//                                         disabled={
//                                             !user.roles?.some((e: string) => ["application_owner"].includes(e)) ||
//                                             !cluster.applicationRequesters || cluster.applicationRequesters.length === 0
//                                         }
//                                         variant="contained"
//                                         size="medium" // Adjust size
//                                         onClick={() => navigate("/applications/add", { state: { clusterId: cluster.id, clusterName: cluster.clusterName } })} // Pass cluster info
//                                     >
//                                         Add New Application
//                                     </Button>
//                                 )}
//                             </Box>
//                             <Divider />
//                             {/* --- Applications List/Empty State Area --- */}
//                             <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}> {/* Scrollable content */}
//                                 {cluster.status === "active" &&
//                                 (!cluster.applications || cluster.applications?.length === 0) ? (
//                                     // --- Empty State for Active Cluster ---
//                                     <Box
//                                         display="flex"
//                                         flexDirection="column"
//                                         flex={1}
//                                         alignItems="center"
//                                         justifyContent="center"
//                                         sx={{ height: '100%', p: 3 }} // Center content vertically & add padding
//                                     >
//                                         <img src="/assets/inbox-icon.svg" alt="No Applications" style={{ marginBottom: '16px', width: '80px' }} />
//                                         <Typography
//                                             gutterBottom
//                                             fontFamily="Gilroy-Bold"
//                                             fontSize="16px"
//                                             textAlign="center"
//                                         >
//                                             No applications added yet
//                                         </Typography>
//                                         <Typography
//                                             fontFamily="Gilroy-Regular"
//                                             fontSize="14px"
//                                             textAlign="center"
//                                             color="text.secondary"
//                                             mb={2}
//                                             maxWidth="450px" // Limit text width
//                                         >
//                                             Click the button above to add a new application, or ask an assigned application owner to add one.
//                                         </Typography>
//                                          {/* Button is already present above, no need to repeat unless different logic */}
//                                     </Box>
//                                 ) : cluster.status === "active" &&
//                                 cluster.applications &&
//                                 cluster.applications?.length > 0 ? (
//                                      // --- List of Applications ---
//                                     <Box
//                                         display="flex"
//                                         flexDirection="column"
//                                         flex={1}
//                                         // sx={{ p: 2, bgcolor: "#FFFFFF" }} // Padding moved to parent Box
//                                     >
//                                         {cluster.applications.map((application: any, index: number) => (
//                                             <Accordion
//                                                 key={application.id || index} // Use stable key
//                                                 elevation={0}
//                                                 sx={{
//                                                     borderRadius: "8px",
//                                                     mb: 2, // Use theme spacing if possible
//                                                     "&:before": {
//                                                         display: "none",
//                                                     },
//                                                     bgcolor: "white",
//                                                     border: "1px solid #eee", // Use border instead of outline
//                                                 }}
//                                             >
//                                                 <AccordionSummary expandIcon={<ExpandMore />}> {/* Use standard icon */}
//                                                     {/* <Box
//                                                         sx={{
//                                                             display: "flex",
//                                                             alignItems: "center",
//                                                             justifyContent: "flex-start",
//                                                             width: '100%' // Ensure full width
//                                                         }}
//                                                     > */}
//                                                         {/* <Box p={1} bgcolor="#F2F2F2" borderRadius={1} mr={2}>
//                                                             <ExpandMore /> Removed custom expand icon holder
//                                                         </Box> */}
//                                                         <Box>
//                                                             <Typography fontSize="14px" fontFamily="Gilroy-SemiBold">
//                                                                 {application.applicationName}
//                                                             </Typography>
//                                                             <Typography fontSize="12px" fontFamily="Gilroy-Regular" color="text.secondary">
//                                                                 Created: {application.createdAt ? moment(
//                                                                     new Date(Number(application.createdAt)).toISOString()
//                                                                 ).format("DD/MM/YYYY | hh:mm A") : 'N/A'}
//                                                             </Typography>
//                                                         </Box>
//                                                         {/* Optional: Add status Chip here */}
//                                                     {/* </Box> */}
//                                                 </AccordionSummary>
//                                                 <AccordionDetails sx={{ pt: 0 }}> {/* Remove top padding */}
//                                                     <Divider sx={{ mb: 2 }}/>
//                                                      <Grid container spacing={2}> {/* Use spacing */}
//                                                          {/* ... Application Details Grid Items ... */}
//                                                          <Grid item xs={6} sm={4} md={2.4}>
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                                 Cluster Name
//                                                             </Typography>
//                                                             <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" noWrap>
//                                                                 {cluster.clusterName}
//                                                             </Typography>
//                                                         </Grid>
//                                                          <Grid item xs={6} sm={4} md={2.4}>
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                                 Environment
//                                                             </Typography>
//                                                             <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                                 {application.environment}
//                                                             </Typography>
//                                                         </Grid>
//                                                         <Grid item xs={12} sm={4} md={2.4}>
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                                 Application Owner
//                                                             </Typography>
//                                                             <Box display="flex" alignItems="center" justifyContent="flex-start">
//                                                                 <Avatar
//                                                                     sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
//                                                                     src={application.applicationOwner?.googleProfilePicture}
//                                                                     alt={application.applicationOwner?.name?.charAt(0)}
//                                                                 />
//                                                                 <Typography fontFamily="Gilroy-Semibold" fontSize="14px" noWrap>
//                                                                     {application.applicationOwner?.name || 'N/A'}
//                                                                 </Typography>
//                                                             </Box>
//                                                         </Grid>
//                                                          <Grid item xs={12} sm={6} md={4.8}> {/* Adjusted grid size */}
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>
//                                                                 Application Viewers
//                                                             </Typography>
//                                                              <Box display="flex" flexWrap="wrap" gap={0.5}>
//                                                                 {application.gcpApplicationViewers?.length > 0 ? application.gcpApplicationViewers.map((e: string, idx: number) => (
//                                                                     <Tooltip title={e} key={idx}>
//                                                                         <Avatar
//                                                                             sx={{ height: "20px", width: "20px" }}
//                                                                             src={e} alt={e}
//                                                                         />
//                                                                     </Tooltip>
//                                                                 )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                                             </Box>
//                                                         </Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}> {/* Adjusted grid size */}
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>
//                                                                 Service Owners
//                                                             </Typography>
//                                                             <Box display="flex" flexWrap="wrap" gap={0.5}>
//                                                                  {application.serviceRequesters?.length > 0 ? application.serviceRequesters.map((e: string, idx: number) => (
//                                                                     <Tooltip title={e} key={idx}>
//                                                                         <Avatar
//                                                                             sx={{ height: "20px", width: "20px" }}
//                                                                             src={e} alt={e}
//                                                                         />
//                                                                     </Tooltip>
//                                                                 )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                                             </Box>
//                                                         </Grid>
//                                                         <Grid item xs={12} sm={6} md={4.8}> {/* Adjusted grid size */}
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px" mb={0.5}>
//                                                                 Tags/Label
//                                                             </Typography>
//                                                             <Box display="flex" flexWrap="wrap" gap={0.75}>
//                                                                  {application.costLabelPairs?.length > 0 ? application.costLabelPairs.map((e: any, idx: number) => (
//                                                                     <Chip
//                                                                         key={idx}
//                                                                         size="small"
//                                                                         sx={{ bgcolor: "#F0F0F0", fontFamily: "Gilroy-Regular", fontSize: "12px" }}
//                                                                         label={`${e.cost} • ${e.label}`}
//                                                                     />
//                                                                 )) : <Typography fontSize="12px" color="text.secondary">None</Typography>}
//                                                             </Box>
//                                                         </Grid>
//                                                         <Grid item xs={6} sm={4} md={2.4}>
//                                                             <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                                                                 Micro-Services
//                                                             </Typography>
//                                                             <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//                                                                 {`${application?.services?.length || 0}`}
//                                                             </Typography>
//                                                         </Grid>
//                                                         {/* TODO: Add Link to application details page? */}
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         ))}
//                                     </Box>
//                                 ) : (
//                                     // --- Empty State for Non-Active Cluster ---
//                                      <Box
//                                         display="flex"
//                                         flexDirection="column"
//                                         flex={1}
//                                         alignItems="center"
//                                         justifyContent="center"
//                                         sx={{ height: '100%', p: 3 }} // Center content vertically
//                                     >
//                                         <img src="/assets/inbox-reject-icon.svg" alt="Application addition not allowed" style={{ marginBottom: '16px', width: '80px' }}/>
//                                         <Typography
//                                             gutterBottom
//                                             fontFamily="Gilroy-Bold"
//                                             fontSize="16px"
//                                             textAlign="center"
//                                         >
//                                             Application addition not allowed
//                                         </Typography>
//                                         <Paper
//                                             elevation={0}
//                                             sx={{
//                                                 bgcolor: cluster.status === "rejected" ? "#FEECEB" : "#FEFBE8", // Background based on status
//                                                 border: `1px solid ${cluster.status === "rejected" ? "#F04438" : "#FDB022"}`, // Border based on status
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 p: 1.5, // Adjust padding
//                                                 maxWidth: '500px', // Limit width
//                                             }}
//                                         >
//                                              <img src="/assets/info-circle.svg" alt="info" style={{ marginRight: '8px', width: '20px' }}/>
//                                             <Typography fontFamily="Gilroy-Regular" fontSize="14px">
//                                                 {cluster.status === "rejected"
//                                                     ? "This cluster request was rejected. Adding applications is not possible."
//                                                     : "This cluster is pending approval. Once approved, you can add applications."}
//                                                     {cluster.reasonForRejection && cluster.status === "rejected" && (
//                                                         <Typography component="span" display="block" mt={1} fontSize="12px"> {/* Use span or div */}
//                                                             Reason: {cluster.reasonForRejection}
//                                                         </Typography>
//                                                     )}
//                                             </Typography>
//                                         </Paper>
//                                     </Box>
//                                 )}
//                             </Box>
//                             {/* --- End Applications List/Empty State Area --- */}
//                         </Box>
//                     </Grid>
//                     {/* --- End Applications Section --- */}
//                 </Grid>
//             )}

//              {/* --- Security Checks Modal --- */}
//             <Dialog open={isSecurityModalOpen} onClose={handleCloseSecurityModal} maxWidth="xs" fullWidth>
//                 <DialogTitle sx={{ fontFamily: "Gilroy-Bold" }}>
//                      <Box display="flex" alignItems="center" gap={1}>
//                         <SecurityIcon /> Security Check Options
//                      </Box>
//                  </DialogTitle>
//                 <DialogContent dividers>
//                     <List disablePadding>
//                         {checkovSummary && (
//                             <ListItemButton
//                                 // Make it clickable
//                                 onClick={handleNavigateToCheckov}
//                                 sx={{ borderRadius: '4px', mb: 1, '&:hover': { bgcolor: 'action.hover' } }}
//                             >
//                                  <ListItemIcon>
//                                     <CheckCircleOutlineIcon color="success" />
//                                  </ListItemIcon>
//                                  <ListItemText
//                                      primary="View Checkov Results"
//                                      secondary={`Passed: ${checkovSummary.passed}, Failed: ${checkovSummary.failed}`}
//                                      primaryTypographyProps={{ fontFamily: "Gilroy-SemiBold" }}
//                                      secondaryTypographyProps={{ fontFamily: "Gilroy-Regular" }}
//                                  />
//                                  {checkovSummary.failed > 0 && (
//                                     <ListItemIcon sx={{ minWidth: 'auto', color: 'error.main' }}>
//                                         <ErrorOutlineIcon />
//                                     </ListItemIcon>
//                                  )}
//                              </ListItemButton>
//                         )}
//                         {kyvernoPolicyCount !== null && (
//                             <ListItemButton
//                                  // Make it clickable
//                                 onClick={handleNavigateToKyverno}
//                                 sx={{ borderRadius: '4px', '&:hover': { bgcolor: 'action.hover' } }}
//                             >
//                                  <ListItemIcon>
//                                      <PolicyIcon color="info"/>
//                                  </ListItemIcon>
//                                  <ListItemText
//                                      primary="View Kyverno Policies"
//                                      secondary={`Total Policies Applied: ${kyvernoPolicyCount}`}
//                                      primaryTypographyProps={{ fontFamily: "Gilroy-SemiBold" }}
//                                      secondaryTypographyProps={{ fontFamily: "Gilroy-Regular" }}
//                                  />
//                             </ListItemButton>
//                         )}
//                          {!checkovSummary && kyvernoPolicyCount === null && (
//                             <Typography color="text.secondary" textAlign="center" fontFamily="Gilroy-Regular">
//                                 No specific results loaded.
//                              </Typography>
//                          )}
//                     </List>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleCloseSecurityModal} sx={{ fontFamily: "Gilroy-SemiBold", textTransform: 'none' }}>
//                         Close
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//              {/* --- End Security Checks Modal --- */}

//         </Container>
//     );
// };

// export default ClusterDetailsPage;
// import React, { useState } from "react";
// import {
// 	Box,
// 	Button,
// 	Container,
// 	Grid,
// 	TextField,
// 	Typography,
// 	MenuItem,
// 	IconButton,
// 	Breadcrumbs,
// 	Link,
// 	Divider,
// 	Autocomplete,
// 	Avatar,
// 	Tooltip,
// 	Chip,
// 	Paper,
// 	Accordion,
// 	AccordionSummary,
// 	AccordionDetails,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate, useParams } from "react-router-dom";
// import queryGraphql from "../../helpers/ApiInterface";
// import { useAuth } from "../../helpers/AuthProvider";
// import moment from "moment";
// import { ExpandMore } from "@mui/icons-material";
// import { RiRestartLine } from "react-icons/ri";
// import { RiCheckLine } from "react-icons/ri";
// import { RiCloseLine } from "react-icons/ri";
// import { RiHourglass2Line } from "react-icons/ri";

// const statusStyles = {
//     Loading: {
//         backgroundImage: 'linear-gradient(to left, rgba(24, 24, 24, 0), rgba(24, 24, 24, 0.1))',
// 		icon:<RiRestartLine/>,
// 		status: ['active', 'pending','rejected']
//     },
//     Success: {
//         backgroundImage: 'linear-gradient(to left, rgba(18, 183, 106, 0), rgba(18, 183, 106, 0.1))',
// 		icon:<RiCheckLine/>,
// 		status: ['Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Cluster Created','Infra Audit Successful']
//     },
// 	Error: {
//         backgroundImage: 'linear-gradient(to left, rgba(240, 68, 56, 0), rgba(240, 68, 56, 0.1))',
// 		icon:<RiCloseLine/>,
// 		status: ['Plan Failed','Cluster Creation Failed','Infra Audit Failed'],
//     },
// 	Pending: {
//         backgroundImage: 'linear-gradient(to left, rgba(253, 176, 34, 0), rgba(253, 176, 34, 0.1))',
// 		icon:<RiHourglass2Line/>,
// 		status: ['MR Approval Pending'],
//     },

// }

// const ClusterDetailsPage: React.FC = () => {
// 	const navigate = useNavigate();
// 	const { user } = useAuth();
// 	const { id } = useParams();
// 	// const [clusterStatus,setClusterStatus] = useState<any>({});
// 	const [resourceStatus, setResourceStatus] = useState<any>({});
// 	const [cluster, setCluster] = useState<any>({});
	
// 	React.useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const data = await queryGraphql(
// 					`
//                         query($clusterId: String!){
//                         cluster(id:$clusterId) {
// 						id,
//                         clusterName,
//                         clusterOwner{
//                         id,
//                         name,
//                         googleProfilePicture
//                         },
//                         gcpProjectId,
//                         environment,
//                         region,
//                         clusterSize,
//                         clusterType,
//                         gcpClusterViewers,
//                         applicationRequesters,
//                         costLabelPairs{
//                         cost,
//                         label
//                         },
//                         status,
//                         createdAt,
// 						actionedAt,
// 						clusterNamePrefix,
// 						vpcProjectId,
// 						network,
// 						nodeSubnet,
// 						nodeSubnetRange,
// 						secondaryPodRange,
// 						secondaryServiceRange,
// 						releaseChannel,
// 						kubernetesVersion,
// 						reasonForRejection,
// 						applications{
// 						id,
// 						applicationName,
// 						environment,
// 						costLabelPairs{
// 						cost,
// 						label
// 						},
// 						status,
// 						createdAt,
// 						gcpApplicationViewers,
// 						serviceRequesters,
// 						applicationOwner{
// 						id,
// 						name,
// 						email,
// 						googleProfilePicture
// 						}
// 						services {
// 							id,
// 							serviceName
// 						}

// 						}
//                         }
//                         }
// `,
// 					{ clusterId: id }
// 				);
// 				if (data.cluster) {
// 					console.dir(data.cluster);
// 					setCluster(data.cluster);
// 				}
// 			} catch (error) {
// 				console.log(error);
// 			}
// 		};

// 		fetchData();
// 	}, []);


// 	React.useEffect(()=>{
// 		const fetchData = async () =>{
// 			try{
// 				const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
//   resourceStatus(id: $resourceStatusId) {
//     id
//     resourceId
//     resourceName
//     currentStatus
//     resourceType
//     resourceEnvironment
//     resourceOwner {
//       id
//       name
//     }
//     projectUrl
//     gcpClusterUrl
//     argoCdStaticUrl
//     subGroupProjectAppUrl
//     subGroupProjectInfraUrl
//     createdAt
//     updatedAt
//   }
// }`, {resourceStatusId: id});
// if(data.resourceStatus){
// 	// console.dir(data.cluster);
// 	setResourceStatus(data.resourceStatus);
	
// }
// 			}
// 			catch(error){
// 				console.log(error);
// 			}
// 		}
// 		fetchData();
// 	},[]);

// // 	React.useEffect(()=>{
// // 		const fetchData = async () =>{
// // 			try{
// // 				const data = await queryGraphql(`query ClusterStatus($clusterStatusId: String!) {
// //   clusterStatus(id: $clusterStatusId) {
// //     id
// //     clusterId
// //     currentStatus
// //     projectUrl
// //     gcpClusterUrl
// //     argoCdStaticUrl
// //     subGroupProjectAppUrl
// // 	subGroupProjectInfraUrl
// //     createdAt
// //     updatedAt
// //   }
// // }`, {clusterStatusId: id});
// // if(data.clusterStatus){
// // 	// console.dir(data.cluster);
// // 	setClusterStatus(data.clusterStatus);
// // }
// // 			}
// // 			catch(error){
// // 				console.log(error);
// // 			}
// // 		}
// // 		fetchData();
// // 	},[]);
// 	return (
// 		// <Container maxWidth={false} sx={{ padding: "24px", bgcolor: "#fafafa" }}>
// 		<Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>
// 			<Box sx={{ p: 2, bgcolor: "#fff" }}>
// 				<Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
// 					<Link underline="hover" color="inherit" href="/clusters">
// 						Clusters
// 					</Link>
// 					<Typography color="text.primary">Cluster Details</Typography>
// 				</Breadcrumbs>
// 				<Box display="flex" alignItems="center" mt={1}>
// 					<IconButton
// 						edge="start"
// 						aria-label="back"
// 						color="inherit"
// 						onClick={() => navigate("/clusters")}
// 					>
// 						<ArrowBackIosNewIcon fontSize="small" />
// 					</IconButton>
// 					<Typography fontFamily="Gilroy-Bold" fontSize="18px">
// 						Cluster Details
// 					</Typography>
// 				</Box>
// 			</Box>
// 			{cluster.id && (
// 				<Grid container>
// 					<Grid item xs={3}>
// 						<Box m={2} bgcolor="white" borderRadius="4px">
// 							<Box
// 								bgcolor={
// 									cluster.status == "active"
// 										? "#12B76A10"
// 										: cluster.status == "rejected"
// 										? "#F0443810"
// 										: "#FDB02210"
// 								}
// 								p={3}
// 							>
// 								<Box display="flex" justifyContent="space-between" alignItems="flex-start" sx={{ display: "flex", alignItems: "right-align" }}>
// 									<Typography fontFamily="Gilroy-Bold" fontSize="20px">
// 										{cluster.clusterName}
// 									</Typography>
// 									{cluster.status == "pending" &&
// 										user.roles?.some((e: string) => ["cluster_owner"].includes(e)) && (
// 											<IconButton
// 												edge="start"
// 												aria-label="back"
// 												color="inherit"
// 												onClick={() => navigate(`/clusters/edit/${cluster.id}`)}
// 											>
// 												<img width="20px" height="20px" src="/assets/edit-icon.svg" />
// 											</IconButton>
// 										)}

// 										{/* <Box sx={{ display: "flex", alignItems: "center" }}>
// 										<img
// 											src={
// 												cluster.status == "active"
// 													? "/assets/tickcircle.svg"
// 													: cluster.status == "rejected"
// 													? "/assets/reject.svg"
// 													: "/assets/clock.svg"
// 											}
// 											alt="Icon"
// 											style={{ width: "14px", marginRight: "2px" }}
// 										/>
// 										<Typography
// 											fontSize="12px"
// 											fontFamily="Gilroy-Regular"
// 											color={
// 												cluster.status == "active"
// 													? "#12B76A"
// 													: cluster.status == "rejected"
// 													? "#F04438"
// 													: "#FDB022"
// 											}
											
// 										>
// 											{cluster.status == "active"
// 												? "Active"
// 												: cluster.status == "rejected"
// 												? "Rejected"
// 												: "Pending Approval"}
// 										</Typography>
// 									</Box> */}
// 								</Box>
// 								<Box display="flex" justifyContent="space-between" alignItems="center">
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										{moment(new Date(Number(cluster.createdAt)).toISOString()).format(
// 											"DD/MM/YYYY | hh:mm A"
// 										)}
// 									</Typography>
// 									{/* <Box sx={{ display: "flex", alignItems: "center" }}>
// 										<img
// 											src={
// 												cluster.status == "active"
// 													? "/assets/tickcircle.svg"
// 													: cluster.status == "rejected"
// 													? "/assets/reject.svg"
// 													: "/assets/clock.svg"
// 											}
// 											alt="Icon"
// 											style={{ width: "14px", marginRight: "2px" }}
// 										/>
// 										<Typography
// 											fontSize="12px"
// 											fontFamily="Gilroy-Regular"
// 											color={
// 												cluster.status == "active"
// 													? "#12B76A"
// 													: cluster.status == "rejected"
// 													? "#F04438"
// 													: "#FDB022"
// 											}
// 										>
// 											{cluster.status == "active"
// 												? "Active"
// 												: cluster.status == "rejected"
// 												? "Rejected"
// 												: "Pending Approval"}
// 										</Typography>
// 									</Box> */}
// 											<Box sx={{ display: "flex", alignItems: "center" }}>
// 										<img
// 											src={
// 												cluster.status == "active"
// 													? "/assets/tickcircle.svg"
// 													: cluster.status == "rejected"
// 													? "/assets/reject.svg"
// 													: "/assets/clock.svg"
// 											}
// 											alt="Icon"
// 											style={{ width: "14px", marginRight: "2px" }}
// 										/>
// 										<Typography
// 											fontSize="12px"
// 											fontFamily="Gilroy-Regular"
// 											color={
// 												cluster.status == "active"
// 													? "#12B76A"
// 													: cluster.status == "rejected"
// 													? "#F04438"
// 													: "#FDB022"
// 											}
											
// 										>
// 											{cluster.status == "active"
// 												? "Active"
// 												: cluster.status == "rejected"
// 												? "Rejected"
// 												: "Pending Approval"}
// 										</Typography>
// 									</Box>
// 								</Box>
// 							</Box>

// 							<Box sx={{maxHeight:'67vh',overflowY: "auto"}}>

// 							<Grid container gap={1} p={3}>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										GCP Project ID
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.gcpProjectId}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Owner
// 									</Typography>
// 									<Box display="flex" alignItems="center" justifyContent="flex-start">
// 										<Avatar
// 											sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 											src={cluster.clusterOwner?.googleProfilePicture}
// 										/>
// 										<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
// 											{cluster.clusterOwner?.name}
// 										</Typography>
// 									</Box>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Environment
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.environment}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Region
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.region}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Size
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.clusterSize}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Type
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.clusterType}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Viewers
// 									</Typography>
// 									<Box display="flex" alignItems="center" justifyContent="flex-start">
// 										{cluster.gcpClusterViewers?.map((e: string) => {
// 											return (
// 												<Tooltip title={e}>
// 													<Avatar
// 														sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 														src={e}
// 														alt={e}
// 													/>
// 												</Tooltip>
// 											);
// 										})}
// 									</Box>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Application Owners
// 									</Typography>
// 									<Box display="flex" alignItems="center" justifyContent="flex-start">
// 										{cluster.applicationRequesters?.map((e: string) => {
// 											return (
// 												<Tooltip title={e}>
// 													<Avatar
// 														sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 														src={e}
// 														alt={e}
// 													/>
// 												</Tooltip>
// 											);
// 										})}
// 									</Box>
// 								</Grid>
// 								<Grid mb={2} item xs={11}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Tags/Label
// 									</Typography>
// 									<Grid container ml={-0.5} gap={0.75}>
// 										{cluster.costLabelPairs?.map((e: any) => {
// 											return (
// 												<Grid item>
// 													<Chip
// 														size="small"
// 														sx={{
// 															bgcolor: "#10101010",
// 															border: "1px solid black",
// 															mr: 0.75,
// 															fontFamily: "Gilroy-Regular",
// 															fontSize: "12px",
// 														}}
// 														variant="filled"
// 														label={`${e.cost} • ${e.label}`}
// 													/>
// 												</Grid>
// 											);
// 										})}
// 									</Grid>
// 								</Grid>
// 							</Grid>

// 							{cluster.status == "active" && (
// 								<>
// 									<Divider sx={{ mb: 3, mx: 3 }} />
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" ml={3} mt={2}>
// 										Cloud Infra Details
// 									</Typography>
// 									<Grid container gap={1} p={3}>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster Name Prefix 
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.clusterNamePrefix} 
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												VPC Project ID
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.vpcProjectId}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Network
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.network}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Node Subnet
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.nodeSubnet}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Master CIDR Range
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.nodeSubnetRange}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Release Channel
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.releaseChannel}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Secondary Range Name for Pods
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.secondaryPodRange}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Secondary Range Name for Services
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.secondaryServiceRange}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Kubernetes Version
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.kubernetesVersion}
// 											</Typography>
// 										</Grid>

// 										{/* <Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={clusterStatus.gcpClusterUrl} target="_blank" rel="noopener noreferrer">
//       													{clusterStatus.gcpClusterUrl}
													
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Project URL
// 											</Typography>

// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={`${clusterStatus.projectUrl}`} target="_blank" rel="noopener noreferrer">
//       													{`${clusterStatus.projectUrl}`}
													
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>

// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												ArgoCD URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={clusterStatus.argoCdStaticUrl} target="_blank" rel="noopener noreferrer">
//       													{clusterStatus.argoCdStaticUrl}
														
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project App URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={`${clusterStatus.subGroupProjectAppUrl}`} target="_blank" rel="noopener noreferrer">
//       													{`${clusterStatus.subGroupProjectAppUrl}`}
														
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project Infra URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={`${clusterStatus.subGroupProjectInfraUrl}`} target="_blank" rel="noopener noreferrer">
//       													{`${clusterStatus.subGroupProjectInfraUrl}`}
														
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid> */}

// 										<Grid mb={2} item xs={5.75} >
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px" >
// 												Infra URLs
// 											</Typography>
											
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
// 											5
// 											<Tooltip 
// 												sx={{ whiteSpace: "pre-line" }}
// 												// title={cluster.applications?.map(
// 												// 	(e: any, index: number) => `${e.applicationName}`
// 												// )}
// 												title={
// 													<>
// 													<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>

// 														List of Infra URLs
// 													</Typography>
// 														<br />
// 														{resourceStatus.resourceId === id && resourceStatus.gcpClusterUrl ? (
//     <Link
//         href={resourceStatus.gcpClusterUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Cluster URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Cluster URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.gcpClusterUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.gcpClusterUrl.substring(0,10)}...`} 
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 														<br/>
// 														{resourceStatus.resourceId === id && resourceStatus.projectUrl ? (
//     <Link
//         href={resourceStatus.projectUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Project URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Project URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Project URL
// 											</Typography>

// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.projectUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.projectUrl.substring(0,10)}...`}
													
// 													 </Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.argoCdStaticUrl ? (
//     <Link
//         href={resourceStatus.argoCdStaticUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             ArgoCD URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         ArgoCD URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												ArgoCD URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.argoCdStaticUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.argoCdStaticUrl.substring(0,10)}...`} 
													
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectAppUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectAppUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project App URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         Sub Group Project App URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project App URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.subGroupProjectAppUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.subGroupProjectAppUrl.substring(0,10)}...`} 
// 													</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectInfraUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectInfraUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project Infra URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Sub Group Project Infra URL

//     </Typography>
// )}

// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project Infra URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (

// 										<Link href={resourceStatus.subGroupProjectInfraUrl} 
// 											target="_blank" rel="noopener noreferrer" sx={{textDecoration: 'underline', color: '#FFFFFF' }}> 
// 											{`${resourceStatus.subGroupProjectInfraUrl.substring(0,10)}...`} 
										
// 											</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}


// 													</>
// 												}
// 												slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
// 											>
// 												<Avatar
// 													src="/assets/info.svg"
// 													alt="info"
// 													sx={{ height: 16, width: 16, marginLeft: "4px" }}
// 												/>
												
// 											</Tooltip>
// 													</Typography>
// 										</Grid>

						


// 									</Grid>
									

// 								</>
// 							)}
							
// 							</Box>	
// 							<Grid  item xs={11.75} sx={{display:"flex", alignItems:"space-between", backgroundImage: (statusStyles.Loading.status.includes(resourceStatus.currentStatus)) ? statusStyles.Loading.backgroundImage :  statusStyles.Success.status.includes(resourceStatus.currentStatus) ? statusStyles.Success.backgroundImage :  statusStyles.Error.status.includes(resourceStatus.currentStatus) ? statusStyles.Error.backgroundImage : statusStyles.Pending.backgroundImage 
										
// 									}} >

// 										<Box   sx={{mx:3, my:1 }}> <Typography fontSize="18px" width= "300px"  sx={{display:"flex", alignItems:"center"}}> <>{ (statusStyles.Loading.status.includes(resourceStatus.currentStatus)) ? statusStyles.Loading.icon : statusStyles.Success.status.includes(resourceStatus.currentStatus) ? statusStyles.Success.icon : statusStyles.Error.status.includes(resourceStatus.currentStatus) ? statusStyles.Error.icon : statusStyles.Pending.icon  } </> <Typography sx={{ml:1}}>{(statusStyles.Loading.status.includes(resourceStatus.currentStatus))? null :resourceStatus.currentStatus}</Typography>  </Typography>
// 										</Box>


// 									</Grid>	
// 						</Box>
// 					</Grid>
// 					<Grid item xs={9}>
// 						<Box
// 							bgcolor="white"
// 							minHeight="100%"
// 							display="flex"
// 							flexDirection="column"
// 							m={2}
// 							borderRadius="8px"
// 						>
// 							<Box display="flex" alignItems="center" justifyContent="space-between">
// 								<Typography fontFamily="Gilroy-SemiBold" fontSize="16px" px={2} py={3}>
// 									{`APPLICATIONS (${cluster.applications?.length || 0})`}
// 								</Typography>
// 								{cluster.applications && cluster.applications?.length > 0 && (
// 									<Button
// 										sx={{
// 											backgroundColor: "black",
// 											color: "white",
// 											fontWeight: "bold",
// 											"&:hover": {
// 												backgroundColor: "white",
// 												color: "black",
// 												borderColor: "black",
// 											},
// 											textTransform: "none",
// 											px: 2,
// 											py: 0.5,
// 											mr: 2,
// 										}}
// 										disabled={!user.roles?.some((e: string) => ["application_owner"].includes(e))}
// 										variant="contained"
// 										size="large"
// 										onClick={() => navigate("/applications/add")}
// 									>
// 										Add New Application
// 									</Button>
// 								)}
// 							</Box>
// 							<Divider />
// 							<Box sx={{maxHeight:'80vh', overflow:'auto'}}>
// 							{cluster.status == "active" &&
// 							(!cluster.applications || cluster.applications?.length == 0) ? (
// 								<Box
// 									sx={{
// 										position: "relative",
// 										top: "50%",
// 										left: "50%",
// 										transform: "translate(-50%, -10%)",
// 										width: "700px",
// 									}}
// 									display="flex"
// 									flexDirection="column"
// 									flex={1}
// 									alignItems="center"
// 									justifyContent="center"
// 								>
// 									<img src="/assets/inbox-icon.svg" alt="empty" />
// 									<Typography
// 										gutterBottom
// 										fontFamily="Gilroy-Bold"
// 										fontSize="16px"
// 										px={2}
// 										textAlign="center"
// 									>
// 										No applications are added yet
// 									</Typography>
// 									<Typography
// 										fontFamily="Gilroy-Regular"
// 										fontSize="14px"
// 										px={2}
// 										mb={2}
// 										textAlign="center"
// 									>
// 										Click below button to start adding applications or ask the application owner to
// 										add.
// 									</Typography>
// 									<Button
// 										sx={{
// 											backgroundColor: "black",
// 											color: "white",
// 											fontWeight: "bold",
// 											"&:hover": {
// 												backgroundColor: "white",
// 												color: "black",
// 												borderColor: "black",
// 											},
// 											textTransform: "none",
// 											px: 4,
// 										}}
// 										variant="contained"
// 										size="large"
// 										disabled={!user.roles?.some((e: string) => ["application_owner"].includes(e))}
// 										onClick={() => navigate("/applications/add")}
// 									>
// 										Add New Application
// 									</Button>
// 								</Box>
// 							) : cluster.status == "active" &&
// 							  cluster.applications &&
// 							  cluster.applications?.length > 0 ? (
// 								<Box
// 									display="flex"
// 									flexDirection="column"
// 									flex={1}
// 									sx={{ p: 2, bgcolor: "#FFFFFF" }}
// 								>
// 									{cluster.applications.map((application: any, index: number) => {
// 										return (
// 											<Accordion
// 												elevation={0}
// 												sx={{
// 													borderRadius: "8px",
// 													mb: "16px",
// 													"&:before": {
// 														display: "none",
// 													},
// 													bgcolor: "white",
// 													outline: "1px solid #eee",
// 												}}
// 											>
// 												<AccordionSummary expandIcon={null}>
// 													<Box
// 														sx={{
// 															display: "flex",
// 															alignItems: "center",
// 															justifyContent: "flex-start",
// 														}}
// 													>
// 														<Box p={1} bgcolor="#F2F2F2" borderRadius={1} mr={2}>
// 															<ExpandMore />
// 														</Box>
// 														<Box>
// 															<Typography fontSize="14px" fontFamily="Gilroy-SemiBold">
// 																{application.applicationName}
// 															</Typography>
// 															<Typography fontSize="12px" fontFamily="Gilroy-Regular">
// 																{moment(
// 																	new Date(Number(application.createdAt)).toISOString()
// 																).format("DD/MM/YYYY | hh:mm A")}
// 															</Typography>
// 														</Box>
// 													</Box>
// 												</AccordionSummary>
// 												<AccordionDetails>
// 													<Divider />
// 													<Grid container mt={2}>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Cluster Name
// 															</Typography>
// 															<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 																{cluster.clusterName}
// 															</Typography>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Environment
// 															</Typography>
// 															<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 																{application.environment}
// 															</Typography>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Application Owner
// 															</Typography>
// 															<Box display="flex" alignItems="center" justifyContent="flex-start">
// 																<Avatar
// 																	sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 																	src={application.applicationOwner?.googleProfilePicture}
// 																/>
// 																<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
// 																	{application.applicationOwner?.name}
// 																</Typography>
// 															</Box>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Application Viewers
// 															</Typography>
// 															<Box display="flex" alignItems="center" justifyContent="flex-start">
// 																{application.gcpApplicationViewers?.map((e: string) => {
// 																	return (
// 																		<Tooltip title={e}>
// 																			<Avatar
// 																				sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 																				src={e}
// 																				alt={e}
// 																			/>
// 																		</Tooltip>
// 																	);
// 																})}
// 															</Box>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Service Owners
// 															</Typography>
// 															<Box display="flex" alignItems="center" justifyContent="flex-start">
// 																{application.serviceRequesters?.map((e: string) => {
// 																	return (
// 																		<Tooltip title={e}>
// 																			<Avatar
// 																				sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 																				src={e}
// 																				alt={e}
// 																			/>
// 																		</Tooltip>
// 																	);
// 																})}
// 															</Box>
// 														</Grid>
// 														<Grid
// 															mb={2}
// 															item
// 															xs={application.costLabelPairs?.lenght > 1 ? 4.8 : 2.4}
// 														>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Tags/Label
// 															</Typography>
// 															<Grid container ml={-0.5} gap={0.75}>
// 																{application.costLabelPairs?.map((e: any) => {
// 																	return (
// 																		<Grid item>
// 																			<Chip
// 																				size="small"
// 																				sx={{
// 																					bgcolor: "#10101010",
// 																					mr: 0.75,
// 																					fontFamily: "Gilroy-Regular",
// 																					fontSize: "12px",
// 																				}}
// 																				variant="filled"
// 																				label={`${e.cost} • ${e.label}`}
// 																			/>
// 																		</Grid>
// 																	);
// 																})}
// 															</Grid>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																No. of Micro-Services
// 															</Typography>
// 															<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 																{`${application?.services?.length || 0}`}
																
// 															</Typography>
// 														</Grid>
// 													</Grid>
// 												</AccordionDetails>
// 											</Accordion>
// 										);
// 									})}
// 								</Box>
// 							) : (
// 								<Box
// 									sx={{
// 										position: "relative",
// 										top: "50%",
// 										left: "50%",
// 										transform: "translate(-50%, -10%)",
// 										width: "700px",
// 									}}
// 									display="flex"
// 									flexDirection="column"
// 									flex={1}
// 									alignItems="center"
// 									justifyContent="center"
// 								>
// 									<img src="/assets/inbox-reject-icon.svg" alt="empty" />
// 									<Typography
// 										gutterBottom
// 										fontFamily="Gilroy-Bold"
// 										fontSize="16px"
// 										px={2}
// 										textAlign="center"
// 									>
// 										Application addition is not allowed
// 									</Typography>
// 									<Paper
// 										elevation={0}
// 										sx={{
// 											bgcolor: "#FDB02215",
// 											border: "1px solid #FDB022",
// 											display: "flex",
// 											alignItems: "center",
// 											p: 1,
// 										}}
// 									>
// 										<img src="/assets/info-circle.svg" />
// 										<Typography fontFamily="Gilroy-Regular" fontSize="14px" ml={1}>
// 											{cluster.status == "rejected"
// 												? "Cluster is rejected by the approver, and addition of application is no longer applicable."
// 												: "Cluster is still pending approval, once the cluster is approved you can start adding applications."}
// 										</Typography>
// 									</Paper>
// 								</Box>
// 							)}
// 							</Box>
// 						</Box>
// 					</Grid>
// 				</Grid>
// 			)}
// 		</Container>
// 	);
// };

// export default ClusterDetailsPage;



// import React, { useState } from "react";
// import {
// 	Box,
// 	Button,
// 	Container,
// 	Grid,
// 	TextField,
// 	Typography,
// 	MenuItem,
// 	IconButton,
// 	Breadcrumbs,
// 	Link,
// 	Divider,
// 	Autocomplete,
// 	Avatar,
// 	Tooltip,
// 	Chip,
// 	Paper,
// 	Accordion,
// 	AccordionSummary,
// 	AccordionDetails,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate, useParams } from "react-router-dom";
// import queryGraphql from "../../helpers/ApiInterface";
// import { useAuth } from "../../helpers/AuthProvider";
// import moment from "moment";
// import { ExpandMore } from "@mui/icons-material";
// import { RiRestartLine } from "react-icons/ri";
// import { RiCheckLine } from "react-icons/ri";
// import { RiCloseLine } from "react-icons/ri";
// import { RiHourglass2Line } from "react-icons/ri";

// const statusStyles = {
//     Loading: {
//         backgroundImage: 'linear-gradient(to left, rgba(24, 24, 24, 0), rgba(24, 24, 24, 0.1))',
// 		icon:<RiRestartLine/>,
// 		status: ['active', 'pending','rejected']
//     },
//     Success: {
//         backgroundImage: 'linear-gradient(to left, rgba(18, 183, 106, 0), rgba(18, 183, 106, 0.1))',
// 		icon:<RiCheckLine/>,
// 		status: ['Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Cluster Created','Infra Audit Successful']
//     },
// 	Error: {
//         backgroundImage: 'linear-gradient(to left, rgba(240, 68, 56, 0), rgba(240, 68, 56, 0.1))',
// 		icon:<RiCloseLine/>,
// 		status: ['Plan Failed','Cluster Creation Failed','Infra Audit Failed'],
//     },
// 	Pending: {
//         backgroundImage: 'linear-gradient(to left, rgba(253, 176, 34, 0), rgba(253, 176, 34, 0.1))',
// 		icon:<RiHourglass2Line/>,
// 		status: ['MR Approval Pending'],
//     },

// }

// const ClusterDetailsPage: React.FC = () => {
// 	const navigate = useNavigate();
// 	const { user } = useAuth();
// 	const { id } = useParams();
// 	// const [clusterStatus,setClusterStatus] = useState<any>({});
// 	const [resourceStatus, setResourceStatus] = useState<any>({});
// 	const [cluster, setCluster] = useState<any>({});
	
// 	React.useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const data = await queryGraphql(
// 					`
//                         query($clusterId: String!){
//                         cluster(id:$clusterId) {
// 						id,
//                         clusterName,
//                         clusterOwner{
//                         id,
//                         name,
//                         googleProfilePicture
//                         },
//                         gcpProjectId,
//                         environment,
//                         region,
//                         clusterSize,
//                         clusterType,
//                         gcpClusterViewers,
//                         applicationRequesters,
//                         costLabelPairs{
//                         cost,
//                         label
//                         },
//                         status,
//                         createdAt,
// 						actionedAt,
// 						clusterNamePrefix,
// 						vpcProjectId,
// 						network,
// 						nodeSubnet,
// 						nodeSubnetRange,
// 						secondaryPodRange,
// 						secondaryServiceRange,
// 						releaseChannel,
// 						kubernetesVersion,
// 						reasonForRejection,
// 						applications{
// 						id,
// 						applicationName,
// 						environment,
// 						costLabelPairs{
// 						cost,
// 						label
// 						},
// 						status,
// 						createdAt,
// 						gcpApplicationViewers,
// 						serviceRequesters,
// 						applicationOwner{
// 						id,
// 						name,
// 						email,
// 						googleProfilePicture
// 						}
// 						services {
// 							id,
// 							serviceName
// 						}

// 						}
//                         }
//                         }
// `,
// 					{ clusterId: id }
// 				);
// 				if (data.cluster) {
// 					console.dir(data.cluster);
// 					setCluster(data.cluster);
// 				}
// 			} catch (error) {
// 				console.log(error);
// 			}
// 		};

// 		fetchData();
// 	}, []);


// 	React.useEffect(()=>{
// 		const fetchData = async () =>{
// 			try{
// 				const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
//   resourceStatus(id: $resourceStatusId) {
//     id
//     resourceId
//     resourceName
//     currentStatus
//     resourceType
//     resourceEnvironment
//     resourceOwner {
//       id
//       name
//     }
//     projectUrl
//     gcpClusterUrl
//     argoCdStaticUrl
//     subGroupProjectAppUrl
//     subGroupProjectInfraUrl
//     createdAt
//     updatedAt
//   }
// }`, {resourceStatusId: id});
// if(data.resourceStatus){
// 	// console.dir(data.cluster);
// 	setResourceStatus(data.resourceStatus);
	
// }
// 			}
// 			catch(error){
// 				console.log(error);
// 			}
// 		}
// 		fetchData();
// 	},[]);

// // 	React.useEffect(()=>{
// // 		const fetchData = async () =>{
// // 			try{
// // 				const data = await queryGraphql(`query ClusterStatus($clusterStatusId: String!) {
// //   clusterStatus(id: $clusterStatusId) {
// //     id
// //     clusterId
// //     currentStatus
// //     projectUrl
// //     gcpClusterUrl
// //     argoCdStaticUrl
// //     subGroupProjectAppUrl
// // 	subGroupProjectInfraUrl
// //     createdAt
// //     updatedAt
// //   }
// // }`, {clusterStatusId: id});
// // if(data.clusterStatus){
// // 	// console.dir(data.cluster);
// // 	setClusterStatus(data.clusterStatus);
// // }
// // 			}
// // 			catch(error){
// // 				console.log(error);
// // 			}
// // 		}
// // 		fetchData();
// // 	},[]);
// 	return (
// 		// <Container maxWidth={false} sx={{ padding: "24px", bgcolor: "#fafafa" }}>
// 		<Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>
// 			<Box sx={{ p: 2, bgcolor: "#fff" }}>
// 				<Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
// 					<Link underline="hover" color="inherit" href="/clusters">
// 						Clusters
// 					</Link>
// 					<Typography color="text.primary">Cluster Details</Typography>
// 				</Breadcrumbs>
// 				<Box display="flex" alignItems="center" mt={1}>
// 					<IconButton
// 						edge="start"
// 						aria-label="back"
// 						color="inherit"
// 						onClick={() => navigate("/clusters")}
// 					>
// 						<ArrowBackIosNewIcon fontSize="small" />
// 					</IconButton>
// 					<Typography fontFamily="Gilroy-Bold" fontSize="18px">
// 						Cluster Details
// 					</Typography>
// 				</Box>
// 			</Box>
// 			{cluster.id && (
// 				<Grid container>
// 					<Grid item xs={3}>
// 						<Box m={2} bgcolor="white" borderRadius="4px">
// 							<Box
// 								bgcolor={
// 									cluster.status == "active"
// 										? "#12B76A10"
// 										: cluster.status == "rejected"
// 										? "#F0443810"
// 										: "#FDB02210"
// 								}
// 								p={3}
// 							>
// 								<Box display="flex" justifyContent="space-between" alignItems="flex-start" sx={{ display: "flex", alignItems: "right-align" }}>
// 									<Typography fontFamily="Gilroy-Bold" fontSize="20px">
// 										{cluster.clusterName}
// 									</Typography>
// 									{cluster.status == "pending" &&
// 										user.roles?.some((e: string) => ["cluster_owner"].includes(e)) && (
// 											<IconButton
// 												edge="start"
// 												aria-label="back"
// 												color="inherit"
// 												onClick={() => navigate(`/clusters/edit/${cluster.id}`)}
// 											>
// 												<img width="20px" height="20px" src="/assets/edit-icon.svg" />
// 											</IconButton>
// 										)}

// 										{/* <Box sx={{ display: "flex", alignItems: "center" }}>
// 										<img
// 											src={
// 												cluster.status == "active"
// 													? "/assets/tickcircle.svg"
// 													: cluster.status == "rejected"
// 													? "/assets/reject.svg"
// 													: "/assets/clock.svg"
// 											}
// 											alt="Icon"
// 											style={{ width: "14px", marginRight: "2px" }}
// 										/>
// 										<Typography
// 											fontSize="12px"
// 											fontFamily="Gilroy-Regular"
// 											color={
// 												cluster.status == "active"
// 													? "#12B76A"
// 													: cluster.status == "rejected"
// 													? "#F04438"
// 													: "#FDB022"
// 											}
											
// 										>
// 											{cluster.status == "active"
// 												? "Active"
// 												: cluster.status == "rejected"
// 												? "Rejected"
// 												: "Pending Approval"}
// 										</Typography>
// 									</Box> */}
// 								</Box>
// 								<Box display="flex" justifyContent="space-between" alignItems="center">
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										{moment(new Date(Number(cluster.createdAt)).toISOString()).format(
// 											"DD/MM/YYYY | hh:mm A"
// 										)}
// 									</Typography>
// 									{/* <Box sx={{ display: "flex", alignItems: "center" }}>
// 										<img
// 											src={
// 												cluster.status == "active"
// 													? "/assets/tickcircle.svg"
// 													: cluster.status == "rejected"
// 													? "/assets/reject.svg"
// 													: "/assets/clock.svg"
// 											}
// 											alt="Icon"
// 											style={{ width: "14px", marginRight: "2px" }}
// 										/>
// 										<Typography
// 											fontSize="12px"
// 											fontFamily="Gilroy-Regular"
// 											color={
// 												cluster.status == "active"
// 													? "#12B76A"
// 													: cluster.status == "rejected"
// 													? "#F04438"
// 													: "#FDB022"
// 											}
// 										>
// 											{cluster.status == "active"
// 												? "Active"
// 												: cluster.status == "rejected"
// 												? "Rejected"
// 												: "Pending Approval"}
// 										</Typography>
// 									</Box> */}
// 											<Box sx={{ display: "flex", alignItems: "center" }}>
// 										<img
// 											src={
// 												cluster.status == "active"
// 													? "/assets/tickcircle.svg"
// 													: cluster.status == "rejected"
// 													? "/assets/reject.svg"
// 													: "/assets/clock.svg"
// 											}
// 											alt="Icon"
// 											style={{ width: "14px", marginRight: "2px" }}
// 										/>
// 										<Typography
// 											fontSize="12px"
// 											fontFamily="Gilroy-Regular"
// 											color={
// 												cluster.status == "active"
// 													? "#12B76A"
// 													: cluster.status == "rejected"
// 													? "#F04438"
// 													: "#FDB022"
// 											}
											
// 										>
// 											{cluster.status == "active"
// 												? "Active"
// 												: cluster.status == "rejected"
// 												? "Rejected"
// 												: "Pending Approval"}
// 										</Typography>
// 									</Box>
// 								</Box>
// 							</Box>

// 							<Box sx={{maxHeight:'67vh',overflowY: "auto"}}>

// 							<Grid container gap={1} p={3}>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										GCP Project ID
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.gcpProjectId}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Owner
// 									</Typography>
// 									<Box display="flex" alignItems="center" justifyContent="flex-start">
// 										<Avatar
// 											sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 											src={cluster.clusterOwner?.googleProfilePicture}
// 										/>
// 										<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
// 											{cluster.clusterOwner?.name}
// 										</Typography>
// 									</Box>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Environment
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.environment}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Region
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.region}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Size
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.clusterSize}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Type
// 									</Typography>
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 										{cluster.clusterType}
// 									</Typography>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Cluster Viewers
// 									</Typography>
// 									<Box display="flex" alignItems="center" justifyContent="flex-start">
// 										{cluster.gcpClusterViewers?.map((e: string) => {
// 											return (
// 												<Tooltip title={e}>
// 													<Avatar
// 														sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 														src={e}
// 														alt={e}
// 													/>
// 												</Tooltip>
// 											);
// 										})}
// 									</Box>
// 								</Grid>
// 								<Grid mb={2} item xs={5.75}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Application Owners
// 									</Typography>
// 									<Box display="flex" alignItems="center" justifyContent="flex-start">
// 										{cluster.applicationRequesters?.map((e: string) => {
// 											return (
// 												<Tooltip title={e}>
// 													<Avatar
// 														sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 														src={e}
// 														alt={e}
// 													/>
// 												</Tooltip>
// 											);
// 										})}
// 									</Box>
// 								</Grid>
// 								<Grid mb={2} item xs={11}>
// 									<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 										Tags/Label
// 									</Typography>
// 									<Grid container ml={-0.5} gap={0.75}>
// 										{cluster.costLabelPairs?.map((e: any) => {
// 											return (
// 												<Grid item>
// 													<Chip
// 														size="small"
// 														sx={{
// 															bgcolor: "#10101010",
// 															border: "1px solid black",
// 															mr: 0.75,
// 															fontFamily: "Gilroy-Regular",
// 															fontSize: "12px",
// 														}}
// 														variant="filled"
// 														label={`${e.cost} • ${e.label}`}
// 													/>
// 												</Grid>
// 											);
// 										})}
// 									</Grid>
// 								</Grid>
// 							</Grid>

// 							{cluster.status == "active" && (
// 								<>
// 									<Divider sx={{ mb: 3, mx: 3 }} />
// 									<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" ml={3} mt={2}>
// 										Cloud Infra Details
// 									</Typography>
// 									<Grid container gap={1} p={3}>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster Name Prefix 
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.clusterNamePrefix} 
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												VPC Project ID
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.vpcProjectId}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Network
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.network}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Node Subnet
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.nodeSubnet}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Master CIDR Range
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.nodeSubnetRange}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Release Channel
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.releaseChannel}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Secondary Range Name for Pods
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.secondaryPodRange}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Secondary Range Name for Services
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.secondaryServiceRange}
// 											</Typography>
// 										</Grid>
// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Kubernetes Version
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 												{cluster.kubernetesVersion}
// 											</Typography>
// 										</Grid>

// 										{/* <Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={clusterStatus.gcpClusterUrl} target="_blank" rel="noopener noreferrer">
//       													{clusterStatus.gcpClusterUrl}
													
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Project URL
// 											</Typography>

// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={`${clusterStatus.projectUrl}`} target="_blank" rel="noopener noreferrer">
//       													{`${clusterStatus.projectUrl}`}
													
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>

// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												ArgoCD URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={clusterStatus.argoCdStaticUrl} target="_blank" rel="noopener noreferrer">
//       													{clusterStatus.argoCdStaticUrl}
														
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project App URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={`${clusterStatus.subGroupProjectAppUrl}`} target="_blank" rel="noopener noreferrer">
//       													{`${clusterStatus.subGroupProjectAppUrl}`}
														
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid>

// 										<Grid mb={2} item xs={5.75}>
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project Infra URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#0064FF' }}>
//   												{clusterStatus.clusterId === id ? (
//     												<a href={`${clusterStatus.subGroupProjectInfraUrl}`} target="_blank" rel="noopener noreferrer">
//       													{`${clusterStatus.subGroupProjectInfraUrl}`}
														
//     												</a>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography>
// 										</Grid> */}

// 										<Grid mb={2} item xs={5.75} >
// 											<Typography fontFamily="Gilroy-Regular" fontSize="12px" >
// 												Infra URLs
// 											</Typography>
											
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
// 											5
// 											<Tooltip 
// 												sx={{ whiteSpace: "pre-line" }}
// 												// title={cluster.applications?.map(
// 												// 	(e: any, index: number) => `${e.applicationName}`
// 												// )}
// 												title={
// 													<>
// 													<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>

// 														List of Infra URLs
// 													</Typography>
// 														<br />
// 														{resourceStatus.resourceId === id && resourceStatus.gcpClusterUrl ? (
//     <Link
//         href={resourceStatus.gcpClusterUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Cluster URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Cluster URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Cluster URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.gcpClusterUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.gcpClusterUrl.substring(0,10)}...`} 
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 														<br/>
// 														{resourceStatus.resourceId === id && resourceStatus.projectUrl ? (
//     <Link
//         href={resourceStatus.projectUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Project URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Project URL

//     </Typography>
// )}

// 														{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Project URL
// 											</Typography>

// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.projectUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.projectUrl.substring(0,10)}...`}
													
// 													 </Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.argoCdStaticUrl ? (
//     <Link
//         href={resourceStatus.argoCdStaticUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             ArgoCD URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         ArgoCD URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												ArgoCD URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.argoCdStaticUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline',color: '#FFFFFF' }}> 
// 													{`${resourceStatus.argoCdStaticUrl.substring(0,10)}...`} 
													
// 													</Link>
//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectAppUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectAppUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project App URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//         Sub Group Project App URL
//     </Typography>
// )}
// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project App URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (
//     												<Link href={resourceStatus.subGroupProjectAppUrl} 
// 													target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
// 													{`${resourceStatus.subGroupProjectAppUrl.substring(0,10)}...`} 
// 													</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}

// 													<br/>
// 													{resourceStatus.resourceId === id && resourceStatus.subGroupProjectInfraUrl ? (
//     <Link
//         href={resourceStatus.subGroupProjectInfraUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//             textDecoration: 'underline', // Ensure underline for link appearance
//             color: 'inherit' // Inherit color from Typography, or set explicitly if needed
//         }}
//     >
//         <Typography
//             fontFamily="Gilroy-Bold"
//             fontSize="12px"
//             // Apply link color here if 'inherit' doesn't work as expected,
//             // or if you want a specific link color different from default Typography.
//             // For example: color: '#ADD8E6' (light blue)
//         >
//             Sub Group Project Infra URL
//         </Typography>
//     </Link>
// ) : (
//     // If no link available (loading state), display the label as plain text
//     <Typography fontFamily="Gilroy-Regular" fontSize="12px">
//                     Sub Group Project Infra URL

//     </Typography>
// )}

// 													{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 												Sub Group Project Infra URL
// 											</Typography>
// 											<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
//   												{resourceStatus.resourceId === id ? (

// 										<Link href={resourceStatus.subGroupProjectInfraUrl} 
// 											target="_blank" rel="noopener noreferrer" sx={{textDecoration: 'underline', color: '#FFFFFF' }}> 
// 											{`${resourceStatus.subGroupProjectInfraUrl.substring(0,10)}...`} 
										
// 											</Link>

//   															) : (
//    														<>Loading...</>
//   																)}
// 													</Typography> */}


// 													</>
// 												}
// 												slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
// 											>
// 												<Avatar
// 													src="/assets/info.svg"
// 													alt="info"
// 													sx={{ height: 16, width: 16, marginLeft: "4px" }}
// 												/>
												
// 											</Tooltip>
// 													</Typography>
// 										</Grid>

						


// 									</Grid>
									

// 								</>
// 							)}
							
// 							</Box>	
// 							<Grid  item xs={11.75} sx={{display:"flex", alignItems:"space-between", backgroundImage: (statusStyles.Loading.status.includes(resourceStatus.currentStatus)) ? statusStyles.Loading.backgroundImage :  statusStyles.Success.status.includes(resourceStatus.currentStatus) ? statusStyles.Success.backgroundImage :  statusStyles.Error.status.includes(resourceStatus.currentStatus) ? statusStyles.Error.backgroundImage : statusStyles.Pending.backgroundImage 
										
// 									}} >

// 										<Box   sx={{mx:3, my:1 }}> <Typography fontSize="18px" width= "300px"  sx={{display:"flex", alignItems:"center"}}> <>{ (statusStyles.Loading.status.includes(resourceStatus.currentStatus)) ? statusStyles.Loading.icon : statusStyles.Success.status.includes(resourceStatus.currentStatus) ? statusStyles.Success.icon : statusStyles.Error.status.includes(resourceStatus.currentStatus) ? statusStyles.Error.icon : statusStyles.Pending.icon  } </> <Typography sx={{ml:1}}>{(statusStyles.Loading.status.includes(resourceStatus.currentStatus))? null :resourceStatus.currentStatus}</Typography>  </Typography>
// 										</Box>


// 									</Grid>	
// 						</Box>
// 					</Grid>
// 					<Grid item xs={9}>
// 						<Box
// 							bgcolor="white"
// 							minHeight="100%"
// 							display="flex"
// 							flexDirection="column"
// 							m={2}
// 							borderRadius="8px"
// 						>
// 							<Box display="flex" alignItems="center" justifyContent="space-between">
// 								<Typography fontFamily="Gilroy-SemiBold" fontSize="16px" px={2} py={3}>
// 									{`APPLICATIONS (${cluster.applications?.length || 0})`}
// 								</Typography>
// 								{cluster.applications && cluster.applications?.length > 0 && (
// 									<Button
// 										sx={{
// 											backgroundColor: "black",
// 											color: "white",
// 											fontWeight: "bold",
// 											"&:hover": {
// 												backgroundColor: "white",
// 												color: "black",
// 												borderColor: "black",
// 											},
// 											textTransform: "none",
// 											px: 2,
// 											py: 0.5,
// 											mr: 2,
// 										}}
// 										disabled={!user.roles?.some((e: string) => ["application_owner"].includes(e))}
// 										variant="contained"
// 										size="large"
// 										onClick={() => navigate("/applications/add")}
// 									>
// 										Add New Application
// 									</Button>
// 								)}
// 							</Box>
// 							<Divider />
// 							<Box sx={{maxHeight:'80vh', overflow:'auto'}}>
// 							{cluster.status == "active" &&
// 							(!cluster.applications || cluster.applications?.length == 0) ? (
// 								<Box
// 									sx={{
// 										position: "relative",
// 										top: "50%",
// 										left: "50%",
// 										transform: "translate(-50%, -10%)",
// 										width: "700px",
// 									}}
// 									display="flex"
// 									flexDirection="column"
// 									flex={1}
// 									alignItems="center"
// 									justifyContent="center"
// 								>
// 									<img src="/assets/inbox-icon.svg" alt="empty" />
// 									<Typography
// 										gutterBottom
// 										fontFamily="Gilroy-Bold"
// 										fontSize="16px"
// 										px={2}
// 										textAlign="center"
// 									>
// 										No applications are added yet
// 									</Typography>
// 									<Typography
// 										fontFamily="Gilroy-Regular"
// 										fontSize="14px"
// 										px={2}
// 										mb={2}
// 										textAlign="center"
// 									>
// 										Click below button to start adding applications or ask the application owner to
// 										add.
// 									</Typography>
// 									<Button
// 										sx={{
// 											backgroundColor: "black",
// 											color: "white",
// 											fontWeight: "bold",
// 											"&:hover": {
// 												backgroundColor: "white",
// 												color: "black",
// 												borderColor: "black",
// 											},
// 											textTransform: "none",
// 											px: 4,
// 										}}
// 										variant="contained"
// 										size="large"
// 										disabled={!user.roles?.some((e: string) => ["application_owner"].includes(e))}
// 										onClick={() => navigate("/applications/add")}
// 									>
// 										Add New Application
// 									</Button>
// 								</Box>
// 							) : cluster.status == "active" &&
// 							  cluster.applications &&
// 							  cluster.applications?.length > 0 ? (
// 								<Box
// 									display="flex"
// 									flexDirection="column"
// 									flex={1}
// 									sx={{ p: 2, bgcolor: "#FFFFFF" }}
// 								>
// 									{cluster.applications.map((application: any, index: number) => {
// 										return (
// 											<Accordion
// 												elevation={0}
// 												sx={{
// 													borderRadius: "8px",
// 													mb: "16px",
// 													"&:before": {
// 														display: "none",
// 													},
// 													bgcolor: "white",
// 													outline: "1px solid #eee",
// 												}}
// 											>
// 												<AccordionSummary expandIcon={null}>
// 													<Box
// 														sx={{
// 															display: "flex",
// 															alignItems: "center",
// 															justifyContent: "flex-start",
// 														}}
// 													>
// 														<Box p={1} bgcolor="#F2F2F2" borderRadius={1} mr={2}>
// 															<ExpandMore />
// 														</Box>
// 														<Box>
// 															<Typography fontSize="14px" fontFamily="Gilroy-SemiBold">
// 																{application.applicationName}
// 															</Typography>
// 															<Typography fontSize="12px" fontFamily="Gilroy-Regular">
// 																{moment(
// 																	new Date(Number(application.createdAt)).toISOString()
// 																).format("DD/MM/YYYY | hh:mm A")}
// 															</Typography>
// 														</Box>
// 													</Box>
// 												</AccordionSummary>
// 												<AccordionDetails>
// 													<Divider />
// 													<Grid container mt={2}>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Cluster Name
// 															</Typography>
// 															<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 																{cluster.clusterName}
// 															</Typography>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Environment
// 															</Typography>
// 															<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 																{application.environment}
// 															</Typography>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Application Owner
// 															</Typography>
// 															<Box display="flex" alignItems="center" justifyContent="flex-start">
// 																<Avatar
// 																	sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 																	src={application.applicationOwner?.googleProfilePicture}
// 																/>
// 																<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
// 																	{application.applicationOwner?.name}
// 																</Typography>
// 															</Box>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Application Viewers
// 															</Typography>
// 															<Box display="flex" alignItems="center" justifyContent="flex-start">
// 																{application.gcpApplicationViewers?.map((e: string) => {
// 																	return (
// 																		<Tooltip title={e}>
// 																			<Avatar
// 																				sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 																				src={e}
// 																				alt={e}
// 																			/>
// 																		</Tooltip>
// 																	);
// 																})}
// 															</Box>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Service Owners
// 															</Typography>
// 															<Box display="flex" alignItems="center" justifyContent="flex-start">
// 																{application.serviceRequesters?.map((e: string) => {
// 																	return (
// 																		<Tooltip title={e}>
// 																			<Avatar
// 																				sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 																				src={e}
// 																				alt={e}
// 																			/>
// 																		</Tooltip>
// 																	);
// 																})}
// 															</Box>
// 														</Grid>
// 														<Grid
// 															mb={2}
// 															item
// 															xs={application.costLabelPairs?.lenght > 1 ? 4.8 : 2.4}
// 														>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																Tags/Label
// 															</Typography>
// 															<Grid container ml={-0.5} gap={0.75}>
// 																{application.costLabelPairs?.map((e: any) => {
// 																	return (
// 																		<Grid item>
// 																			<Chip
// 																				size="small"
// 																				sx={{
// 																					bgcolor: "#10101010",
// 																					mr: 0.75,
// 																					fontFamily: "Gilroy-Regular",
// 																					fontSize: "12px",
// 																				}}
// 																				variant="filled"
// 																				label={`${e.cost} • ${e.label}`}
// 																			/>
// 																		</Grid>
// 																	);
// 																})}
// 															</Grid>
// 														</Grid>
// 														<Grid mb={2} item xs={2.4}>
// 															<Typography fontFamily="Gilroy-Regular" fontSize="12px">
// 																No. of Micro-Services
// 															</Typography>
// 															<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
// 																{`${application?.services?.length || 0}`}
																
// 															</Typography>
// 														</Grid>
// 													</Grid>
// 												</AccordionDetails>
// 											</Accordion>
// 										);
// 									})}
// 								</Box>
// 							) : (
// 								<Box
// 									sx={{
// 										position: "relative",
// 										top: "50%",
// 										left: "50%",
// 										transform: "translate(-50%, -10%)",
// 										width: "700px",
// 									}}
// 									display="flex"
// 									flexDirection="column"
// 									flex={1}
// 									alignItems="center"
// 									justifyContent="center"
// 								>
// 									<img src="/assets/inbox-reject-icon.svg" alt="empty" />
// 									<Typography
// 										gutterBottom
// 										fontFamily="Gilroy-Bold"
// 										fontSize="16px"
// 										px={2}
// 										textAlign="center"
// 									>
// 										Application addition is not allowed
// 									</Typography>
// 									<Paper
// 										elevation={0}
// 										sx={{
// 											bgcolor: "#FDB02215",
// 											border: "1px solid #FDB022",
// 											display: "flex",
// 											alignItems: "center",
// 											p: 1,
// 										}}
// 									>
// 										<img src="/assets/info-circle.svg" />
// 										<Typography fontFamily="Gilroy-Regular" fontSize="14px" ml={1}>
// 											{cluster.status == "rejected"
// 												? "Cluster is rejected by the approver, and addition of application is no longer applicable."
// 												: "Cluster is still pending approval, once the cluster is approved you can start adding applications."}
// 										</Typography>
// 									</Paper>
// 								</Box>
// 							)}
// 							</Box>
// 						</Box>
// 					</Grid>
// 				</Grid>
// 			)}
// 		</Container>
// 	);
// };

// export default ClusterDetailsPage;
